/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AdditionalDocumentFileConfigurationModel {
  additionalDocumentFiles?: AdditionalDocumentFileModel[] | null;
  /** @format int32 */
  fileUploadSizeLimitMb?: number;
}

export interface AdditionalDocumentFileModel {
  /** @format int32 */
  id?: number;
  fileName?: string | null;
  description?: string | null;
  canDelete?: boolean;
  signTabs?: AdditionalDocumentSignTabModel[] | null;
}

export interface AdditionalDocumentFileUpdateModel {
  /** @format int32 */
  id?: number;
  description?: string | null;
}

export interface AdditionalDocumentSignTabConfigurationModel {
  signTabs?: AdditionalDocumentSignTabModel[] | null;
  additionalDocumentFile?: AdditionalDocumentFileModel;
}

export interface AdditionalDocumentSignTabCreateUpdateModel {
  tabName?: string | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  xCoord?: number;
  /** @format int32 */
  yCoord?: number;
  /** @format int32 */
  dateSignedXCoord?: number | null;
  /** @format int32 */
  dateSignedYCoord?: number | null;
  includeDateSigned?: boolean;
}

export interface AdditionalDocumentSignTabModel {
  tabName?: string | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  xCoord?: number;
  /** @format int32 */
  yCoord?: number;
  /** @format int32 */
  dateSignedXCoord?: number | null;
  /** @format int32 */
  dateSignedYCoord?: number | null;
  includeDateSigned?: boolean;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  additionalDocumentFileId?: number;
  canDelete?: boolean;
}

export interface AnyReferenceCriteriaModel {
  value?: string | null;
  /**
   *
   * 0 = StartsWith
   * 1 = Equals
   * 2 = DoesNotEqual
   * 3 = LessThan
   * 4 = LessThanOrEqualTo
   * 5 = GreaterThan
   * 6 = GreaterThanOrEqualTo
   * 7 = EndsWith
   * 8 = Contains
   * 9 = DoesNotStartWith
   * 10 = DoesNotContain
   * 11 = DoesNotEndWith
   */
  comparisonType?: CriteriaComparisonType;
  includeFullText?: boolean;
}

export interface ApiKeyResponseModel {
  apiKey?: string | null;
}

export interface AppSettingsModel {
  sessionId?: string | null;
  baseUrl?: string | null;
  authServerAuthority?: string | null;
  /** @format int32 */
  idleTimeout?: number;
  /** @format int32 */
  maximumNumberOfPagesToCache?: number;
  postLogoutRedirectUri?: string | null;
  feedbackRecipientEmailAddress?: string | null;
  externalSignaturePadEnabled?: boolean;
  version?: string | null;
  versionDate?: string | null;
  arenaMessengerUrl?: string | null;
  arenaSignListenerKey?: string | null;
  /** @format int32 */
  presentExportOptionWhenConvertingDocumentAfterSeconds?: number;
  paginationOptions?: PaginationOptionsModel;
  docuSignDateSignedFont?: string | null;
  docuSignDateSignedFontSize?: string | null;
  getHelpRecipientEmailAddress?: string | null;
  reportIssueRecipientEmailAddress?: string | null;
  customerAccountCode?: string | null;
  customerName?: string | null;
  mStoreSystemName?: string | null;
  bypassLockingOnToolkit?: boolean;
  /** @format int32 */
  topModalRecords?: number;
  searchOptions?: SearchOptionsModel;
  backgroundExportOptions?: BackgroundExportOptionsModel;
  backgroundDeleteOptions?: BackgroundDeleteOptionsModel;
  backgroundPrintOptions?: BulkPrintOptionsModel;
}

export interface AppStartSettingsModel {
  sessionId?: string | null;
  baseUrl?: string | null;
  authServerAuthority?: string | null;
  /** @format int32 */
  idleTimeout?: number;
  /** @format int32 */
  maximumNumberOfPagesToCache?: number;
  postLogoutRedirectUri?: string | null;
}

/**
* 

0 = Copy

1 = Move
* @format int32
*/
export enum AppendType {
  Copy = 0,
  Move = 1
}

/**
* 

0 = DocuSign

1 = Scrive
* @format int32
*/
export enum ArenaSignApi {
  DocuSign = 0,
  Scrive = 1
}

/**
* 

0 = Standard

1 = SMS

2 = OnFido
* @format int32
*/
export enum ArenaSignAuthenticationTypes {
  Standard = 0,
  SMS = 1,
  OnFido = 2
}

export interface ArenaSignBaseResultModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  /** @format int32 */
  id?: number | null;
}

export interface ArenaSignDocumentTypeConfigurationModel {
  /** @format int32 */
  documentTypeId?: number | null;
  keyBusinessReferenceField?: string | null;
  documentTypes?: DocumentTypeModel[] | null;
  /** @format int32 */
  templateCount?: number;
}

/**
* 

1 = NewDocument

2 = NewVersion
* @format int32
*/
export enum ArenaSignIndexAction {
  NewDocument = 1,
  NewVersion = 2
}

export interface ArenaSignSignerRoleConfigurationModel {
  signerRole?: ArenaSignSignerRoleModel;
  signerRoleDataSources?: ArenaSignSignerRoleDataSourceModel[] | null;
  signerRoleLists?: ArenaSignSignerRoleListModel[] | null;
}

export interface ArenaSignSignerRoleDataFieldModel {
  dataSourceKey?: string | null;
  name?: string | null;
  description?: string | null;
}

export interface ArenaSignSignerRoleDataSourceModel {
  key?: string | null;
  description?: string | null;
  fields?: ArenaSignSignerRoleDataFieldModel[] | null;
}

export interface ArenaSignSignerRoleListModel {
  /** @format int32 */
  id?: number;
  description?: string | null;
}

export interface ArenaSignSignerRoleModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  documentTypeId?: number;
  description?: string | null;
  common?: boolean;
  enter?: boolean;
  useDataSourceForName?: boolean;
  nameDataSourceKey?: string | null;
  nameDataFieldKey?: string | null;
  useDataSourceForEmailAddress?: boolean;
  emailAddressDataSourceKey?: string | null;
  emailAddressDataFieldKey?: string | null;
  useListForNameAndEmailAddress?: boolean;
  /**
   *
   * 0 = Standard
   * 1 = SMS
   * 2 = OnFido
   */
  authenticationType?: ArenaSignAuthenticationTypes;
  useDataSourceForMobile?: boolean;
  mobileDataSourceKey?: string | null;
  mobileDataFieldKey?: string | null;
  /** @format int32 */
  listId?: number | null;
  canDelete?: boolean;
  mustBeSameRecipientWithinEnvelope?: boolean;
}

export interface ArenaSignTemplateCreateUpdateModel {
  /**
   *
   * 0 = DocuSign
   * 1 = Scrive
   */
  arenaSignApi?: ArenaSignApi;
  /** @format int32 */
  documentTypeId?: number;
  template?: string | null;
}

export interface Assembly {
  definedTypes?: TypeInfo[] | null;
  exportedTypes?: Type[] | null;
  /** @deprecated */
  codeBase?: string | null;
  entryPoint?: MethodInfo;
  fullName?: string | null;
  imageRuntimeVersion?: string | null;
  isDynamic?: boolean;
  location?: string | null;
  reflectionOnly?: boolean;
  isCollectible?: boolean;
  isFullyTrusted?: boolean;
  customAttributes?: CustomAttributeData[] | null;
  /** @deprecated */
  escapedCodeBase?: string | null;
  manifestModule?: Module;
  modules?: Module[] | null;
  /** @deprecated */
  globalAssemblyCache?: boolean;
  /** @format int64 */
  hostContext?: number;
  /**
   *
   * 0 = None
   * 1 = Level1
   * 2 = Level2
   */
  securityRuleSet?: SecurityRuleSet;
}

export interface AuthClientConfigurationModel {
  /** @format int32 */
  id?: number;
  provider?: string | null;
  clientId?: string | null;
  clientSecret?: string | null;
  redirectUri?: string | null;
  isEnabled?: boolean;
  hasClientSecret?: boolean;
  tenant?: string | null;
  singleSignOnButtonLabel?: string | null;
}

export interface AuthClientModel {
  /** @format int32 */
  id?: number;
  provider?: string | null;
  isEnabled?: boolean;
}

export interface AutoSaveConfigurationModel {
  enabled?: boolean;
  scope?: string | null;
}

/**
* 

17100 = CancelledDeal

17101 = ForwardOrderOrFreeReleaseNumber
* @format int32
*/
export enum AutomotiveEntityId {
  CancelledDeal = 17100,
  ForwardOrderOrFreeReleaseNumber = 17101
}

export interface AutomotiveWorkflowJobModel {
  /** @format int32 */
  jobId?: number;
  /** @format int32 */
  queueId?: number;
  jobTabsToHide?: WorkflowJobTabsToHideModel[] | null;
  tabKeysHiddenBySaleType?: string[] | null;
  jobInForwardOrderFreeReleaseQueue?: boolean;
}

export interface BackgroundDeleteOptionsModel {
  /** @format int32 */
  backgroundDeletePageThreshold?: number;
}

export interface BackgroundDeleteRequestDataModel {
  documents?: BackgroundRequestDocumentModel[] | null;
}

export interface BackgroundDeleteResultModel {
  /** @format int32 */
  id?: number;
  documentsNotDeleted?: BackgroundDocumentFailureModel[] | null;
  endUserMessage?: string | null;
  allDocumentsDeleted?: boolean;
  zeroDocumentsDeleted?: boolean;
  /** @format int32 */
  documentsToDeleteCount?: number;
}

export interface BackgroundDocumentFailureModel {
  cabinetId?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  /** @format int32 */
  documentId?: number;
  failureMessage?: string | null;
}

export interface BackgroundExportNotificationLinkModel {
  componentName?: string | null;
  success?: boolean;
  notification?: string | null;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  fileCount?: number;
  zipFilename?: string | null;
}

export interface BackgroundExportOptionsModel {
  /** @format int32 */
  backgroundExportPageThreshold?: number;
  /** @format int32 */
  exportZipFileSizeLimitMb?: number;
  /** @format int32 */
  exportFreeSpaceMb?: number;
}

export interface BackgroundExportRequestDataModel {
  documents?: BackgroundRequestDocumentModel[] | null;
  includeRelatedDocuments?: boolean;
}

export interface BackgroundPrintRequestDataModel {
  documents?: BackgroundRequestDocumentModel[] | null;
}

export interface BackgroundRequestDocumentModel {
  cabinetId?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  /** @format int32 */
  documentId?: number;
  /** @format int32 */
  mainDocumentId?: number | null;
}

export interface BaseColumnsModel {
  key?: string | null;
  label?: string | null;
  sortable?: boolean;
  formatter?: string | null;
  class?: string | null;
  tdClass?: string | null;
  sortByFormatted?: boolean;
  filterByFormatted?: boolean;
}

export interface BaseDescriptionModel {
  /** @format int32 */
  id?: number;
  description?: string | null;
}

export interface BaseDocumentSearchModel {
  cabinetId?: string | null;
  /** @format int32 */
  documentId?: number;
  /** @format int32 */
  documentTypeId?: number;
  hasDocumentTypeId?: boolean;
}

export interface BaseModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
}

export interface BaseTaskServiceSettingsModel {
  /** @format int32 */
  retryAttempts?: number;
  retryWaits?: number[] | null;
  overrideGlobalSettings?: boolean;
  notificationsEnabled?: boolean;
  notificationEmail?: string | null;
  hasEnqueuedJobLimit?: boolean;
  /** @format int32 */
  enqueuedJobLimit?: number;
}

export interface BuiltInListAdditionalConfigurationModel {
  editListItemSettings?: EditListItemSettingsModel[] | null;
}

export interface BuiltInListConfigurationModel {
  /** @format int32 */
  id?: number;
  description?: string | null;
  canAccess?: boolean;
  canConfigure?: boolean;
  primaryKey?: string | null;
  columns?: ColumnsModel[] | null;
  listItems?: BuiltInListItemModel[] | null;
  builtInListAdditionalConfiguration?: BuiltInListAdditionalConfigurationModel;
  componentName?: string | null;
}

export interface BuiltInListItemModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  listId?: number;
  field1?: string | null;
  field2?: string | null;
  field3?: string | null;
  field4?: string | null;
  field5?: string | null;
  field6?: string | null;
  field7?: string | null;
  field8?: string | null;
  field9?: string | null;
  field10?: string | null;
}

export interface BuiltInListUpdateResultModel {
  /** @format int32 */
  id?: number;
  description?: string | null;
  canAccess?: boolean;
  canConfigure?: boolean;
  primaryKey?: string | null;
  columns?: ColumnsModel[] | null;
  listItems?: BuiltInListItemModel[] | null;
  builtInListAdditionalConfiguration?: BuiltInListAdditionalConfigurationModel;
  componentName?: string | null;
  /** @format int32 */
  newBuiltListItemId?: number | null;
}

export interface BulkPrintOptionsModel {
  /** @format int32 */
  realtimePrintPageThreshold?: number | null;
  /** @format int32 */
  backgroundPrintPageThreshold?: number | null;
}

export interface BulkPrintRequestModel {
  documents?: BackgroundRequestDocumentModel[] | null;
  includeRelatedDocuments?: boolean;
  isBackground?: boolean;
}

/**
* 

0 = Realtime

1 = Background

2 = UnableToPrint
* @format int32
*/
export enum BulkPrintRequestStatus {
  Realtime = 0,
  Background = 1,
  UnableToPrint = 2
}

export interface BulkPrintResultModel {
  documentsNotPrinted?: BackgroundDocumentFailureModel[] | null;
  documentBase64?: string | null;
  /**
   *
   * 0 = Realtime
   * 1 = Background
   * 2 = UnableToPrint
   */
  status?: BulkPrintRequestStatus;
  message?: string | null;
  allDocumentsExported?: boolean;
  documentsToPrint?: BackgroundRequestDocumentModel[] | null;
}

export interface CabinetConfigurationModel {
  /** @format int32 */
  configurationChangeId?: number | null;
  id?: string | null;
  description?: string | null;
  documentLocation?: string | null;
  cabinetStoreConfiguration?: CabinetStoreConfigurationModel;
  commonSearchReferencesConfiguration?: SearchReferenceConfigurationModel[] | null;
  defaultCommonStoreReferencesConfiguration?: StoreReferenceConfigurationModel[] | null;
  documentTypes?: DocumentTypeConfigurationModel[] | null;
  cabinetReferences?: CabinetReferenceConfigurationModel[] | null;
  documentLinks?: DocumentLinkConfigurationModel[] | null;
  isEncryptNewDocumentTypesEnabled?: boolean;
  isMultiValueReferencesFeatureEnabled?: boolean;
}

export interface CabinetConfigurationSettingModel {
  settingName?: string | null;
  description?: string | null;
  explanation?: string | null;
  /**
   *
   * 0 = Boolean
   * 1 = Value
   * 2 = Option
   */
  valueType?: CabinetConfigurationValueType;
  settingValues?: CabinetConfigurationSettingValueModel[] | null;
}

export interface CabinetConfigurationSettingValueModel {
  value?: any;
  description?: string | null;
  explanation?: string | null;
}

export interface CabinetConfigurationSettingsModel {
  listConfigurations?: ListConfigurationModel[] | null;
  referenceSearchingConfigurationOptions?: CabinetConfigurationSettingModel[] | null;
  referenceStoringConfigurationOptions?: CabinetConfigurationSettingModel[] | null;
  documentDateStoringConfigurationOptions?: CabinetConfigurationSettingModel[] | null;
  documentTypeStoringConfigurationOptions?: CabinetConfigurationSettingModel[] | null;
  isEncryptNewDocumentTypesEnabled?: boolean;
  isMultiValueReferencesFeatureEnabled?: boolean;
}

/**
* 

0 = Boolean

1 = Value

2 = Option
* @format int32
*/
export enum CabinetConfigurationValueType {
  Boolean = 0,
  Value = 1,
  Option = 2
}

export interface CabinetCriteriaModel {
  id?: string | null;
  documentTypes?: number[] | null;
  hasDocumentTypeSelections?: boolean;
  hasMultipleDocumentTypeSelections?: boolean;
}

export interface CabinetDocumentTypesModel {
  id?: string | null;
  description?: string | null;
  documentTypes?: BaseDescriptionModel[] | null;
}

export interface CabinetModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  id?: string | null;
  description?: string | null;
  documentLocation?: string | null;
  tableName?: string | null;
  references?: CabinetReferenceModel[] | null;
  documentTypes?: DocumentTypeModel[] | null;
  documentLinks?: DocumentLinkModel[] | null;
  isEncryptNewDocumentTypesEnabled?: boolean;
}

export interface CabinetReferenceConfigurationModel {
  /** @format int32 */
  id?: number | null;
  isNew?: boolean;
  /** @format int32 */
  documentTypeId?: number | null;
  isDeleted?: boolean;
  canDelete?: boolean;
  deletionDisabledReason?: string | null;
  description?: string | null;
  /**
   *
   * 1 = Common
   * 2 = Document
   */
  referenceType?: CabinetReferenceType;
  /** @format int32 */
  fieldNumber?: number;
  /** @format int32 */
  referenceNumber?: number;
  /** @format int32 */
  maximumLength?: number;
  /** @format int32 */
  displayOrder?: number;
  isMultiValue?: boolean;
}

export interface CabinetReferenceModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  /**
   *
   * 1 = Common
   * 2 = Document
   */
  type?: CabinetReferenceType;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  fieldNumber?: number;
  referenceDescription?: string | null;
  /** @format int32 */
  referenceNumber?: number;
  fieldName?: string | null;
  multiValueFieldName?: string | null;
  cabinetId?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  fieldKey?: string | null;
  /**
   *
   * 1 = AnyValue
   * 2 = Numeric
   * 3 = Alphanumeric
   * 4 = Date
   */
  referenceValidationType?: ReferenceValidationType;
  documentTypes?: DocumentTypeModel[] | null;
  /** @format int32 */
  maximumLength?: number;
  deleted?: boolean;
  canDelete?: boolean;
  deletionDisabledReason?: string | null;
  /** @format int32 */
  displayOrder?: number;
  isMultiValue?: boolean;
  relatedDocumentReferenceKey?: string | null;
}

/**
* 

1 = Common

2 = Document
* @format int32
*/
export enum CabinetReferenceType {
  Common = 1,
  Document = 2
}

export interface CabinetStoreConfigurationModel {
  retainCommonReferences?: boolean;
  retainDocumentReferences?: boolean;
}

export interface CabinetToReviewCountModel {
  /** @format int32 */
  totalToReview?: number;
  cabinetDescription?: string | null;
  documentTypesToReviewCounts?: Record<string, DocumentTypeToReviewCountModel>;
}

export interface Calendar {
  /** @format date-time */
  minSupportedDateTime?: string;
  /** @format date-time */
  maxSupportedDateTime?: string;
  /**
   *
   * 0 = Unknown
   * 1 = SolarCalendar
   * 2 = LunarCalendar
   * 3 = LunisolarCalendar
   */
  algorithmType?: CalendarAlgorithmType;
  isReadOnly?: boolean;
  eras?: number[] | null;
  /** @format int32 */
  twoDigitYearMax?: number;
}

/**
* 

0 = Unknown

1 = SolarCalendar

2 = LunarCalendar

3 = LunisolarCalendar
* @format int32
*/
export enum CalendarAlgorithmType {
  Unknown = 0,
  SolarCalendar = 1,
  LunarCalendar = 2,
  LunisolarCalendar = 3
}

/**
* 

0 = FirstDay

1 = FirstFullWeek

2 = FirstFourDayWeek
* @format int32
*/
export enum CalendarWeekRule {
  FirstDay = 0,
  FirstFullWeek = 1,
  FirstFourDayWeek = 2
}

/**
* 

1 = Standard

2 = VarArgs

3 = Any

32 = HasThis

64 = ExplicitThis
* @format int32
*/
export enum CallingConventions {
  Standard = 1,
  VarArgs = 2,
  Any = 3,
  HasThis = 32,
  ExplicitThis = 64
}

export interface CancelDealModel {
  workflowDataSources?: WorkflowDataSourceModel[] | null;
}

export interface ColumnsModel {
  key?: string | null;
  label?: string | null;
  sortable?: boolean;
  formatter?: string | null;
  class?: string | null;
  tdClass?: string | null;
  sortByFormatted?: boolean;
  filterByFormatted?: boolean;
}

export interface CompareInfo {
  name?: string | null;
  version?: SortVersion;
  /** @format int32 */
  lcid?: number;
}

export interface ComponentVersionModel {
  componentName?: string | null;
  versionNumber?: string | null;
  versionDate?: string | null;
}

export interface ConfigurationAuthorizationModel {
  canConfigureSecurity?: boolean;
  canConfigureHr?: boolean;
  canMaintainAllUsers?: boolean;
  canMaintainAllRoles?: boolean;
  canMaintainMyRoles?: boolean;
  canMaintainUserClientMaintenance?: boolean;
  canConfigureMStoreClassic?: boolean;
  canConfigureLeaversTool?: boolean;
  canConfigureDocuSign?: boolean;
  canConfigureScrive?: boolean;
  canMaintainLists?: boolean;
  canConfigureXPorter?: boolean;
  canConfigureSingleSignOn?: boolean;
}

export interface ConfigurationChangeModel {
  /** @format int32 */
  id?: number | null;
  configurationArea?: string | null;
  /** @format date-time */
  beginDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  description?: string | null;
  user?: UserModel;
  lock?: LockModel;
  bypassLockingOnToolkit?: boolean;
  isNew?: boolean;
}

export interface ConfigurationTreeNodeDataModel {
  icon?: string | null;
  routeName?: string | null;
  treeNodePath?: string | null;
  routeParameters?: Record<string, any>;
}

export interface ConfigurationTreeNodeModel {
  text?: string | null;
  state?: ConfigurationTreeNodeStateModel;
  data?: ConfigurationTreeNodeDataModel;
  children?: ConfigurationTreeNodeModel[] | null;
}

export interface ConfigurationTreeNodeStateModel {
  visible?: boolean;
  selectable?: boolean;
}

export interface ConstructorInfo {
  name?: string | null;
  declaringType?: Type;
  reflectedType?: Type;
  module?: Module;
  customAttributes?: CustomAttributeData[] | null;
  isCollectible?: boolean;
  /** @format int32 */
  metadataToken?: number;
  /**
   *
   * 0 = ReuseSlot
   * 1 = Private
   * 2 = FamANDAssem
   * 3 = Assembly
   * 4 = Family
   * 5 = FamORAssem
   * 6 = Public
   * 7 = MemberAccessMask
   * 8 = UnmanagedExport
   * 16 = Static
   * 32 = Final
   * 64 = Virtual
   * 128 = HideBySig
   * 256 = VtableLayoutMask
   * 512 = CheckAccessOnOverride
   * 1024 = Abstract
   * 2048 = SpecialName
   * 4096 = RTSpecialName
   * 8192 = PinvokeImpl
   * 16384 = HasSecurity
   * 32768 = RequireSecObject
   * 53248 = ReservedMask
   */
  attributes?: MethodAttributes;
  /**
   *
   * 0 = Managed
   * 1 = Native
   * 2 = OPTIL
   * 3 = Runtime
   * 4 = Unmanaged
   * 8 = NoInlining
   * 16 = ForwardRef
   * 32 = Synchronized
   * 64 = NoOptimization
   * 128 = PreserveSig
   * 256 = AggressiveInlining
   * 512 = AggressiveOptimization
   * 4096 = InternalCall
   * 65535 = MaxMethodImplVal
   */
  methodImplementationFlags?: MethodImplAttributes;
  /**
   *
   * 1 = Standard
   * 2 = VarArgs
   * 3 = Any
   * 32 = HasThis
   * 64 = ExplicitThis
   */
  callingConvention?: CallingConventions;
  isAbstract?: boolean;
  isConstructor?: boolean;
  isFinal?: boolean;
  isHideBySig?: boolean;
  isSpecialName?: boolean;
  isStatic?: boolean;
  isVirtual?: boolean;
  isAssembly?: boolean;
  isFamily?: boolean;
  isFamilyAndAssembly?: boolean;
  isFamilyOrAssembly?: boolean;
  isPrivate?: boolean;
  isPublic?: boolean;
  isConstructedGenericMethod?: boolean;
  isGenericMethod?: boolean;
  isGenericMethodDefinition?: boolean;
  containsGenericParameters?: boolean;
  methodHandle?: RuntimeMethodHandle;
  isSecurityCritical?: boolean;
  isSecuritySafeCritical?: boolean;
  isSecurityTransparent?: boolean;
  /**
   *
   * 1 = Constructor
   * 2 = Event
   * 4 = Field
   * 8 = Method
   * 16 = Property
   * 32 = TypeInfo
   * 64 = Custom
   * 128 = NestedType
   * 191 = All
   */
  memberType?: MemberTypes;
}

export interface ContainerColumnModel {
  fieldRows?: FieldRowModel[] | null;
}

export interface ContainerRowModel {
  containerColumns?: ContainerColumnModel[] | null;
}

export interface CopyCabinetReferencesModel {
  id?: string | null;
  description?: string | null;
  /** @format int32 */
  referenceCount?: number;
}

export interface CopyReferenceModel {
  /** @format int32 */
  referenceId?: number;
  /**
   *
   * 1 = Common
   * 2 = Document
   */
  referenceType?: CabinetReferenceType;
  referenceName?: string | null;
  cabinetName?: string | null;
  documentTypeName?: string | null;
}

export interface CreateExceptionalJobConfigurationModel {
  cabinetId?: string | null;
  documentTypeIds?: number[] | null;
  /**
   *
   * 1 = CreateNewVersion
   */
  versionType?: ExceptionalJobVersionType;
  enabled?: boolean;
}

export interface CreateSavedSearchModel {
  name?: string | null;
  /** @format int32 */
  roleId?: number | null;
  searchCriteria?: string | null;
}

/**
* 

0 = StartsWith

1 = Equals

2 = DoesNotEqual

3 = LessThan

4 = LessThanOrEqualTo

5 = GreaterThan

6 = GreaterThanOrEqualTo

7 = EndsWith

8 = Contains

9 = DoesNotStartWith

10 = DoesNotContain

11 = DoesNotEndWith
* @format int32
*/
export enum CriteriaComparisonType {
  StartsWith = 0,
  Equals = 1,
  DoesNotEqual = 2,
  LessThan = 3,
  LessThanOrEqualTo = 4,
  GreaterThan = 5,
  GreaterThanOrEqualTo = 6,
  EndsWith = 7,
  Contains = 8,
  DoesNotStartWith = 9,
  DoesNotContain = 10,
  DoesNotEndWith = 11
}

export interface CriteriaModel {
  field?: string | null;
  value?: any;
  /**
   *
   * 0 = StartsWith
   * 1 = Equals
   * 2 = DoesNotEqual
   * 3 = LessThan
   * 4 = LessThanOrEqualTo
   * 5 = GreaterThan
   * 6 = GreaterThanOrEqualTo
   * 7 = EndsWith
   * 8 = Contains
   * 9 = DoesNotStartWith
   * 10 = DoesNotContain
   * 11 = DoesNotEndWith
   */
  comparisonType?: CriteriaComparisonType;
}

export interface CultureInfo {
  parent?: CultureInfo;
  /** @format int32 */
  lcid?: number;
  /** @format int32 */
  keyboardLayoutId?: number;
  name?: string | null;
  ietfLanguageTag?: string | null;
  displayName?: string | null;
  nativeName?: string | null;
  englishName?: string | null;
  twoLetterISOLanguageName?: string | null;
  threeLetterISOLanguageName?: string | null;
  threeLetterWindowsLanguageName?: string | null;
  compareInfo?: CompareInfo;
  textInfo?: TextInfo;
  isNeutralCulture?: boolean;
  /**
   *
   * 1 = NeutralCultures
   * 2 = SpecificCultures
   * 4 = InstalledWin32Cultures
   * 7 = AllCultures
   * 8 = UserCustomCulture
   * 16 = ReplacementCultures
   * 32 = WindowsOnlyCultures
   * 64 = FrameworkCultures
   */
  cultureTypes?: CultureTypes;
  numberFormat?: NumberFormatInfo;
  dateTimeFormat?: DateTimeFormatInfo;
  calendar?: Calendar;
  optionalCalendars?: Calendar[] | null;
  useUserOverride?: boolean;
  isReadOnly?: boolean;
}

/**
* 

1 = NeutralCultures

2 = SpecificCultures

4 = InstalledWin32Cultures

7 = AllCultures

8 = UserCustomCulture

16 = ReplacementCultures

32 = WindowsOnlyCultures

64 = FrameworkCultures
* @format int32
*/
export enum CultureTypes {
  NeutralCultures = 1,
  SpecificCultures = 2,
  InstalledWin32Cultures = 4,
  AllCultures = 7,
  UserCustomCulture = 8,
  ReplacementCultures = 16,
  WindowsOnlyCultures = 32,
  FrameworkCultures = 64
}

export interface CustomAttributeData {
  attributeType?: Type;
  constructor?: ConstructorInfo;
  constructorArguments?: CustomAttributeTypedArgument[] | null;
  namedArguments?: CustomAttributeNamedArgument[] | null;
}

export interface CustomAttributeNamedArgument {
  memberInfo?: MemberInfo;
  typedValue?: CustomAttributeTypedArgument;
  memberName?: string | null;
  isField?: boolean;
}

export interface CustomAttributeTypedArgument {
  argumentType?: Type;
  value?: any;
}

export interface CustomIndexingLookupModel {
  icon?: string | null;
  titleText?: string | null;
  description?: string | null;
  componentName?: string | null;
}

export interface DataColumn {
  site?: ISite;
  container?: IContainer;
  designMode?: boolean;
  allowDBNull?: boolean;
  autoIncrement?: boolean;
  /** @format int64 */
  autoIncrementSeed?: number;
  /** @format int64 */
  autoIncrementStep?: number;
  caption?: string | null;
  columnName?: string | null;
  prefix?: string | null;
  dataType?: Type;
  /**
   *
   * 1 = Local
   * 2 = Unspecified
   * 3 = UnspecifiedLocal
   * 4 = Utc
   */
  dateTimeMode?: DataSetDateTime;
  defaultValue?: any;
  expression?: string | null;
  extendedProperties?: Record<string, any>;
  /** @format int32 */
  maxLength?: number;
  namespace?: string | null;
  /** @format int32 */
  ordinal?: number;
  readOnly?: boolean;
  table?: DataTable;
  unique?: boolean;
  /**
   *
   * 1 = Element
   * 2 = Attribute
   * 3 = SimpleContent
   * 4 = Hidden
   */
  columnMapping?: MappingType;
}

export interface DataSet {
  container?: IContainer;
  designMode?: boolean;
  /**
   *
   * 0 = Xml
   * 1 = Binary
   */
  remotingFormat?: SerializationFormat;
  /**
   *
   * 1 = IncludeSchema
   * 2 = ExcludeSchema
   */
  schemaSerializationMode?: SchemaSerializationMode;
  caseSensitive?: boolean;
  defaultViewManager?: any[] | null;
  enforceConstraints?: boolean;
  dataSetName?: string | null;
  namespace?: string | null;
  prefix?: string | null;
  extendedProperties?: Record<string, any>;
  hasErrors?: boolean;
  isInitialized?: boolean;
  locale?: CultureInfo;
  site?: ISite;
  relations?: any[] | null;
  tables?: any[] | null;
}

/**
* 

1 = Local

2 = Unspecified

3 = UnspecifiedLocal

4 = Utc
* @format int32
*/
export enum DataSetDateTime {
  Local = 1,
  Unspecified = 2,
  UnspecifiedLocal = 3,
  Utc = 4
}

export interface DataTable {
  container?: IContainer;
  designMode?: boolean;
  caseSensitive?: boolean;
  isInitialized?: boolean;
  /**
   *
   * 0 = Xml
   * 1 = Binary
   */
  remotingFormat?: SerializationFormat;
  childRelations?: any[] | null;
  columns?: any[] | null;
  constraints?: any[] | null;
  dataSet?: DataSet;
  defaultView?: any[] | null;
  displayExpression?: string | null;
  extendedProperties?: Record<string, any>;
  hasErrors?: boolean;
  locale?: CultureInfo;
  /** @format int32 */
  minimumCapacity?: number;
  parentRelations?: any[] | null;
  primaryKey?: DataColumn[] | null;
  rows?: any[] | null;
  tableName?: string | null;
  namespace?: string | null;
  prefix?: string | null;
  site?: ISite;
}

export interface DataTableColumnsModel {
  key?: string | null;
  label?: string | null;
  sortable?: boolean;
  formatter?: string | null;
  class?: string | null;
  tdClass?: string | null;
  sortByFormatted?: boolean;
  filterByFormatted?: boolean;
}

/**
* 

0 = All

1 = Range

2 = LastMonth

3 = LastThreeMonths

4 = LastYear
* @format int32
*/
export enum DateRangeType {
  All = 0,
  Range = 1,
  LastMonth = 2,
  LastThreeMonths = 3,
  LastYear = 4
}

export interface DateTimeFormatInfo {
  amDesignator?: string | null;
  calendar?: Calendar;
  dateSeparator?: string | null;
  /**
   *
   * 0 = Sunday
   * 1 = Monday
   * 2 = Tuesday
   * 3 = Wednesday
   * 4 = Thursday
   * 5 = Friday
   * 6 = Saturday
   */
  firstDayOfWeek?: DayOfWeek;
  /**
   *
   * 0 = FirstDay
   * 1 = FirstFullWeek
   * 2 = FirstFourDayWeek
   */
  calendarWeekRule?: CalendarWeekRule;
  fullDateTimePattern?: string | null;
  longDatePattern?: string | null;
  longTimePattern?: string | null;
  monthDayPattern?: string | null;
  pmDesignator?: string | null;
  rfC1123Pattern?: string | null;
  shortDatePattern?: string | null;
  shortTimePattern?: string | null;
  sortableDateTimePattern?: string | null;
  timeSeparator?: string | null;
  universalSortableDateTimePattern?: string | null;
  yearMonthPattern?: string | null;
  abbreviatedDayNames?: string[] | null;
  shortestDayNames?: string[] | null;
  dayNames?: string[] | null;
  abbreviatedMonthNames?: string[] | null;
  monthNames?: string[] | null;
  isReadOnly?: boolean;
  nativeCalendarName?: string | null;
  abbreviatedMonthGenitiveNames?: string[] | null;
  monthGenitiveNames?: string[] | null;
}

/**
* 

0 = Sunday

1 = Monday

2 = Tuesday

3 = Wednesday

4 = Thursday

5 = Friday

6 = Saturday
* @format int32
*/
export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export interface DealCopyRequestModel {
  formerStockNumber?: string | null;
  currentStockNumber?: string | null;
}

export interface DealDocumentCopyHistoryModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  userId?: number;
  userName?: string | null;
  formerStockNumber?: string | null;
  currentStockNumber?: string | null;
  exceptionMessage?: string | null;
  /** @format date-time */
  lastUpdated?: string | null;
  /**
   *
   * 0 = NotProcessed
   * 1 = Pending
   * 2 = Success
   * 3 = Failed
   * 4 = NoDocumentsToCopy
   */
  status?: DealDocumentCopyRequestStatus;
  statusDescription?: string | null;
  /** @format date-time */
  requestDate?: string;
}

export interface DealDocumentCopyListConfigurationModel {
  /** @format int32 */
  formerStockNumbersListId?: number;
  /** @format int32 */
  currentStockNumbersListId?: number;
}

/**
* 

0 = NotProcessed

1 = Pending

2 = Success

3 = Failed

4 = NoDocumentsToCopy
* @format int32
*/
export enum DealDocumentCopyRequestStatus {
  NotProcessed = 0,
  Pending = 1,
  Success = 2,
  Failed = 3,
  NoDocumentsToCopy = 4
}

export interface DeleteConfigurationModel {
  /** @format int32 */
  configurationChangeId?: number | null;
  id?: string | null;
  continue?: boolean;
}

export interface DeleteConfigurationResponseModel {
  /**
   *
   * 0 = Deleted
   * 1 = Prevented
   * 2 = PreventedCanContinue
   */
  deleteResponseType?: DeleteResponseType;
  notification?: NotificationModel;
}

/**
* 

0 = Deleted

1 = Prevented

2 = PreventedCanContinue
* @format int32
*/
export enum DeleteResponseType {
  Deleted = 0,
  Prevented = 1,
  PreventedCanContinue = 2
}

/**
* 

0 = Context

1 = None

2 = NativeNational
* @format int32
*/
export enum DigitShapes {
  Context = 0,
  None = 1,
  NativeNational = 2
}

export interface DocuSignDocumentModel {
  documentId?: string | null;
  documentData?: string | null;
  name?: string | null;
  fileExtension?: string | null;
}

export interface DocuSignDocumentSignHereModel {
  tabName?: string | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  xCoord?: number;
  /** @format int32 */
  yCoord?: number;
  /** @format int32 */
  dateSignedXCoord?: number | null;
  /** @format int32 */
  dateSignedYCoord?: number | null;
  includeDateSigned?: boolean;
  /** @format int32 */
  signerRoleId?: number;
  name?: string | null;
  emailAddress?: string | null;
  /** @format int32 */
  arenaSignDocumentId?: number;
}

export interface DocuSignEnvelopeCreateModel {
  emailSubject?: string | null;
  documents?: DocuSignDocumentModel[] | null;
  recipients?: DocuSignDocumentSignHereModel[] | null;
  notification?: DocuSignNotificationModel;
  status?: string | null;
}

export interface DocuSignExpirationsModel {
  expireEnabled?: string | null;
  expireAfter?: string | null;
  expireWarn?: string | null;
}

export interface DocuSignGroupActionModel {
  jobIds?: number[] | null;
  /**
   *
   * 0 = ReturnToPrepare
   * 1 = Cancel
   * 2 = CreateEnvelope
   * 3 = VoidEnvelope
   */
  processingAction?: DocuSignStandardProcessingAction;
  voidReason?: string | null;
}

export interface DocuSignNotificationModel {
  userAccountDefaults?: string | null;
  reminders?: DocuSignRemindersModel;
  expirations?: DocuSignExpirationsModel;
}

export interface DocuSignRemindersModel {
  reminderEnabled?: string | null;
  reminderDelay?: string | null;
  reminderFrequency?: string | null;
}

/**
* 

0 = ReturnToPrepare

1 = Cancel

2 = CreateEnvelope

3 = VoidEnvelope
* @format int32
*/
export enum DocuSignStandardProcessingAction {
  ReturnToPrepare = 0,
  Cancel = 1,
  CreateEnvelope = 2,
  VoidEnvelope = 3
}

export interface DocuSignTemplateConfigurationModel {
  /** @format int32 */
  templateId?: number | null;
  keyBusinessReferenceField?: string | null;
  documentType?: DocumentTypeModel;
  template?: DocuSignTemplateModel;
}

export interface DocuSignTemplateModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  documentTypeId?: number;
  keyBusinessReferenceField?: string | null;
  template?: string | null;
  canDelete?: boolean;
  templateSignHeres?: TemplateSignHereModel[] | null;
  additionalDocuments?: TemplateAdditionalDocumentModel[] | null;
}

export interface DocuSignTemplatesConfigurationModel {
  /** @format int32 */
  documentTypeId?: number | null;
  keyBusinessReferenceField?: string | null;
  documentTypes?: DocumentTypeModel[] | null;
  templates?: DocuSignTemplateModel[] | null;
}

export interface DocuSignTestResponseModel {
  isError?: boolean;
  responseMessage?: string | null;
  userMessage?: string | null;
}

export interface DocumentActionModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  export?: boolean;
  delete?: boolean;
  email?: boolean;
  print?: boolean;
}

export interface DocumentBulkEmailDocumentModel {
  cabinetId?: string | null;
  /** @format int32 */
  documentId?: number;
}

export interface DocumentBulkEmailModel {
  to?: string | null;
  subject?: string | null;
  body?: string | null;
  documents?: DocumentBulkEmailDocumentModel[] | null;
  includeMe?: boolean;
}

export interface DocumentCreationResultModel {
  /** @format int32 */
  documentId?: number;
  pdfPermissionOnlyEncryptionRemoved?: boolean;
}

export interface DocumentDataModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  pages?: number;
  fileType?: DocumentFileTypeEnumModel;
  fileTypeSupportsPageSplitting?: boolean;
  fileExtension?: string | null;
  references?: DocumentReferenceModel[] | null;
  /** @format date-time */
  documentDate?: string;
  /** @format date-time */
  createdDate?: string;
  documentDateLabel?: string | null;
  multiValueReferences?: MultiValueReferenceModel[] | null;
  multiValueReferenceData?: DataTable;
  /** @format int32 */
  batchNumber?: number;
  fileName?: string | null;
  location?: string | null;
  retentionType?: RetentionTypeEnumModel;
  /** @format date-time */
  retentionDate?: string | null;
  cabinet?: CabinetModel;
  documentType?: DocumentTypeModel;
  versions?: DocumentVersionModel[] | null;
  currentUserCanView?: boolean;
  currentUserCanEdit?: boolean;
  deleted?: boolean;
  expired?: boolean;
  isCurrentVersion?: boolean;
  isMultiPageFile?: boolean;
  /** @format int32 */
  documentPageFileCount?: number;
}

export interface DocumentDateRangeModel {
  /**
   *
   * 0 = All
   * 1 = Range
   * 2 = LastMonth
   * 3 = LastThreeMonths
   * 4 = LastYear
   */
  rangeType?: DateRangeType;
  /** @format date */
  fromDate?: string | null;
  /** @format date */
  toDate?: string | null;
}

export interface DocumentEmailModel {
  to?: string | null;
  subject?: string | null;
  body?: string | null;
  /** @format int32 */
  documentId?: number;
  cabinetId?: string | null;
}

export interface DocumentEmailToMeModel {
  /** @format int32 */
  documentId?: number;
  cabinetId?: string | null;
  convertToPdf?: boolean;
}

export interface DocumentEncryptionConfigurationModel {
  isEncryptionPaused?: boolean;
  isEncryptionEnabledForNewCabinets?: boolean;
}

export type DocumentEncryptionStatusModel = object;

export interface DocumentExportModel {
  documentData?: DocumentDataModel;
  documentDataBase64?: string | null;
}

export interface DocumentExportOptionsModel {
  historyDescription?: string | null;
  acquireDocumentLock?: boolean;
}

/**
* 

0 = Tif

1 = Tiff

2 = Gp4

3 = Gif

4 = Jpg

5 = Bmp

6 = Dib

7 = Png

8 = Wmf

9 = Rtf

10 = Txt

11 = Ini

12 = Doc

13 = Dot

14 = Docx

15 = Docm

16 = Dotx

17 = Xls

18 = Xlsx

19 = Xlsb

20 = Xltx

21 = Ppt

22 = Pptx

23 = Pptm

24 = Potx

25 = Ppsx

26 = Vsd

27 = Mpp

28 = Mht

29 = Htm

30 = Html

31 = Pdf

32 = Xps

33 = Xml

34 = Msg

35 = Tmp

36 = Nsf

37 = Csv

38 = Unsupported
* @format int32
*/
export enum DocumentFileType {
  Tif = 0,
  Tiff = 1,
  Gp4 = 2,
  Gif = 3,
  Jpg = 4,
  Bmp = 5,
  Dib = 6,
  Png = 7,
  Wmf = 8,
  Rtf = 9,
  Txt = 10,
  Ini = 11,
  Doc = 12,
  Dot = 13,
  Docx = 14,
  Docm = 15,
  Dotx = 16,
  Xls = 17,
  Xlsx = 18,
  Xlsb = 19,
  Xltx = 20,
  Ppt = 21,
  Pptx = 22,
  Pptm = 23,
  Potx = 24,
  Ppsx = 25,
  Vsd = 26,
  Mpp = 27,
  Mht = 28,
  Htm = 29,
  Html = 30,
  Pdf = 31,
  Xps = 32,
  Xml = 33,
  Msg = 34,
  Tmp = 35,
  Nsf = 36,
  Csv = 37,
  Unsupported = 38
}

export interface DocumentFileTypeEnumModel {
  /**
   *
   * 0 = Tif
   * 1 = Tiff
   * 2 = Gp4
   * 3 = Gif
   * 4 = Jpg
   * 5 = Bmp
   * 6 = Dib
   * 7 = Png
   * 8 = Wmf
   * 9 = Rtf
   * 10 = Txt
   * 11 = Ini
   * 12 = Doc
   * 13 = Dot
   * 14 = Docx
   * 15 = Docm
   * 16 = Dotx
   * 17 = Xls
   * 18 = Xlsx
   * 19 = Xlsb
   * 20 = Xltx
   * 21 = Ppt
   * 22 = Pptx
   * 23 = Pptm
   * 24 = Potx
   * 25 = Ppsx
   * 26 = Vsd
   * 27 = Mpp
   * 28 = Mht
   * 29 = Htm
   * 30 = Html
   * 31 = Pdf
   * 32 = Xps
   * 33 = Xml
   * 34 = Msg
   * 35 = Tmp
   * 36 = Nsf
   * 37 = Csv
   * 38 = Unsupported
   */
  value?: DocumentFileType;
  name?: string | null;
}

export interface DocumentFullTextDataModel {
  fullTextData?: DocumentFullTextModel[] | null;
  fullTextColumns?: ColumnsModel[] | null;
  fullTextSearch?: boolean;
}

export interface DocumentFullTextModel {
  /** @format int32 */
  uniqueId?: number;
  /** @format int32 */
  page?: number;
  entity?: string | null;
  /**
   *
   * 0 = NotProcessed
   * 1 = Successful
   * 2 = Failed
   * 3 = PostProcessSuccessful
   * 4 = PostProcessFailed
   * 5 = MailroomSuccessful
   * 6 = MailroomFailed
   * 7 = BarcodeIndexingSuccessful
   * 8 = BarcodeIndexFailed
   * 9 = PdfCombinePending
   * 10 = PdfCombineFailed
   */
  status?: FullTextStatus;
  textStatus?: string | null;
  processNotes?: string | null;
}

export interface DocumentFullTextSearchModel {
  cabinetId?: string | null;
  /** @format int32 */
  documentId?: number;
  fullTextSearch?: string | null;
}

export interface DocumentInformationModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  documentFields?: Record<string, any>;
  referenceFields?: DocumentReferenceModel[] | null;
  multiValueReferenceData?: DataTable;
  multiValueReferenceColumns?: DataTableColumnsModel[] | null;
  multiValueRelationshipName?: string | null;
  hasMultiValueReferences?: boolean;
}

export interface DocumentLinkConfigurationModel {
  /** @format int32 */
  configurationChangeId?: number | null;
  /** @format int32 */
  id?: number | null;
  cabinetId?: string | null;
  /** @format int32 */
  sourceDocumentTypeId?: number;
  /** @format int32 */
  targetDocumentTypeId?: number;
  /** @format int32 */
  sourceReference1Id?: number | null;
  /** @format int32 */
  targetReference1Id?: number | null;
  /** @format int32 */
  sourceReference2Id?: number | null;
  /** @format int32 */
  targetReference2Id?: number | null;
  /** @format int32 */
  sourceReference3Id?: number | null;
  /** @format int32 */
  targetReference3Id?: number | null;
}

export interface DocumentLinkModel {
  /** @format int32 */
  id?: number;
  sourceDocumentType?: DocumentTypeModel;
  targetDocumentType?: DocumentTypeModel;
  sourceField1?: CabinetReferenceModel;
  sourceField2?: CabinetReferenceModel;
  sourceField3?: CabinetReferenceModel;
  targetField1?: CabinetReferenceModel;
  targetField2?: CabinetReferenceModel;
  targetField3?: CabinetReferenceModel;
}

export interface DocumentPagePreferencesModel {
  /** @format int32 */
  page?: number;
  sizing?: string | null;
  position?: string | null;
  rotation?: string | null;
}

export interface DocumentPdf {
  name?: string | null;
  pdfBytes?: string | null;
  documentId?: string | null;
  documentType?: string | null;
}

export interface DocumentPdfs {
  documentPdf?: DocumentPdf[] | null;
}

export interface DocumentPrintResponseModel {
  fileName?: string | null;
  base64Data?: string | null;
  contentType?: string | null;
}

export interface DocumentReferenceModel {
  value?: string | null;
  /**
   *
   * 1 = Common
   * 2 = Document
   */
  type?: CabinetReferenceType;
  /** @format int32 */
  referenceNumber?: number;
  /** @format int32 */
  displayOrder?: number;
  cabinetReferenceModel?: CabinetReferenceModel;
}

export interface DocumentReferencesModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  pages?: number;
  fileType?: DocumentFileTypeEnumModel;
  fileTypeSupportsPageSplitting?: boolean;
  fileExtension?: string | null;
  references?: DocumentReferenceModel[] | null;
  /** @format date-time */
  documentDate?: string;
  /** @format date-time */
  createdDate?: string;
  documentDateLabel?: string | null;
  multiValueReferences?: MultiValueReferenceModel[] | null;
  multiValueReferenceData?: DataTable;
  cabinetId?: string | null;
  /** @format int32 */
  documentTypeId?: number;
}

export interface DocumentReferencesResultModel {
  cabinets?: CabinetModel[] | null;
  documents?: DocumentReferencesModel[] | null;
}

export interface DocumentRetentionModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  /** @format int32 */
  documentId?: number | null;
  cabinetId?: string | null;
  /**
   *
   * 0 = None
   * 1 = AutomaticDeletion
   * 2 = ReviewForDeletion
   */
  retentionType?: RetentionType;
  /** @format date-time */
  retentionDate?: string | null;
  isToReview?: boolean;
}

/**
* 

0 = None

1 = AutomaticDeletion

2 = ReviewForDeletion

3 = Default
* @format int32
*/
export enum DocumentRetentionType {
  None = 0,
  AutomaticDeletion = 1,
  ReviewForDeletion = 2,
  Default = 3
}

export interface DocumentSearchModel {
  cabinetId?: string | null;
  /** @format int32 */
  documentId?: number;
  /** @format int32 */
  documentTypeId?: number;
  hasDocumentTypeId?: boolean;
  /** @format int32 */
  page?: number;
  /** @format int32 */
  viewConversionId?: number | null;
  documentPagePreferences?: DocumentPagePreferencesModel[] | null;
  autoSaveConfiguration?: AutoSaveConfigurationModel;
}

export interface DocumentTabModel {
  componentName?: string | null;
  key?: string | null;
  description?: string | null;
  lazyLoad?: boolean;
  hidden?: boolean;
}

export interface DocumentToStoreUpdateModel {
  targetCabinetId?: string | null;
  /** @format int32 */
  targetDocumentTypeId?: number;
  references?: Record<string, string | null>;
  multiValueReferences?: MultiValueReferenceModel[] | null;
  pages?: string | null;
  /** @format int32 */
  existingDocumentId?: number | null;
  /**
   *
   * 1 = AddToDocument
   * 2 = ReplaceDocument
   * 3 = CreateHistoricVersion
   */
  existingDocumentOption?: ExistingDocumentOption;
  /** @format date-time */
  documentDate?: string | null;
  keepPagesAfterStoring?: boolean | null;
  /** @format date-time */
  retentionDate?: string | null;
  /**
   *
   * 0 = None
   * 1 = AutomaticDeletion
   * 2 = ReviewForDeletion
   * 3 = Default
   */
  retentionType?: DocumentRetentionType;
  /**
   *
   * 0 = Default
   * 1 = DisableLegacyWorkflowFeed
   * 2 = DisableMAFWorkflowFeed
   * 4 = DisableSecureDelivery
   * 8 = DisableFeederTypeHandling
   * 16 = DisableReferenceValidation
   * 32 = DeleteFilesAfterwards
   * 64 = DisableTaskFeed
   * 128 = DisableAutoVersioning
   * 256 = IgnoreDocumentTypeIndexParametersUseDefaults
   * 512 = PreserveExistingMultiValueValues
   * 1024 = DontCheckIfFileIsSupported
   * 2048 = DisableReferenceLookup
   * 4096 = DisableFileMetaDataLinkingLookup
   * 8192 = DisableAllIndexReIndexProcesses
   * 16384 = DisablePreValidationIndexReIndexProcesses
   * 32768 = DisablePostValidationIndexReIndexProcesses
   * 65536 = DisablePostRecordLookupIndexReIndexProcesses
   * 131072 = DisablePostIndexReIndexProcesses
   * 1048576 = DisableReIndexCheckLock
   */
  indexOptions?: IndexOptions;
}

export interface DocumentToStoreViewModel {
  cabinets?: CabinetDocumentTypesModel[] | null;
  dynamicFormSchema?: MStoreDynamicFieldModel[] | null;
  multiValueDynamicFormSchema?: MStoreDynamicFieldModel[] | null;
  multiValueReferences?: DataTable;
  multiValueReferenceColumns?: DataTableColumnsModel[] | null;
  hasMultiValueReferences?: boolean;
  multiValueRelationshipName?: string | null;
  /** @format int32 */
  targetDocumentTypeId?: number;
  targetDocumentTypeSettings?: TargetDocumentTypeSettingsModel;
  customIndexingLookups?: CustomIndexingLookupModel[] | null;
}

export interface DocumentTypeConfigurationModel {
  /** @format int32 */
  id?: number | null;
  isNew?: boolean;
  isDeleted?: boolean;
  modified?: boolean;
  description?: string | null;
  storeConfiguration?: DocumentTypeStoreConfigurationModel;
  referencesConfiguration?: ReferenceConfigurationModel[] | null;
  /**
   *
   * 0 = Disabled
   * 1 = EnabledForNewDocuments
   * 2 = EnabledForNewAndExistingDocuments
   */
  encryptionEnabled?: DocumentTypeEncryptionEnabledType;
}

/**
* 

0 = Disabled

1 = EnabledForNewDocuments

2 = EnabledForNewAndExistingDocuments
* @format int32
*/
export enum DocumentTypeEncryptionEnabledType {
  Disabled = 0,
  EnabledForNewDocuments = 1,
  EnabledForNewAndExistingDocuments = 2
}

export interface DocumentTypeModel {
  /** @format int32 */
  id?: number;
  cabinetId?: string | null;
  description?: string | null;
  references?: CabinetReferenceModel[] | null;
  signatureReferenceField?: SignatureReferenceFieldModel;
  hasSignatureReference?: boolean;
  /** @format int32 */
  documentsCount?: number | null;
  /**
   *
   * 0 = Disabled
   * 1 = EnabledForNewDocuments
   * 2 = EnabledForNewAndExistingDocuments
   */
  encryptionEnabled?: DocumentTypeEncryptionEnabledType;
  canViewDocumentType?: boolean;
}

export interface DocumentTypeStoreConfigurationModel {
  /**
   *
   * 0 = CreateNew
   * 1 = AppendPages
   * 2 = ReplaceMatchingRecordBecomesVersion
   * 3 = CreateAsVersionOfMatchingRecord
   * 4 = Overwrite
   */
  matchExistingRecordAction?: MatchingRecordAction;
  clearReferencesAfterUpdate?: boolean;
  documentDateIsLookupField?: boolean;
  documentDateDescription?: string | null;
  multiValueRelationshipName?: string | null;
}

export interface DocumentTypeToReviewCountModel {
  /** @format int32 */
  totalToReview?: number;
  documentTypeDescription?: string | null;
}

export interface DocumentTypeToStoreModel {
  /** @format int32 */
  documentTypeId?: number;
  documentColumns?: BaseColumnsModel[] | null;
  documentData?: DataTable;
}

export interface DocumentTypeUpdateModel {
  /** @format int32 */
  documentTypeId?: number;
  keyBusinessReferenceField?: string | null;
}

export interface DocumentVersionModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  currentVersionDocumentId?: number;
  /** @format int32 */
  documentId?: number;
  documentType?: DocumentTypeModel;
  cabinet?: CabinetModel;
  /**
   *
   * 0 = None
   * 1 = ManualCheckedInOut
   * 2 = ReIndexed
   * 3 = HistoricVersion
   * 4 = PagesChanged
   * 5 = CapturePlusPdfPlugin
   * 6 = Current
   */
  type?: DocumentVersionType;
  /** @format int32 */
  number?: number;
  details?: string | null;
  user?: UserModel;
  /** @format date-time */
  date?: string | null;
  currentUserCanEdit?: boolean;
}

/**
* 

0 = None

1 = ManualCheckedInOut

2 = ReIndexed

3 = HistoricVersion

4 = PagesChanged

5 = CapturePlusPdfPlugin

6 = Current
* @format int32
*/
export enum DocumentVersionType {
  None = 0,
  ManualCheckedInOut = 1,
  ReIndexed = 2,
  HistoricVersion = 3,
  PagesChanged = 4,
  CapturePlusPdfPlugin = 5,
  Current = 6
}

export interface DocumentViewModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  /** @format int32 */
  id?: number;
  fileName?: string | null;
  fileExtension?: string | null;
  documentData?: string | null;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  viewConversionId?: number | null;
  isBeingConverted?: boolean;
  /** @format date-time */
  conversionRequestedDate?: string | null;
  cabinetId?: string | null;
  pageSplittingSupported?: boolean;
  isTif?: boolean;
  inWorkflow?: boolean;
  canEditReferences?: boolean;
  editReferencesButtonTooltip?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  documentTypeDescription?: string | null;
  documentPagePreferences?: DocumentPagePreferencesModel[] | null;
  autoSaveConfiguration?: AutoSaveConfigurationModel;
  isImageOrPdfType?: boolean;
}

export interface DocumentWorkflowInformationTabItemModel {
  /** @format int32 */
  workflowJobId?: number;
  jobStatus?: string | null;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  queueId?: number | null;
  queueDescription?: string | null;
}

export interface DocumentWorkflowInformationTabModel {
  workflowInformationItems?: DocumentWorkflowInformationTabItemModel[] | null;
  workflowInformationColumns?: ColumnsModel[] | null;
}

export interface DocumentsToReviewCountModel {
  /** @format int32 */
  totalToReview?: number;
  cabinetsToReviewCounts?: Record<string, CabinetToReviewCountModel>;
}

export interface DocumentsToReviewModel {
  cabinetReferenceDescriptions?: Record<string, string | null>;
  documentReferenceDescriptions?: Record<string, Record<string, string>>;
  data?: Record<string, any>[] | null;
}

export interface DocumentsToStoreModel {
  canAccessMyDocuments?: boolean;
  canAccessEveryonesDocuments?: boolean;
  myDocuments?: DocumentTypeToStoreModel;
  documentTypes?: DocumentTypeModel[] | null;
  fileUploadSettings?: FileUploadSettingsModel;
  /** @format int32 */
  documentsToStoreDocumentTypeId?: number;
}

export interface DynamicFormModel {
  formId?: string | null;
  containerRows?: ContainerRowModel[] | null;
  fields?: SimpleFieldModel[] | null;
}

export interface EditListItemSettingsModel {
  listItemFieldId?: string | null;
  /** @format int32 */
  listId?: number;
  /**
   *
   * 0 = LocalListDataFilterEnabled
   * 1 = LookupFilterEnabled
   */
  listType?: ListItemFieldListType;
}

export interface EnvelopeStatus {
  envelopeId?: string | null;
  status?: string | null;
}

export interface EnvelopeUpdateModel {
  envelopeStatus?: EnvelopeStatus;
  documentPdfs?: DocumentPdfs;
}

/**
* 

0 = None

1 = UnsupportedFileType

2 = SqlTimeOutException

3 = JobDoesNotExistInQueue

4 = JobLockedByAnotherSession

5 = InvalidConfiguration

6 = DocumentPageShuffleSucceededReIndexFailed

7 = EncryptionError
* @format int32
*/
export enum ErrorCode {
  None = 0,
  UnsupportedFileType = 1,
  SqlTimeOutException = 2,
  JobDoesNotExistInQueue = 3,
  JobLockedByAnotherSession = 4,
  InvalidConfiguration = 5,
  DocumentPageShuffleSucceededReIndexFailed = 6,
  EncryptionError = 7
}

export interface ErrorModel {
  header?: string | null;
  showHeader?: boolean;
  message?: string | null;
  icon?: string | null;
  iconTheme?: string | null;
  showButton?: boolean;
  buttonRouteName?: string | null;
  buttonRouteParams?: Record<string, string | null>;
  buttonText?: string | null;
}

/**
* 

0 = None

512 = SpecialName

1024 = ReservedMask
* @format int32
*/
export enum EventAttributes {
  None = 0,
  SpecialName = 512,
  ReservedMask = 1024
}

export interface EventInfo {
  name?: string | null;
  declaringType?: Type;
  reflectedType?: Type;
  module?: Module;
  customAttributes?: CustomAttributeData[] | null;
  isCollectible?: boolean;
  /** @format int32 */
  metadataToken?: number;
  /**
   *
   * 1 = Constructor
   * 2 = Event
   * 4 = Field
   * 8 = Method
   * 16 = Property
   * 32 = TypeInfo
   * 64 = Custom
   * 128 = NestedType
   * 191 = All
   */
  memberType?: MemberTypes;
  /**
   *
   * 0 = None
   * 512 = SpecialName
   * 1024 = ReservedMask
   */
  attributes?: EventAttributes;
  isSpecialName?: boolean;
  addMethod?: MethodInfo;
  removeMethod?: MethodInfo;
  raiseMethod?: MethodInfo;
  isMulticast?: boolean;
  eventHandlerType?: Type;
}

export interface ExampleErrorsModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  someData?: string | null;
}

export interface ExceptionalJobConfigurationCabinetModel {
  groupedConfigurations?: GroupedExceptionalJobConfigurationModel[] | null;
  cabinets?: CabinetModel[] | null;
}

export interface ExceptionalJobConfigurationModel {
  /** @format int32 */
  id?: number;
  cabinetId?: string | null;
  cabinetDescription?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  documentTypeDescription?: string | null;
  /**
   *
   * 1 = CreateNewVersion
   */
  versionType?: ExceptionalJobVersionType;
  versionTypeDescription?: string | null;
  enabled?: boolean;
  enabledDescription?: string | null;
}

export interface ExceptionalJobCreateModel {
  uniqueIdentifier?: string | null;
}

export interface ExceptionalJobModel {
  /** @format int32 */
  id?: number;
  uniqueIdentifier?: string | null;
  /** @format date-time */
  createdDate?: string;
  createdByUserName?: string | null;
  /**
   *
   * 0 = New
   * 1 = AwaitingOversize
   * 2 = AwaitingBatch
   * 3 = AwaitingConsolidation
   * 4 = InProgress
   * 5 = Completed
   * 6 = Error
   */
  status?: ExceptionalJobStatus;
  errorMessage?: string | null;
  targetCabinetId?: string | null;
  /** @format int32 */
  targetDocumentId?: number | null;
  sourceCabinetId?: string | null;
  /** @format int32 */
  sourceDocumentId?: number | null;
}

/**
* 

0 = New

1 = AwaitingOversize

2 = AwaitingBatch

3 = AwaitingConsolidation

4 = InProgress

5 = Completed

6 = Error
* @format int32
*/
export enum ExceptionalJobStatus {
  New = 0,
  AwaitingOversize = 1,
  AwaitingBatch = 2,
  AwaitingConsolidation = 3,
  InProgress = 4,
  Completed = 5,
  Error = 6
}

/**
* 

1 = CreateNewVersion
* @format int32
*/
export enum ExceptionalJobVersionType {
  CreateNewVersion = 1
}

/**
* 

1 = AddToDocument

2 = ReplaceDocument

3 = CreateHistoricVersion
* @format int32
*/
export enum ExistingDocumentOption {
  AddToDocument = 1,
  ReplaceDocument = 2,
  CreateHistoricVersion = 3
}

export interface ExternalRoleModel {
  /** @format int32 */
  roleId?: number;
  name?: string | null;
  description?: string | null;
}

export interface ExternalUserCreateModel {
  username?: string | null;
  name?: string | null;
  emailAddress?: string | null;
}

export interface ExternalUserModel {
  /** @format int32 */
  userId?: number;
  username?: string | null;
  name?: string | null;
  emailAddress?: string | null;
  organisation?: string | null;
  roles?: ExternalRoleModel[] | null;
  apiKeyRevoked?: boolean | null;
  hasApiKey?: boolean | null;
}

export interface ExternalUserUpdateModel {
  name?: string | null;
  emailAddress?: string | null;
}

export interface FeedbackModel {
  subject?: string | null;
  message?: string | null;
  includeUserInformation?: boolean;
}

export interface FeedbackSubjectsModel {
  reportIssue?: string[] | null;
  feedback?: string[] | null;
  getHelp?: string[] | null;
}

/**
* 

0 = PrivateScope

1 = Private

2 = FamANDAssem

3 = Assembly

4 = Family

5 = FamORAssem

6 = Public

7 = FieldAccessMask

16 = Static

32 = InitOnly

64 = Literal

128 = NotSerialized

256 = HasFieldRVA

512 = SpecialName

1024 = RTSpecialName

4096 = HasFieldMarshal

8192 = PinvokeImpl

32768 = HasDefault

38144 = ReservedMask
* @format int32
*/
export enum FieldAttributes {
  PrivateScope = 0,
  Private = 1,
  FamANDAssem = 2,
  Assembly = 3,
  Family = 4,
  FamORAssem = 5,
  Public = 6,
  FieldAccessMask = 7,
  Static = 16,
  InitOnly = 32,
  Literal = 64,
  NotSerialized = 128,
  HasFieldRVA = 256,
  SpecialName = 512,
  RTSpecialName = 1024,
  HasFieldMarshal = 4096,
  PinvokeImpl = 8192,
  HasDefault = 32768,
  ReservedMask = 38144
}

export interface FieldColumnModel {
  fieldColumnCssClass?: string | null;
  fields?: FieldModel[] | null;
}

export interface FieldInfo {
  name?: string | null;
  declaringType?: Type;
  reflectedType?: Type;
  module?: Module;
  customAttributes?: CustomAttributeData[] | null;
  isCollectible?: boolean;
  /** @format int32 */
  metadataToken?: number;
  /**
   *
   * 1 = Constructor
   * 2 = Event
   * 4 = Field
   * 8 = Method
   * 16 = Property
   * 32 = TypeInfo
   * 64 = Custom
   * 128 = NestedType
   * 191 = All
   */
  memberType?: MemberTypes;
  /**
   *
   * 0 = PrivateScope
   * 1 = Private
   * 2 = FamANDAssem
   * 3 = Assembly
   * 4 = Family
   * 5 = FamORAssem
   * 6 = Public
   * 7 = FieldAccessMask
   * 16 = Static
   * 32 = InitOnly
   * 64 = Literal
   * 128 = NotSerialized
   * 256 = HasFieldRVA
   * 512 = SpecialName
   * 1024 = RTSpecialName
   * 4096 = HasFieldMarshal
   * 8192 = PinvokeImpl
   * 32768 = HasDefault
   * 38144 = ReservedMask
   */
  attributes?: FieldAttributes;
  fieldType?: Type;
  isInitOnly?: boolean;
  isLiteral?: boolean;
  /** @deprecated */
  isNotSerialized?: boolean;
  isPinvokeImpl?: boolean;
  isSpecialName?: boolean;
  isStatic?: boolean;
  isAssembly?: boolean;
  isFamily?: boolean;
  isFamilyAndAssembly?: boolean;
  isFamilyOrAssembly?: boolean;
  isPrivate?: boolean;
  isPublic?: boolean;
  isSecurityCritical?: boolean;
  isSecuritySafeCritical?: boolean;
  isSecurityTransparent?: boolean;
  fieldHandle?: RuntimeFieldHandle;
}

export interface FieldModel {
  componentName?: string | null;
  /** @format int32 */
  columnNumber?: number;
  properties?: FieldPropertiesModel;
}

export interface FieldPropertiesModel {
  formId?: string | null;
  fieldId?: string | null;
  htmlElementId?: string | null;
  fieldLabel?: string | null;
  fieldName?: string | null;
  dataSourceKey?: string | null;
  isRequired?: boolean;
  isReadonly?: boolean;
  mustExistInList?: boolean;
  filterEnabled?: boolean;
  /**
   *
   * 1 = String
   * 2 = Integer
   * 3 = Boolean
   * 4 = DateTime
   * 5 = Decimal
   * 6 = Double
   * 7 = Object
   * 8 = Unknown
   */
  dataType?: WorkflowDataSourceFieldDataType;
  additionalProperties?: Record<string, any>;
}

export interface FieldRowModel {
  fieldColumns?: FieldColumnModel[] | null;
}

export interface FileUploadSettingsModel {
  fileExtensionWhiteList?: string[] | null;
  /** @format int32 */
  fileSizeLimitMb?: number;
  /** @format int32 */
  maximumFileUploadCount?: number;
}

export interface FullTextSearchModel {
  isFullTextSearch?: boolean;
  fullTextSearchValue?: string | null;
}

/**
* 

0 = VisibleNotChecked

1 = VisibleAndChecked

2 = Hidden
* @format int32
*/
export enum FullTextSearchSettingType {
  VisibleNotChecked = 0,
  VisibleAndChecked = 1,
  Hidden = 2
}

/**
* 

0 = NotProcessed

1 = Successful

2 = Failed

3 = PostProcessSuccessful

4 = PostProcessFailed

5 = MailroomSuccessful

6 = MailroomFailed

7 = BarcodeIndexingSuccessful

8 = BarcodeIndexFailed

9 = PdfCombinePending

10 = PdfCombineFailed
* @format int32
*/
export enum FullTextStatus {
  NotProcessed = 0,
  Successful = 1,
  Failed = 2,
  PostProcessSuccessful = 3,
  PostProcessFailed = 4,
  MailroomSuccessful = 5,
  MailroomFailed = 6,
  BarcodeIndexingSuccessful = 7,
  BarcodeIndexFailed = 8,
  PdfCombinePending = 9,
  PdfCombineFailed = 10
}

/**
* 

0 = None

1 = Covariant

2 = Contravariant

3 = VarianceMask

4 = ReferenceTypeConstraint

8 = NotNullableValueTypeConstraint

16 = DefaultConstructorConstraint

28 = SpecialConstraintMask
* @format int32
*/
export enum GenericParameterAttributes {
  None = 0,
  Covariant = 1,
  Contravariant = 2,
  VarianceMask = 3,
  ReferenceTypeConstraint = 4,
  NotNullableValueTypeConstraint = 8,
  DefaultConstructorConstraint = 16,
  SpecialConstraintMask = 28
}

export interface GroupedExceptionalJobConfigurationModel {
  cabinetId?: string | null;
  cabinetDescription?: string | null;
  configurations?: ExceptionalJobConfigurationModel[] | null;
}

export interface IComponent {
  site?: ISite;
}

export interface IContainer {
  components?: any[] | null;
}

export type ICustomAttributeProvider = object;

export interface ISite {
  component?: IComponent;
  container?: IContainer;
  designMode?: boolean;
  name?: string | null;
}

export interface IndexDocumentModel {
  /** @format int32 */
  batchNumber?: number;
  cabinetId?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  /** @format int32 */
  appendToDocumentId?: number;
  /**
   *
   * 0 = Copy
   * 1 = Move
   */
  appendType?: AppendType;
  /** @format int32 */
  newVersionDocumentId?: number;
  newVersionCabinetId?: string | null;
  /**
   *
   * 0 = None
   * 1 = ManualCheckedInOut
   * 2 = ReIndexed
   * 3 = HistoricVersion
   * 4 = PagesChanged
   */
  newVersionType?: VersionType;
  newVersionDetails?: string | null;
  /**
   *
   * 0 = AsNewVersionOfDocument
   * 1 = AsAVersionOfDocument
   */
  newVersionControlType?: VersionControlType;
  accessLevel?: string | null;
  /** @format int32 */
  priority?: number;
  /**
   *
   * 0 = None
   * 1 = AutomaticDeletion
   * 2 = ReviewForDeletion
   * 3 = Default
   */
  retentionType?: DocumentRetentionType;
  /** @format date-time */
  retentionDate?: string;
  references?: IndexReferenceModel[] | null;
  notes?: IndexNoteModel[] | null;
  reason?: string | null;
  /**
   *
   * 0 = Default
   * 1 = DisableLegacyWorkflowFeed
   * 2 = DisableMAFWorkflowFeed
   * 4 = DisableSecureDelivery
   * 8 = DisableFeederTypeHandling
   * 16 = DisableReferenceValidation
   * 32 = DeleteFilesAfterwards
   * 64 = DisableTaskFeed
   * 128 = DisableAutoVersioning
   * 256 = IgnoreDocumentTypeIndexParametersUseDefaults
   * 512 = PreserveExistingMultiValueValues
   * 1024 = DontCheckIfFileIsSupported
   * 2048 = DisableReferenceLookup
   * 4096 = DisableFileMetaDataLinkingLookup
   * 8192 = DisableAllIndexReIndexProcesses
   * 16384 = DisablePreValidationIndexReIndexProcesses
   * 32768 = DisablePostValidationIndexReIndexProcesses
   * 65536 = DisablePostRecordLookupIndexReIndexProcesses
   * 131072 = DisablePostIndexReIndexProcesses
   * 1048576 = DisableReIndexCheckLock
   */
  indexOptions?: IndexOptions;
  /** @format byte */
  file?: string | null;
  fileExtension?: string | null;
  permissionOnlyEncryptionRemoved?: boolean;
}

export interface IndexNoteModel {
  /**
   *
   * 1 = Default
   * 2 = Narrative
   */
  type?: NoteType;
  subject?: string | null;
  body?: string | null;
  /**
   *
   * 0 = Normal
   * 1 = High
   */
  noteImportance?: NoteImportance;
  /** @format int32 */
  categoryId?: number;
}

/**
* 

0 = Default

1 = DisableLegacyWorkflowFeed

2 = DisableMAFWorkflowFeed

4 = DisableSecureDelivery

8 = DisableFeederTypeHandling

16 = DisableReferenceValidation

32 = DeleteFilesAfterwards

64 = DisableTaskFeed

128 = DisableAutoVersioning

256 = IgnoreDocumentTypeIndexParametersUseDefaults

512 = PreserveExistingMultiValueValues

1024 = DontCheckIfFileIsSupported

2048 = DisableReferenceLookup

4096 = DisableFileMetaDataLinkingLookup

8192 = DisableAllIndexReIndexProcesses

16384 = DisablePreValidationIndexReIndexProcesses

32768 = DisablePostValidationIndexReIndexProcesses

65536 = DisablePostRecordLookupIndexReIndexProcesses

131072 = DisablePostIndexReIndexProcesses

1048576 = DisableReIndexCheckLock
* @format int32
*/
export enum IndexOptions {
  Default = 0,
  DisableLegacyWorkflowFeed = 1,
  DisableMAFWorkflowFeed = 2,
  DisableSecureDelivery = 4,
  DisableFeederTypeHandling = 8,
  DisableReferenceValidation = 16,
  DeleteFilesAfterwards = 32,
  DisableTaskFeed = 64,
  DisableAutoVersioning = 128,
  IgnoreDocumentTypeIndexParametersUseDefaults = 256,
  PreserveExistingMultiValueValues = 512,
  DontCheckIfFileIsSupported = 1024,
  DisableReferenceLookup = 2048,
  DisableFileMetaDataLinkingLookup = 4096,
  DisableAllIndexReIndexProcesses = 8192,
  DisablePreValidationIndexReIndexProcesses = 16384,
  DisablePostValidationIndexReIndexProcesses = 32768,
  DisablePostRecordLookupIndexReIndexProcesses = 65536,
  DisablePostIndexReIndexProcesses = 131072,
  DisableReIndexCheckLock = 1048576
}

export interface IndexReferenceModel {
  /**
   *
   * 0 = Common
   * 1 = Document
   * 2 = Display
   * 3 = DocumentDate
   */
  referenceType?: ReferenceType;
  /** @format int32 */
  referenceNumber?: number;
  /** @format int32 */
  valueNumber?: number;
  value?: string | null;
}

/**
* 

1 = EnterOnly

2 = EnterAndDropdown

3 = EnterAndSearch

4 = DropdownOnly

5 = SearchOnly

6 = BarCode

7 = ExistingValues

8 = AutoIncrement

9 = DropdownAndSearch
* @format int32
*/
export enum InputType {
  EnterOnly = 1,
  EnterAndDropdown = 2,
  EnterAndSearch = 3,
  DropdownOnly = 4,
  SearchOnly = 5,
  BarCode = 6,
  ExistingValues = 7,
  AutoIncrement = 8,
  DropdownAndSearch = 9
}

export type IntPtr = object;

/**
* 

1 = Horizontal

2 = Vertical
* @format int32
*/
export enum JobTabOrientation {
  Horizontal = 1,
  Vertical = 2
}

/**
* 

0 = Sequential

2 = Explicit

3 = Auto
* @format int32
*/
export enum LayoutKind {
  Sequential = 0,
  Explicit = 2,
  Auto = 3
}

export interface LeaverCreateModel {
  /** @format int32 */
  configurationId?: number;
  listItemValue?: string | null;
  details?: string | null;
  /** @format date-time */
  leavingDate?: string;
}

export interface LeaverDocumentModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  documentId?: number;
  fromCabinet?: CabinetModel;
  fromDocumentType?: DocumentTypeModel;
  toCabinet?: CabinetModel;
  toDocumentType?: DocumentTypeModel;
  /** @format date-time */
  retentionDateSet?: string | null;
  /**
   *
   * 1 = Unprocessed
   * 2 = Pending
   * 3 = Successful
   * 4 = Failed
   */
  status?: LeaverDocumentStatus;
  errorMessage?: string | null;
}

/**
* 

1 = Unprocessed

2 = Pending

3 = Successful

4 = Failed
* @format int32
*/
export enum LeaverDocumentStatus {
  Unprocessed = 1,
  Pending = 2,
  Successful = 3,
  Failed = 4
}

export interface LeaverModel {
  /** @format int32 */
  id?: number;
  configuration?: LeaversToolConfigurationModel;
  listItemValue?: string | null;
  listData?: string | null;
  /** @format date-time */
  leavingDate?: string;
  progressMessage?: string | null;
  /**
   *
   * 1 = Unprocessed
   * 2 = Pending
   * 3 = Successful
   * 4 = Failed
   */
  status?: LeaverStatus;
  errorMessage?: string | null;
  documents?: LeaverDocumentModel[] | null;
}

export interface LeaverRuleCreateUpdateModel {
  /** @format int32 */
  currentDocumentTypeId?: number;
  /** @format int32 */
  destinationDocumentTypeId?: number;
  /**
   *
   * 1 = None
   * 2 = Days
   * 3 = Weeks
   * 4 = Months
   * 5 = Years
   */
  retentionPeriodType?: RetentionPeriodType;
  /** @format int32 */
  retentionPeriod?: number | null;
  /** @format int32 */
  referenceId?: number | null;
  referenceValue?: string | null;
  /** @format int32 */
  calculateFromReferenceId?: number | null;
}

export interface LeaverRuleModel {
  /** @format int32 */
  id?: number;
  configuration?: LeaversToolConfigurationModel;
  currentDocumentType?: DocumentTypeModel;
  destinationDocumentType?: DocumentTypeModel;
  /**
   *
   * 1 = None
   * 2 = Days
   * 3 = Weeks
   * 4 = Months
   * 5 = Years
   */
  retentionPeriodType?: RetentionPeriodType;
  /** @format int32 */
  retentionPeriod?: number | null;
  reference?: CabinetReferenceModel;
  referenceValue?: string | null;
  calculateFromReference?: CabinetReferenceModel;
  createdByUser?: UserModel;
}

/**
* 

1 = Unprocessed

2 = Pending

3 = Successful

4 = Failed
* @format int32
*/
export enum LeaverStatus {
  Unprocessed = 1,
  Pending = 2,
  Successful = 3,
  Failed = 4
}

export interface LeaversToolConfigurationCreateModel {
  currentCabinetId?: string | null;
  destinationCabinetId?: string | null;
  /** @format int32 */
  currentListConfigurationId?: number;
  /** @format int32 */
  destinationListConfigurationId?: number;
}

export interface LeaversToolConfigurationModel {
  /** @format int32 */
  id?: number;
  currentCabinet?: CabinetModel;
  destinationCabinet?: CabinetModel;
  currentListConfiguration?: ListConfigurationModel;
  destinationListConfiguration?: ListConfigurationModel;
  rules?: LeaverRuleModel[] | null;
  configurableCurrentDocumentTypes?: DocumentTypeModel[] | null;
  configurableDestinationDocumentTypes?: DocumentTypeModel[] | null;
}

export interface LeaversToolConfigurationsModel {
  configurations?: LeaversToolConfigurationModel[] | null;
  configurableCabinets?: CabinetModel[] | null;
  configurableListConfigurations?: ListConfigurationModel[] | null;
  configurationExists?: boolean;
}

export interface ListConfigurationModel {
  /** @format int32 */
  id?: number;
  description?: string | null;
  /**
   *
   * 0 = Maf
   * 1 = Sql
   * 2 = Class
   * 3 = Enumerator
   */
  listType?: ListType;
  /** @format int32 */
  initialListValueFieldIndex?: number;
  initialListSql?: string | null;
  initialListValueFieldDescription?: string | null;
  hasInitialList?: boolean;
}

/**
* 

0 = NoRecords

1 = SomeRecords

2 = ManyRecords
* @format int32
*/
export enum ListDataResultType {
  NoRecords = 0,
  SomeRecords = 1,
  ManyRecords = 2
}

export interface ListHeaderModel {
  data?: string | null;
  title?: string | null;
}

/**
* 

0 = LocalListDataFilterEnabled

1 = LookupFilterEnabled
* @format int32
*/
export enum ListItemFieldListType {
  LocalListDataFilterEnabled = 0,
  LookupFilterEnabled = 1
}

export interface ListItemModel {
  value?: string | null;
  data?: string | null;
}

export interface ListItemsModel {
  /** @format int32 */
  listId?: number;
  listItems?: ListItemModel[] | null;
}

export interface ListMaintenanceConfigurationModel {
  /** @format int32 */
  configurationChangeId?: number | null;
  canMaintain?: boolean;
  canConfigure?: boolean;
  lists?: ListConfigurationModel[] | null;
  columns?: ColumnsModel[] | null;
}

export interface ListModel {
  /** @format int32 */
  id?: number;
  key?: string | null;
  text?: string | null;
  headers?: ListHeaderModel[] | null;
  list?: DataTable;
  /** @format int32 */
  totalRow?: number;
  /**
   *
   * 0 = NoRecords
   * 1 = SomeRecords
   * 2 = ManyRecords
   */
  resultType?: ListDataResultType;
  listDataResultTypeMessage?: string | null;
}

export interface ListSearchModel {
  /** @format int32 */
  id?: number;
  searchText?: string | null;
  getAllItems?: boolean;
  keyFilterValues?: Record<string, any>;
}

/**
* 

0 = Maf

1 = Sql

2 = Class

3 = Enumerator
* @format int32
*/
export enum ListType {
  Maf = 0,
  Sql = 1,
  Class = 2,
  Enumerator = 3
}

export interface LockMaintenanceModel {
  canMaintainAllPersistentLocks?: boolean;
  canMaintainMyPersistentLocks?: boolean;
  locks?: LockModel[] | null;
  lockTypes?: LockTypeModel[] | null;
  applicationTypes?: string[] | null;
}

export interface LockModel {
  /** @format int64 */
  id?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  expires?: string | null;
  lockedByUser?: UserModel;
  isLockedByCurrentSessionId?: boolean;
  workstation?: string | null;
  hasExpired?: boolean;
  isLockedOnDesktop?: boolean;
  lockMessage?: string | null;
  isValidLockForSession?: boolean;
  isExistingLock?: boolean;
  isLocked?: boolean;
  applicationType?: string | null;
  lockType?: string | null;
  /** @format int32 */
  lockTypeId?: number;
  isPersistentLock?: boolean;
  sessionId?: string | null;
  itemId?: string | null;
}

export interface LockTypeModel {
  /** @format int32 */
  entityId?: number;
  name?: string | null;
}

export interface MStoreDynamicFieldModel {
  id?: string | null;
  value?: any;
  label?: string | null;
  componentProperties?: any;
  validation?: MStoreDynamicFieldValidationModel;
  readonly?: boolean;
  disabled?: boolean;
  metadata?: any;
}

export interface MStoreDynamicFieldValidationModel {
  required?: boolean;
  /** @format int32 */
  maxLength?: number | null;
  /** @format int32 */
  minLength?: number | null;
  /** @format int32 */
  fixedLength?: number | null;
  upperCase?: boolean;
  /**
   *
   * 0 = Any
   * 1 = AlphaNumeric
   * 2 = Integer
   * 3 = Decimal
   * 4 = Email
   */
  valueType?: MStoreDynamicFieldValueType;
  /** @format double */
  minValue?: number | null;
  /** @format double */
  maxValue?: number | null;
  mustExistInList?: boolean | null;
  regex?: string | null;
}

/**
* 

0 = Any

1 = AlphaNumeric

2 = Integer

3 = Decimal

4 = Email
* @format int32
*/
export enum MStoreDynamicFieldValueType {
  Any = 0,
  AlphaNumeric = 1,
  Integer = 2,
  Decimal = 3,
  Email = 4
}

export interface MStoreDynamicFormModel {
  canProcess?: boolean;
  fields?: MStoreDynamicFieldModel[] | null;
}

/**
* 

0 = System

1 = UserClient

2 = User

3 = Role

4 = Module

5 = Permission

6 = Note

7 = General

8 = Email

9 = Task

10 = FailedDeletedFile

11 = File

12 = Api

13 = List

15 = CustomExecute

16 = PerformanceLogGroup

17 = Licence

18 = BlockMonitor

19 = TaskType

20 = FileTemplateDocument

21 = TaskStatus

22 = AdSynchronisation

23 = Toolkit

101 = Cabinet

102 = DocumentType

103 = ReferenceType

104 = Document

105 = Reference

106 = Favourite

107 = SavedSearch

108 = Batch

109 = RecentSearch

110 = MStoreClassic

111 = CheckedOutDocument

112 = IncomingDocuments

113 = ExceptionalJob

201 = WorkflowProcess

202 = WorkflowQueue

203 = WorkflowJobType

204 = WorkflowJob

205 = WorkflowDataSource

206 = WorkflowDataField

207 = WorkflowRule

300 = MessageBodyFullText

301 = WordAttachmentFullText

302 = ImageFullText

303 = WordFullText

304 = EmailFullText

305 = AcrobatFullText

306 = ExcelFullText

307 = PlainTextFullText

308 = BarcodeFullText

309 = RichTextFullText

400 = MailroomConfiguration

401 = MailroomRule

402 = MailroomField

500 = CapturePlus
* @format int32
*/
export enum MStoreEntityId {
  System = 0,
  UserClient = 1,
  User = 2,
  Role = 3,
  Module = 4,
  Permission = 5,
  Note = 6,
  General = 7,
  Email = 8,
  Task = 9,
  FailedDeletedFile = 10,
  File = 11,
  Api = 12,
  List = 13,
  CustomExecute = 15,
  PerformanceLogGroup = 16,
  Licence = 17,
  BlockMonitor = 18,
  TaskType = 19,
  FileTemplateDocument = 20,
  TaskStatus = 21,
  AdSynchronisation = 22,
  Toolkit = 23,
  Cabinet = 101,
  DocumentType = 102,
  ReferenceType = 103,
  Document = 104,
  Reference = 105,
  Favourite = 106,
  SavedSearch = 107,
  Batch = 108,
  RecentSearch = 109,
  MStoreClassic = 110,
  CheckedOutDocument = 111,
  IncomingDocuments = 112,
  ExceptionalJob = 113,
  WorkflowProcess = 201,
  WorkflowQueue = 202,
  WorkflowJobType = 203,
  WorkflowJob = 204,
  WorkflowDataSource = 205,
  WorkflowDataField = 206,
  WorkflowRule = 207,
  MessageBodyFullText = 300,
  WordAttachmentFullText = 301,
  ImageFullText = 302,
  WordFullText = 303,
  EmailFullText = 304,
  AcrobatFullText = 305,
  ExcelFullText = 306,
  PlainTextFullText = 307,
  BarcodeFullText = 308,
  RichTextFullText = 309,
  MailroomConfiguration = 400,
  MailroomRule = 401,
  MailroomField = 402,
  CapturePlus = 500
}

export interface MStoreInputInlineUpdateModel {
  data?: string | null;
}

export interface ManufacturerTabModel {
  manufacturerDataSource?: WorkflowDataSourceModel;
  dynamicForm?: DynamicFormModel;
}

/**
* 

1 = Element

2 = Attribute

3 = SimpleContent

4 = Hidden
* @format int32
*/
export enum MappingType {
  Element = 1,
  Attribute = 2,
  SimpleContent = 3,
  Hidden = 4
}

/**
* 

0 = CreateNew

1 = AppendPages

2 = ReplaceMatchingRecordBecomesVersion

3 = CreateAsVersionOfMatchingRecord

4 = Overwrite
* @format int32
*/
export enum MatchingRecordAction {
  CreateNew = 0,
  AppendPages = 1,
  ReplaceMatchingRecordBecomesVersion = 2,
  CreateAsVersionOfMatchingRecord = 3,
  Overwrite = 4
}

export interface MemberInfo {
  /**
   *
   * 1 = Constructor
   * 2 = Event
   * 4 = Field
   * 8 = Method
   * 16 = Property
   * 32 = TypeInfo
   * 64 = Custom
   * 128 = NestedType
   * 191 = All
   */
  memberType?: MemberTypes;
  name?: string | null;
  declaringType?: Type;
  reflectedType?: Type;
  module?: Module;
  customAttributes?: CustomAttributeData[] | null;
  isCollectible?: boolean;
  /** @format int32 */
  metadataToken?: number;
}

/**
* 

1 = Constructor

2 = Event

4 = Field

8 = Method

16 = Property

32 = TypeInfo

64 = Custom

128 = NestedType

191 = All
* @format int32
*/
export enum MemberTypes {
  Constructor = 1,
  Event = 2,
  Field = 4,
  Method = 8,
  Property = 16,
  TypeInfo = 32,
  Custom = 64,
  NestedType = 128,
  All = 191
}

/**
* 

0 = ReuseSlot

1 = Private

2 = FamANDAssem

3 = Assembly

4 = Family

5 = FamORAssem

6 = Public

7 = MemberAccessMask

8 = UnmanagedExport

16 = Static

32 = Final

64 = Virtual

128 = HideBySig

256 = VtableLayoutMask

512 = CheckAccessOnOverride

1024 = Abstract

2048 = SpecialName

4096 = RTSpecialName

8192 = PinvokeImpl

16384 = HasSecurity

32768 = RequireSecObject

53248 = ReservedMask
* @format int32
*/
export enum MethodAttributes {
  ReuseSlot = 0,
  Private = 1,
  FamANDAssem = 2,
  Assembly = 3,
  Family = 4,
  FamORAssem = 5,
  Public = 6,
  MemberAccessMask = 7,
  UnmanagedExport = 8,
  Static = 16,
  Final = 32,
  Virtual = 64,
  HideBySig = 128,
  VtableLayoutMask = 256,
  CheckAccessOnOverride = 512,
  Abstract = 1024,
  SpecialName = 2048,
  RTSpecialName = 4096,
  PinvokeImpl = 8192,
  HasSecurity = 16384,
  RequireSecObject = 32768,
  ReservedMask = 53248
}

export interface MethodBase {
  /**
   *
   * 1 = Constructor
   * 2 = Event
   * 4 = Field
   * 8 = Method
   * 16 = Property
   * 32 = TypeInfo
   * 64 = Custom
   * 128 = NestedType
   * 191 = All
   */
  memberType?: MemberTypes;
  name?: string | null;
  declaringType?: Type;
  reflectedType?: Type;
  module?: Module;
  customAttributes?: CustomAttributeData[] | null;
  isCollectible?: boolean;
  /** @format int32 */
  metadataToken?: number;
  /**
   *
   * 0 = ReuseSlot
   * 1 = Private
   * 2 = FamANDAssem
   * 3 = Assembly
   * 4 = Family
   * 5 = FamORAssem
   * 6 = Public
   * 7 = MemberAccessMask
   * 8 = UnmanagedExport
   * 16 = Static
   * 32 = Final
   * 64 = Virtual
   * 128 = HideBySig
   * 256 = VtableLayoutMask
   * 512 = CheckAccessOnOverride
   * 1024 = Abstract
   * 2048 = SpecialName
   * 4096 = RTSpecialName
   * 8192 = PinvokeImpl
   * 16384 = HasSecurity
   * 32768 = RequireSecObject
   * 53248 = ReservedMask
   */
  attributes?: MethodAttributes;
  /**
   *
   * 0 = Managed
   * 1 = Native
   * 2 = OPTIL
   * 3 = Runtime
   * 4 = Unmanaged
   * 8 = NoInlining
   * 16 = ForwardRef
   * 32 = Synchronized
   * 64 = NoOptimization
   * 128 = PreserveSig
   * 256 = AggressiveInlining
   * 512 = AggressiveOptimization
   * 4096 = InternalCall
   * 65535 = MaxMethodImplVal
   */
  methodImplementationFlags?: MethodImplAttributes;
  /**
   *
   * 1 = Standard
   * 2 = VarArgs
   * 3 = Any
   * 32 = HasThis
   * 64 = ExplicitThis
   */
  callingConvention?: CallingConventions;
  isAbstract?: boolean;
  isConstructor?: boolean;
  isFinal?: boolean;
  isHideBySig?: boolean;
  isSpecialName?: boolean;
  isStatic?: boolean;
  isVirtual?: boolean;
  isAssembly?: boolean;
  isFamily?: boolean;
  isFamilyAndAssembly?: boolean;
  isFamilyOrAssembly?: boolean;
  isPrivate?: boolean;
  isPublic?: boolean;
  isConstructedGenericMethod?: boolean;
  isGenericMethod?: boolean;
  isGenericMethodDefinition?: boolean;
  containsGenericParameters?: boolean;
  methodHandle?: RuntimeMethodHandle;
  isSecurityCritical?: boolean;
  isSecuritySafeCritical?: boolean;
  isSecurityTransparent?: boolean;
}

/**
* 

0 = Managed

1 = Native

2 = OPTIL

3 = Runtime

4 = Unmanaged

8 = NoInlining

16 = ForwardRef

32 = Synchronized

64 = NoOptimization

128 = PreserveSig

256 = AggressiveInlining

512 = AggressiveOptimization

4096 = InternalCall

65535 = MaxMethodImplVal
* @format int32
*/
export enum MethodImplAttributes {
  Managed = 0,
  Native = 1,
  OPTIL = 2,
  Runtime = 3,
  Unmanaged = 4,
  NoInlining = 8,
  ForwardRef = 16,
  Synchronized = 32,
  NoOptimization = 64,
  PreserveSig = 128,
  AggressiveInlining = 256,
  AggressiveOptimization = 512,
  InternalCall = 4096,
  MaxMethodImplVal = 65535
}

export interface MethodInfo {
  name?: string | null;
  declaringType?: Type;
  reflectedType?: Type;
  module?: Module;
  customAttributes?: CustomAttributeData[] | null;
  isCollectible?: boolean;
  /** @format int32 */
  metadataToken?: number;
  /**
   *
   * 0 = ReuseSlot
   * 1 = Private
   * 2 = FamANDAssem
   * 3 = Assembly
   * 4 = Family
   * 5 = FamORAssem
   * 6 = Public
   * 7 = MemberAccessMask
   * 8 = UnmanagedExport
   * 16 = Static
   * 32 = Final
   * 64 = Virtual
   * 128 = HideBySig
   * 256 = VtableLayoutMask
   * 512 = CheckAccessOnOverride
   * 1024 = Abstract
   * 2048 = SpecialName
   * 4096 = RTSpecialName
   * 8192 = PinvokeImpl
   * 16384 = HasSecurity
   * 32768 = RequireSecObject
   * 53248 = ReservedMask
   */
  attributes?: MethodAttributes;
  /**
   *
   * 0 = Managed
   * 1 = Native
   * 2 = OPTIL
   * 3 = Runtime
   * 4 = Unmanaged
   * 8 = NoInlining
   * 16 = ForwardRef
   * 32 = Synchronized
   * 64 = NoOptimization
   * 128 = PreserveSig
   * 256 = AggressiveInlining
   * 512 = AggressiveOptimization
   * 4096 = InternalCall
   * 65535 = MaxMethodImplVal
   */
  methodImplementationFlags?: MethodImplAttributes;
  /**
   *
   * 1 = Standard
   * 2 = VarArgs
   * 3 = Any
   * 32 = HasThis
   * 64 = ExplicitThis
   */
  callingConvention?: CallingConventions;
  isAbstract?: boolean;
  isConstructor?: boolean;
  isFinal?: boolean;
  isHideBySig?: boolean;
  isSpecialName?: boolean;
  isStatic?: boolean;
  isVirtual?: boolean;
  isAssembly?: boolean;
  isFamily?: boolean;
  isFamilyAndAssembly?: boolean;
  isFamilyOrAssembly?: boolean;
  isPrivate?: boolean;
  isPublic?: boolean;
  isConstructedGenericMethod?: boolean;
  isGenericMethod?: boolean;
  isGenericMethodDefinition?: boolean;
  containsGenericParameters?: boolean;
  methodHandle?: RuntimeMethodHandle;
  isSecurityCritical?: boolean;
  isSecuritySafeCritical?: boolean;
  isSecurityTransparent?: boolean;
  /**
   *
   * 1 = Constructor
   * 2 = Event
   * 4 = Field
   * 8 = Method
   * 16 = Property
   * 32 = TypeInfo
   * 64 = Custom
   * 128 = NestedType
   * 191 = All
   */
  memberType?: MemberTypes;
  returnParameter?: ParameterInfo;
  returnType?: Type;
  returnTypeCustomAttributes?: ICustomAttributeProvider;
}

export interface Module {
  assembly?: Assembly;
  fullyQualifiedName?: string | null;
  name?: string | null;
  /** @format int32 */
  mdStreamVersion?: number;
  /** @format uuid */
  moduleVersionId?: string;
  scopeName?: string | null;
  moduleHandle?: ModuleHandle;
  customAttributes?: CustomAttributeData[] | null;
  /** @format int32 */
  metadataToken?: number;
}

export interface ModuleHandle {
  /** @format int32 */
  mdStreamVersion?: number;
}

export interface MultiValueReferenceModel {
  /** @format int32 */
  id?: number;
  values?: Record<string, string | null>;
}

export interface NavBarAccessModel {
  search?: boolean;
  index?: boolean;
  configuration?: boolean;
  tools?: boolean;
  workflow?: boolean;
  currentUsername?: string | null;
  customerNavbarAccess?: Record<string, boolean>;
}

export interface NoteCreateModel {
  subject?: string | null;
  message?: string | null;
}

/**
* 

0 = Normal

1 = High
* @format int32
*/
export enum NoteImportance {
  Normal = 0,
  High = 1
}

export interface NoteModel {
  /** @format int32 */
  id?: number;
  subject?: string | null;
  message?: string | null;
  user?: string | null;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  userId?: number;
  /** @format date-time */
  modifiedDate?: string | null;
}

/**
* 

1 = Default

2 = Narrative
* @format int32
*/
export enum NoteType {
  Default = 1,
  Narrative = 2
}

export interface NotificationMessageModel {
  /**
   *
   * 0 = Error
   * 1 = Warning
   */
  type?: NotificationMessageType;
  message?: string | null;
}

/**
* 

0 = Error

1 = Warning
* @format int32
*/
export enum NotificationMessageType {
  Error = 0,
  Warning = 1
}

export interface NotificationModel {
  messages?: NotificationMessageModel[] | null;
  hasMessages?: boolean;
  hasErrorMessages?: boolean;
  hasWarningMessages?: boolean;
  firstErrorMessage?: string | null;
}

/**
* 

0 = Success

1 = UserActionRequired

2 = UnexpectedError
* @format int32
*/
export enum NotificationPresentationType {
  Success = 0,
  UserActionRequired = 1,
  UnexpectedError = 2
}

export interface NumberFormatInfo {
  /** @format int32 */
  currencyDecimalDigits?: number;
  currencyDecimalSeparator?: string | null;
  isReadOnly?: boolean;
  currencyGroupSizes?: number[] | null;
  numberGroupSizes?: number[] | null;
  percentGroupSizes?: number[] | null;
  currencyGroupSeparator?: string | null;
  currencySymbol?: string | null;
  naNSymbol?: string | null;
  /** @format int32 */
  currencyNegativePattern?: number;
  /** @format int32 */
  numberNegativePattern?: number;
  /** @format int32 */
  percentPositivePattern?: number;
  /** @format int32 */
  percentNegativePattern?: number;
  negativeInfinitySymbol?: string | null;
  negativeSign?: string | null;
  /** @format int32 */
  numberDecimalDigits?: number;
  numberDecimalSeparator?: string | null;
  numberGroupSeparator?: string | null;
  /** @format int32 */
  currencyPositivePattern?: number;
  positiveInfinitySymbol?: string | null;
  positiveSign?: string | null;
  /** @format int32 */
  percentDecimalDigits?: number;
  percentDecimalSeparator?: string | null;
  percentGroupSeparator?: string | null;
  percentSymbol?: string | null;
  perMilleSymbol?: string | null;
  nativeDigits?: string[] | null;
  /**
   *
   * 0 = Context
   * 1 = None
   * 2 = NativeNational
   */
  digitSubstitution?: DigitShapes;
}

export interface OptimisticLockModel {
  lock?: LockModel;
  entityChangedSinceReadTime?: boolean;
  /** @format date-time */
  entityChangedTime?: string | null;
  /** @format date-time */
  readTime?: string;
  isLocked?: boolean;
  userMessage?: string | null;
  /**
   *
   * 0 = System
   * 1 = UserClient
   * 2 = User
   * 3 = Role
   * 4 = Module
   * 5 = Permission
   * 6 = Note
   * 7 = General
   * 8 = Email
   * 9 = Task
   * 10 = FailedDeletedFile
   * 11 = File
   * 12 = Api
   * 13 = List
   * 15 = CustomExecute
   * 16 = PerformanceLogGroup
   * 17 = Licence
   * 18 = BlockMonitor
   * 19 = TaskType
   * 20 = FileTemplateDocument
   * 21 = TaskStatus
   * 22 = AdSynchronisation
   * 23 = Toolkit
   * 101 = Cabinet
   * 102 = DocumentType
   * 103 = ReferenceType
   * 104 = Document
   * 105 = Reference
   * 106 = Favourite
   * 107 = SavedSearch
   * 108 = Batch
   * 109 = RecentSearch
   * 110 = MStoreClassic
   * 111 = CheckedOutDocument
   * 112 = IncomingDocuments
   * 113 = ExceptionalJob
   * 201 = WorkflowProcess
   * 202 = WorkflowQueue
   * 203 = WorkflowJobType
   * 204 = WorkflowJob
   * 205 = WorkflowDataSource
   * 206 = WorkflowDataField
   * 207 = WorkflowRule
   * 300 = MessageBodyFullText
   * 301 = WordAttachmentFullText
   * 302 = ImageFullText
   * 303 = WordFullText
   * 304 = EmailFullText
   * 305 = AcrobatFullText
   * 306 = ExcelFullText
   * 307 = PlainTextFullText
   * 308 = BarcodeFullText
   * 309 = RichTextFullText
   * 400 = MailroomConfiguration
   * 401 = MailroomRule
   * 402 = MailroomField
   * 500 = CapturePlus
   */
  entityId?: MStoreEntityId;
  isLockedByCurrentSessionId?: boolean;
}

export interface OrderByModel {
  field?: string | null;
  /**
   *
   * 0 = Asc
   * 1 = Desc
   */
  orderByType?: OrderByType;
}

/**
* 

0 = Asc

1 = Desc
* @format int32
*/
export enum OrderByType {
  Asc = 0,
  Desc = 1
}

export interface OrganisationCreateModel {
  name?: string | null;
}

export interface OrganisationModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  isDeactivated?: boolean;
  defaultRole?: RoleModel;
  canEdit?: boolean;
}

export interface OrganisationUpdateModel {
  name?: string | null;
  isDeactivated?: boolean;
}

export interface PaginationOptionsModel {
  /** @format int32 */
  minValue?: number;
  /** @format int32 */
  maxValue?: number;
  /** @format int32 */
  defaultValue?: number;
  /** @format int32 */
  incrementBy?: number;
}

/**
* 

0 = None

1 = In

2 = Out

4 = Lcid

8 = Retval

16 = Optional

4096 = HasDefault

8192 = HasFieldMarshal

16384 = Reserved3

32768 = Reserved4

61440 = ReservedMask
* @format int32
*/
export enum ParameterAttributes {
  None = 0,
  In = 1,
  Out = 2,
  Lcid = 4,
  Retval = 8,
  Optional = 16,
  HasDefault = 4096,
  HasFieldMarshal = 8192,
  Reserved3 = 16384,
  Reserved4 = 32768,
  ReservedMask = 61440
}

export interface ParameterInfo {
  /**
   *
   * 0 = None
   * 1 = In
   * 2 = Out
   * 4 = Lcid
   * 8 = Retval
   * 16 = Optional
   * 4096 = HasDefault
   * 8192 = HasFieldMarshal
   * 16384 = Reserved3
   * 32768 = Reserved4
   * 61440 = ReservedMask
   */
  attributes?: ParameterAttributes;
  member?: MemberInfo;
  name?: string | null;
  parameterType?: Type;
  /** @format int32 */
  position?: number;
  isIn?: boolean;
  isLcid?: boolean;
  isOptional?: boolean;
  isOut?: boolean;
  isRetval?: boolean;
  defaultValue?: any;
  rawDefaultValue?: any;
  hasDefaultValue?: boolean;
  customAttributes?: CustomAttributeData[] | null;
  /** @format int32 */
  metadataToken?: number;
}

/**
* 

0 = Sha1

1 = Sha1AndBCrypt

2 = BCrypt
* @format int32
*/
export enum PasswordHashType {
  Sha1 = 0,
  Sha1AndBCrypt = 1,
  BCrypt = 2
}

/**
* 

0 = None

1 = Allow

2 = Deny
* @format int32
*/
export enum PermissionValue {
  None = 0,
  Allow = 1,
  Deny = 2
}

export interface PrivateKeyUpdateModel {
  privateKey?: string | null;
}

/**
* 

0 = None

512 = SpecialName

1024 = RTSpecialName

4096 = HasDefault

8192 = Reserved2

16384 = Reserved3

32768 = Reserved4

62464 = ReservedMask
* @format int32
*/
export enum PropertyAttributes {
  None = 0,
  SpecialName = 512,
  RTSpecialName = 1024,
  HasDefault = 4096,
  Reserved2 = 8192,
  Reserved3 = 16384,
  Reserved4 = 32768,
  ReservedMask = 62464
}

export interface PropertyInfo {
  name?: string | null;
  declaringType?: Type;
  reflectedType?: Type;
  module?: Module;
  customAttributes?: CustomAttributeData[] | null;
  isCollectible?: boolean;
  /** @format int32 */
  metadataToken?: number;
  /**
   *
   * 1 = Constructor
   * 2 = Event
   * 4 = Field
   * 8 = Method
   * 16 = Property
   * 32 = TypeInfo
   * 64 = Custom
   * 128 = NestedType
   * 191 = All
   */
  memberType?: MemberTypes;
  propertyType?: Type;
  /**
   *
   * 0 = None
   * 512 = SpecialName
   * 1024 = RTSpecialName
   * 4096 = HasDefault
   * 8192 = Reserved2
   * 16384 = Reserved3
   * 32768 = Reserved4
   * 62464 = ReservedMask
   */
  attributes?: PropertyAttributes;
  isSpecialName?: boolean;
  canRead?: boolean;
  canWrite?: boolean;
  getMethod?: MethodInfo;
  setMethod?: MethodInfo;
}

export interface QueueBackgroundTaskResultModel {
  /** @format int32 */
  userId?: number;
  endUserMessage?: string | null;
}

/**
* 

0 = Minute

1 = Hour
* @format int32
*/
export enum RecurrenceIntervalType {
  Minute = 0,
  Hour = 1
}

export interface RecurrenceModel {
  /**
   *
   * 0 = Minute
   * 1 = Hour
   */
  intervalType?: RecurrenceIntervalType;
  /** @format int32 */
  interval?: number;
  withinTimeWindow?: boolean;
  /** @format int32 */
  timeWindowFromHour?: number;
  /** @format int32 */
  timeWindowToHour?: number;
  onSpecificDays?: boolean;
  specificDays?: number[] | null;
  timeZoneCode?: string | null;
}

export interface ReferenceConfigurationModel {
  /**
   *
   * 1 = Common
   * 2 = Document
   */
  referenceType?: CabinetReferenceType;
  /** @format int32 */
  referenceNumber?: number;
  isDeleted?: boolean;
  storeReferenceConfiguration?: StoreReferenceConfigurationModel;
  searchReferenceConfiguration?: SearchReferenceConfigurationModel;
}

/**
* 

0 = UseFirstMatch

1 = Continue
* @format int32
*/
export enum ReferenceLookupMultiMatchOption {
  UseFirstMatch = 0,
  Continue = 1
}

/**
* 

0 = Continue

1 = ClearReferences
* @format int32
*/
export enum ReferenceLookupNoMatchOption {
  Continue = 0,
  ClearReferences = 1
}

export interface ReferenceLookupResultModel {
  references?: Record<string, string | null>;
  /** @format date-time */
  documentDate?: string | null;
  multiValueReferences?: DataTable;
  /**
   *
   * 0 = MatchFound
   * 1 = NoMatchFound
   * 2 = MultipleMatchesFound
   */
  resultType?: ReferenceLookupResultType;
  applyDocumentDate?: boolean;
  /**
   *
   * 0 = Continue
   * 1 = ClearReferences
   */
  noMatchOption?: ReferenceLookupNoMatchOption;
  /**
   *
   * 0 = UseFirstMatch
   * 1 = Continue
   */
  multiMatchOption?: ReferenceLookupMultiMatchOption;
}

/**
* 

0 = MatchFound

1 = NoMatchFound

2 = MultipleMatchesFound
* @format int32
*/
export enum ReferenceLookupResultType {
  MatchFound = 0,
  NoMatchFound = 1,
  MultipleMatchesFound = 2
}

export interface ReferenceLookupSearchModel {
  references?: Record<string, string | null>;
  multiValueReferences?: Record<string, string>[] | null;
  /** @format date-time */
  documentDate?: string | null;
}

/**
* 

0 = None

1 = SpecialLookupSql

2 = ShowExisting
* @format int32
*/
export enum ReferenceLookupType {
  None = 0,
  SpecialLookupSql = 1,
  ShowExisting = 2
}

/**
* 

0 = Common

1 = Document

2 = Display

3 = DocumentDate
* @format int32
*/
export enum ReferenceType {
  Common = 0,
  Document = 1,
  Display = 2,
  DocumentDate = 3
}

/**
* 

1 = AnyValue

2 = Numeric

3 = Alphanumeric

4 = Date
* @format int32
*/
export enum ReferenceValidationType {
  AnyValue = 1,
  Numeric = 2,
  Alphanumeric = 3,
  Date = 4
}

export interface RelatedDocumentModel {
  /** @format int32 */
  linkId?: number;
  targetDocumentType?: DocumentTypeModel;
  /** @format int32 */
  targetDocumentTypeId?: number;
  criteria?: string | null;
  documents?: DocumentDataModel[] | null;
  columns?: DataTableColumnsModel[] | null;
  columnIds?: number[] | null;
  data?: DataTable;
  /** @format int32 */
  documentCount?: number;
  visible?: boolean;
}

export interface RelatedDocumentViewModel {
  /** @format int32 */
  linkId?: number;
  documentSearchModel?: BaseDocumentSearchModel;
  documentType?: DocumentTypeModel;
}

export interface RelatedDocumentsModel {
  relatedDocuments?: RelatedDocumentModel[] | null;
  columns?: DataTableColumnsModel[] | null;
  documentTypes?: DocumentTypeModel[] | null;
  /** @format int32 */
  count?: number;
}

/**
* 

1 = None

2 = Days

3 = Weeks

4 = Months

5 = Years
* @format int32
*/
export enum RetentionPeriodType {
  None = 1,
  Days = 2,
  Weeks = 3,
  Months = 4,
  Years = 5
}

/**
* 

0 = None

1 = AutomaticDeletion

2 = ReviewForDeletion
* @format int32
*/
export enum RetentionType {
  None = 0,
  AutomaticDeletion = 1,
  ReviewForDeletion = 2
}

export interface RetentionTypeEnumModel {
  /**
   *
   * 0 = None
   * 1 = AutomaticDeletion
   * 2 = ReviewForDeletion
   */
  value?: RetentionType;
  name?: string | null;
}

export interface RoleCopyModel {
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  copyRoleId?: number;
}

export interface RoleCreateModel {
  name?: string | null;
  description?: string | null;
}

export interface RoleModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  description?: string | null;
  isActiveDirectorySynched?: boolean;
  isStandard?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  organisations?: OrganisationModel[] | null;
  externallyManaged?: boolean;
}

export interface RoleUpdateModel {
  name?: string | null;
  description?: string | null;
  externallyManaged?: boolean;
}

export interface RoleUsersUpdateModel {
  role?: RoleModel;
  users?: UserModel[] | null;
}

export interface RuntimeFieldHandle {
  value?: IntPtr;
}

export interface RuntimeMethodHandle {
  value?: IntPtr;
}

export interface RuntimeTypeHandle {
  value?: IntPtr;
}

export interface SalesPackTabModel {
  /** @format int32 */
  documentTypeId?: number;
  mstoreRowName?: string | null;
  include?: boolean;
  comments?: string | null;
  documentMetaDataReferenceKey?: string | null;
  relatedDocument?: RelatedDocumentViewModel;
  isWorkflowJobDocument?: boolean;
}

export interface SavedSearchModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  roleName?: string | null;
  /** @format date-time */
  createdDate?: string;
  searchCriteria?: string | null;
  /**
   *
   * 0 = Saved
   * 1 = Recent
   */
  searchType?: SavedSearchType;
}

/**
* 

0 = Saved

1 = Recent
* @format int32
*/
export enum SavedSearchType {
  Saved = 0,
  Recent = 1
}

/**
* 

1 = IncludeSchema

2 = ExcludeSchema
* @format int32
*/
export enum SchemaSerializationMode {
  IncludeSchema = 1,
  ExcludeSchema = 2
}

export interface ScriveAccessCredentialsModel {
  username?: string | null;
  password?: string | null;
}

export interface ScriveFlowApiCallbackResponseModel {
  flowInstanceId?: string | null;
  statusType?: string | null;
}

export interface ScriveGroupActionModel {
  jobIds?: number[] | null;
  /**
   *
   * 0 = ReturnToPrepare
   * 1 = Cancel
   * 2 = SendForSigning
   * 3 = CancelSigning
   */
  processingAction?: ScriveStandardProcessingAction;
  cancelSigningReason?: string | null;
}

export interface ScriveSettingsConfigurationModel {
  /** @format int32 */
  documentTypeId?: number | null;
  settings?: ScriveSettingsModel;
  documentTypes?: DocumentTypeModel[] | null;
}

export interface ScriveSettingsModel {
  expiryEnabled?: boolean;
  /** @format int32 */
  expireAfterDays?: number;
  remindersEnabled?: boolean;
  /** @format int32 */
  remindAfterDays?: number;
  emailSubject?: string | null;
  emailMessage?: string | null;
}

export interface ScriveSignersDataSourceModel {
  key?: string | null;
  fields?: Record<string, any>;
}

export interface ScriveSignersTabModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  scriveSignersDataSource?: WorkflowDataSourceModel;
  dynamicForm?: DynamicFormModel;
}

export type ScriveSigningModel = object;

/**
* 

0 = ReturnToPrepare

1 = Cancel

2 = SendForSigning

3 = CancelSigning
* @format int32
*/
export enum ScriveStandardProcessingAction {
  ReturnToPrepare = 0,
  Cancel = 1,
  SendForSigning = 2,
  CancelSigning = 3
}

export interface ScriveSubmitDocumentsForSigningResultModel {
  flowId?: string | null;
  scriveStatus?: string | null;
  documents?: Record<string, string | null>;
}

export interface ScriveTemplateConfigurationModel {
  /** @format int32 */
  templateId?: number | null;
  keyBusinessReferenceField?: string | null;
  documentType?: DocumentTypeModel;
  template?: ScriveTemplateModel;
}

export interface ScriveTemplateModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  documentTypeId?: number;
  keyBusinessReferenceField?: string | null;
  template?: string | null;
  canDelete?: boolean;
  templateSigningParties?: ScriveTemplateSigningPartyModel[] | null;
}

export interface ScriveTemplateSigningPartyConfigurationModel {
  templateSigningParty?: ScriveTemplateSigningPartyModel;
  signerRoles?: ArenaSignSignerRoleModel[] | null;
}

export interface ScriveTemplateSigningPartyCreateUpdateModel {
  /** @format int32 */
  documentTypeId?: number;
  /** @format int32 */
  templateId?: number;
  /** @format int32 */
  signerRoleId?: number;
  description?: string | null;
}

export interface ScriveTemplateSigningPartyFieldCreateUpdateModel {
  /** @format int32 */
  templateSigningPartyId?: number;
  description?: string | null;
  fieldName?: string | null;
  type?: string | null;
}

export interface ScriveTemplateSigningPartyFieldModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  templateSigningPartyId?: number;
  type?: string | null;
  description?: string | null;
  fieldName?: string | null;
  required?: boolean;
  canDelete?: boolean;
  templateSigningPartyFieldPlacements?: ScriveTemplateSigningPartyFieldPlacementModel[] | null;
}

export interface ScriveTemplateSigningPartyFieldPlacementCreateUpdateModel {
  /** @format int32 */
  templateSigningPartyFieldId?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format double */
  relativeXPosition?: number;
  /** @format double */
  relativeYPosition?: number;
  /** @format double */
  relativeWidth?: number;
  /** @format double */
  relativeHeight?: number;
  /** @format double */
  relativeFontSize?: number;
  /**
   *
   * 0 = FromStart
   * 1 = FromEnd
   */
  pageNumberLocationType?: SignaturePageNumberLocationType;
  tip?: string | null;
}

export interface ScriveTemplateSigningPartyFieldPlacementModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  templateSigningPartyFieldId?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format double */
  relativeXPosition?: number;
  /** @format double */
  relativeYPosition?: number;
  /** @format double */
  relativeWidth?: number;
  /** @format double */
  relativeHeight?: number;
  /** @format double */
  relativeFontSize?: number;
  tip?: string | null;
  /**
   *
   * 0 = FromStart
   * 1 = FromEnd
   */
  pageNumberLocationType?: SignaturePageNumberLocationType;
  canDelete?: boolean;
}

export interface ScriveTemplateSigningPartyModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  templateId?: number;
  /** @format int32 */
  signerRoleId?: number;
  signerRoleDescription?: string | null;
  description?: string | null;
  canDelete?: boolean;
  templateSigningPartyFields?: ScriveTemplateSigningPartyFieldModel[] | null;
}

export interface ScriveTemplatesConfigurationModel {
  /** @format int32 */
  documentTypeId?: number | null;
  keyBusinessReferenceField?: string | null;
  documentTypes?: DocumentTypeModel[] | null;
  templates?: ScriveTemplateModel[] | null;
}

export interface SearchBuilderModel {
  cabinets?: SearchCabinetModel[] | null;
  /**
   *
   * 0 = VisibleNotChecked
   * 1 = VisibleAndChecked
   * 2 = Hidden
   */
  fullTextSearchSetting?: FullTextSearchSettingType;
}

export interface SearchCabinetModel {
  id: string | null;
  description: string | null;
  documentTypes?: SearchDocumentTypeModel[] | null;
  isFullTextSearchEnabled?: boolean;
}

export interface SearchDocumentTypeModel {
  /** @format int32 */
  id: number;
  description: string | null;
}

export interface SearchOptionsModel {
  /** @format int32 */
  resultsLimit?: number;
  showWorkflowJobInSearchResults?: boolean;
}

export interface SearchReferenceConfigurationModel {
  /** @format int32 */
  referenceNumber?: number;
  /**
   *
   * 1 = EnterOnly
   * 2 = EnterAndDropdown
   * 3 = EnterAndSearch
   * 4 = DropdownOnly
   * 5 = SearchOnly
   * 6 = BarCode
   * 7 = ExistingValues
   * 8 = AutoIncrement
   * 9 = DropdownAndSearch
   */
  inputType?: InputType;
  upperCase?: boolean;
  visible?: boolean;
  /**
   *
   * 1 = AnyValue
   * 2 = Numeric
   * 3 = AlphaNumeric
   * 4 = Date
   * 5 = YesNo
   */
  validationType?: ValidationType;
  /** @format int32 */
  listId?: number | null;
}

export interface SearchReferenceModel {
  /** @format int32 */
  id: number;
  description: string | null;
  fieldKey: string | null;
  /**
   *
   * 0 = Text
   * 1 = Numeric
   * 2 = Date
   * 3 = Alphanumeric
   */
  validationType: SearchReferenceValidationType;
  /** @format int32 */
  listId?: number | null;
  uppercase?: boolean;
  fieldId?: string | null;
}

/**
* 

0 = Text

1 = Numeric

2 = Date

3 = Alphanumeric
* @format int32
*/
export enum SearchReferenceValidationType {
  Text = 0,
  Numeric = 1,
  Date = 2,
  Alphanumeric = 3
}

export interface SearchRequestModel {
  anyReferenceCriteria?: AnyReferenceCriteriaModel;
  orderBy?: OrderByModel;
  cabinets?: CabinetCriteriaModel[] | null;
  isMultipleCabinetSearch?: boolean;
  criteria?: CriteriaModel[] | null;
  hasReferenceFieldCriteria?: boolean;
  fieldCabinetReferenceFieldCriteria?: boolean;
  fieldDocumentReferenceFieldCriteria?: boolean;
  documentDateRange?: DocumentDateRangeModel;
  fullTextSearchModel?: FullTextSearchModel;
}

export interface SearchResultsDocumentModel {
  cabinetId?: string | null;
  cabinet?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  documentType?: string | null;
  /** @format date-time */
  documentDate?: string;
  /** @format int32 */
  documentId?: number;
  /** @format int32 */
  pages?: number;
  /** @format int32 */
  queueId?: number | null;
  /** @format int32 */
  jobId?: number | null;
  hasNotes?: boolean;
  references?: Record<string, string | null>;
}

export interface SearchResultsModel {
  /** @format int64 */
  totalResultsCount?: number;
  /** @format int64 */
  resultsCount?: number;
  columns?: DataTableColumnsModel[] | null;
  documents?: SearchResultsDocumentModel[] | null;
  documentReferenceDescriptions?: Record<string, Record<string, string>>;
  commonReferenceDescriptions?: Record<string, Record<string, string>>;
  searchName?: string | null;
}

export interface SecurityConfigurationModel {
  entityName?: string | null;
  securityEntities?: SecurityEntityModel[] | null;
  securityPermissions?: SecurityPermissionModel[] | null;
}

export interface SecurityEntityModel {
  /** @format int32 */
  id?: number;
  entityName?: string | null;
  /**
   *
   * 0 = User
   * 1 = Role
   */
  type?: SecurityEntityType;
  permissions?: SecurityEntityPermissionModel[] | null;
}

export interface SecurityEntityPermissionModel {
  /** @format int32 */
  id?: number;
  /**
   *
   * 0 = None
   * 1 = Allow
   * 2 = Deny
   */
  access?: PermissionValue;
}

/**
* 

0 = User

1 = Role
* @format int32
*/
export enum SecurityEntityType {
  User = 0,
  Role = 1
}

export interface SecurityPermissionModel {
  /** @format int32 */
  id?: number;
  code?: string | null;
  description?: string | null;
}

/**
* 

0 = None

1 = Level1

2 = Level2
* @format int32
*/
export enum SecurityRuleSet {
  None = 0,
  Level1 = 1,
  Level2 = 2
}

/**
* 

0 = Xml

1 = Binary
* @format int32
*/
export enum SerializationFormat {
  Xml = 0,
  Binary = 1
}

export interface SettingsConfigurationModel {
  /** @format int32 */
  documentTypeId?: number | null;
  settings?: SettingsModel;
  documentTypes?: DocumentTypeModel[] | null;
}

export interface SettingsModel {
  expiryEnabled?: boolean;
  expireAfterDays?: string | null;
  beforeExpiryWarningDays?: string | null;
  remindersEnabled?: boolean;
  reminderDelayDays?: string | null;
  reminderFrequencyDays?: string | null;
  emailSubject?: string | null;
}

export interface SignatureCreateModel {
  /** @format int32 */
  signatureSettingId?: number;
  signatureBase64?: string | null;
}

/**
* 

0 = FromStart

1 = FromEnd
* @format int32
*/
export enum SignaturePageNumberLocationType {
  FromStart = 0,
  FromEnd = 1
}

export interface SignatureReferenceFieldModel {
  referenceField?: string | null;
}

export interface SignatureSettingModel {
  /** @format int32 */
  id?: number;
  label?: string | null;
  isSigned?: boolean;
  /** @format int32 */
  height?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  pageNumber?: number;
}

export interface SignatureTemplateModel {
  /** @format int32 */
  id?: number;
  signatureSettings?: SignatureSettingModel[] | null;
  canSign?: boolean;
}

export interface SignerRoleCreateUpdateModel {
  description?: string | null;
  common?: boolean;
  enter?: boolean;
  useDataSourceForName?: boolean;
  nameDataSourceKey?: string | null;
  nameDataFieldKey?: string | null;
  useDataSourceForEmailAddress?: boolean;
  emailAddressDataSourceKey?: string | null;
  emailAddressDataFieldKey?: string | null;
  useListForNameAndEmailAddress?: boolean;
  /**
   *
   * 0 = Standard
   * 1 = SMS
   * 2 = OnFido
   */
  authenticationType?: ArenaSignAuthenticationTypes;
  useDataSourceForMobile?: boolean;
  mobileDataSourceKey?: string | null;
  mobileDataFieldKey?: string | null;
  /** @format int32 */
  listId?: number | null;
  mustBeSameRecipientWithinEnvelope?: boolean;
}

export interface SignerRolesConfigurationModel {
  /** @format int32 */
  documentTypeId?: number | null;
  signerRoles?: ArenaSignSignerRoleModel[] | null;
  documentTypes?: DocumentTypeModel[] | null;
}

export interface SignersDataSourceModel {
  key?: string | null;
  fields?: Record<string, any>;
}

export interface SignersTabModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  signersDataSource?: WorkflowDataSourceModel;
  dynamicForm?: DynamicFormModel;
}

export interface SimpleFieldModel {
  fieldName?: string | null;
  dataSourceKey?: string | null;
}

export interface SingleSignOnConfigurationModel {
  authClients?: AuthClientConfigurationModel[] | null;
  isSingleSignOnEnabled?: boolean;
}

export interface SingleSignOnUserConfigurationModel {
  isSingleSignOnEnabled?: boolean;
  authClients?: AuthClientModel[] | null;
}

export interface SortVersion {
  /** @format int32 */
  fullVersion?: number;
  /** @format uuid */
  sortId?: string;
}

export interface SourceDocumentTypeSettingsModel {
  setFocusToDocumentTypeAfterStore?: boolean;
}

export interface SqlListConfigurationModel {
  /** @format int32 */
  id?: number;
  description?: string | null;
  initialListSql?: string | null;
}

export interface StockNumberModel {
  isOnKerridge?: boolean;
  /** @format int32 */
  workflowJobId?: number | null;
  workflowJobExists?: boolean;
}

export interface StoreDocumentModel {
  sourceDocumentTypeSettings?: SourceDocumentTypeSettingsModel;
  fileExtension?: string | null;
  lock?: LockModel;
  componentName?: string | null;
  errorModel?: ErrorModel;
  status?: string | null;
  /** @format int32 */
  statusMaximumLength?: number;
  isInWorkflow?: boolean;
}

export interface StoreReferenceConfigurationModel {
  /** @format int32 */
  referenceNumber?: number;
  /**
   *
   * 1 = EnterOnly
   * 2 = EnterAndDropdown
   * 3 = EnterAndSearch
   * 4 = DropdownOnly
   * 5 = SearchOnly
   * 6 = BarCode
   * 7 = ExistingValues
   * 8 = AutoIncrement
   * 9 = DropdownAndSearch
   */
  inputType?: InputType;
  upperCase?: boolean;
  visible?: boolean;
  /**
   *
   * 1 = AnyValue
   * 2 = Numeric
   * 3 = AlphaNumeric
   * 4 = Date
   * 5 = YesNo
   */
  validationType?: ValidationType;
  /** @format int32 */
  listId?: number | null;
  useDefaults?: boolean | null;
  lookup?: boolean;
  required?: boolean;
  mustExistInList?: boolean | null;
  fixedLength?: boolean;
  /** @format int32 */
  requiredLength?: number | null;
}

export interface StructLayoutAttribute {
  typeId?: any;
  /**
   *
   * 0 = Sequential
   * 2 = Explicit
   * 3 = Auto
   */
  value?: LayoutKind;
}

export interface TargetDocumentTypeSettingsModel {
  clearGridAfterUpdate?: boolean;
  retainCommonReferenceValues?: boolean;
  retainDocumentReferenceValues?: boolean;
  clearDocumentDate?: boolean;
  /**
   *
   * 0 = None
   * 1 = SpecialLookupSql
   * 2 = ShowExisting
   */
  referenceLookupType?: ReferenceLookupType;
  lookupReferencesKeys?: string[] | null;
}

export interface TaskService {
  /** @format int32 */
  id?: number;
  queueName?: string | null;
  name?: string | null;
  description?: string | null;
  enabled?: boolean;
  /**
   *
   * 0 = Recurring
   */
  runType?: TaskServiceRunType;
  jobQueueName?: string | null;
  customSettingsComponent?: string | null;
  hasEncryptedSettings?: boolean;
  serviceQueueHosts?: TaskServiceHostService[] | null;
  serviceJobHosts?: TaskServiceHostService[] | null;
}

export interface TaskServiceHost {
  /** @format int32 */
  id?: number;
  hostName?: string | null;
  /** @format int32 */
  logicalProcessorCount?: number;
  /** @format date-time */
  heartbeatExpiration?: string | null;
  taskServiceHostServices?: TaskServiceHostService[] | null;
}

export interface TaskServiceHostService {
  /** @format int32 */
  id?: number;
  hostName?: string | null;
  queueName?: string | null;
  /** @format int32 */
  workers?: number;
  taskServiceHost?: TaskServiceHost;
}

/**
* 

0 = Recurring
* @format int32
*/
export enum TaskServiceRunType {
  Recurring = 0
}

export interface TaskServiceSettingsConfigurationModel {
  /** @format int32 */
  configurationChangeId?: number | null;
  taskServiceSettings?: BaseTaskServiceSettingsModel;
  taskService?: TaskService;
  hosts?: TaskServiceHostService[] | null;
  defaultRecurrence?: RecurrenceModel;
  /** @format int32 */
  minimumEnqueuedJobLimit?: number;
  /** @format int32 */
  maximumEnqueuedJobLimit?: number;
}

export interface TaskServicesGlobalConfigurationModel {
  /** @format int32 */
  configurationChangeId?: number | null;
  notificationsEnabled?: boolean;
  notificationEmail?: string | null;
  /** @format int32 */
  notificationLimit?: number;
  /** @format int32 */
  notificationIntervalMinutes?: number;
}

export interface TemplateAdditionalDocumentConfigurationModel {
  /** @format int32 */
  documentTypeId?: number;
  /** @format int32 */
  templateId?: number;
  /** @format int32 */
  additionalDocumentFileId?: number | null;
  /** @format int32 */
  templateAdditionalDocumentId?: number | null;
  signerRoles?: ArenaSignSignerRoleModel[] | null;
  additionalDocumentFiles?: AdditionalDocumentFileModel[] | null;
  templateAdditionalDocument?: TemplateAdditionalDocumentModel;
}

export interface TemplateAdditionalDocumentCreateUpdateModel {
  /** @format int32 */
  documentTypeId?: number;
  /** @format int32 */
  templateId?: number;
  /** @format int32 */
  additionalDocumentFileId?: number;
  templateAdditionalDocumentSignHeres?: TemplateAdditionalDocumentSignHereCreateUpdateModel[] | null;
}

export interface TemplateAdditionalDocumentModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  templateId?: number;
  additionalDocumentFile?: AdditionalDocumentFileModel;
  signHeres?: TemplateAdditionalDocumentSignHereModel[] | null;
  canDelete?: boolean;
}

export interface TemplateAdditionalDocumentSignHereCreateUpdateModel {
  /** @format int32 */
  additionalDocumentSignTabId?: number;
  /** @format int32 */
  signerRoleId?: number;
}

export interface TemplateAdditionalDocumentSignHereModel {
  additionalDocumentSignTab?: AdditionalDocumentSignTabModel;
  signerRole?: ArenaSignSignerRoleModel;
}

export interface TemplateAfterSignSettingConfigurationModel {
  templateAfterSignSetting?: TemplateAfterSignSettingModel;
  targetCabinets?: CabinetModel[] | null;
}

export interface TemplateAfterSignSettingConfigurationUpdateModel {
  /** @format int32 */
  id?: number;
  sourceDocumentType?: DocumentTypeModel;
  targetCabinet?: CabinetModel;
  targetDocumentType?: DocumentTypeModel;
  /**
   *
   * 1 = NewDocument
   * 2 = NewVersion
   */
  indexAction?: ArenaSignIndexAction;
  referenceMappings?: Record<string, number>;
}

export interface TemplateAfterSignSettingModel {
  /** @format int32 */
  id?: number;
  templateName?: string | null;
  sourceDocumentType?: DocumentTypeModel;
  targetCabinet?: CabinetModel;
  targetDocumentType?: DocumentTypeModel;
  templateType?: string | null;
  additionalDocumentFileDescription?: string | null;
  /**
   *
   * 1 = NewDocument
   * 2 = NewVersion
   */
  indexAction?: ArenaSignIndexAction;
  referenceMappings?: TemplateAfterSignSettingReferenceMappingModel[] | null;
}

export interface TemplateAfterSignSettingReferenceMappingModel {
  /** @format int32 */
  afterSignSettingId?: number;
  /** @format int32 */
  signedReferenceNumber?: number;
  signedReferenceType?: string | null;
  /** @format int32 */
  targetReferenceNumber?: number;
  targetReferenceType?: string | null;
}

export interface TemplateSignHereConfigurationModel {
  templateSignHere?: TemplateSignHereModel;
  signerRoles?: ArenaSignSignerRoleModel[] | null;
}

export interface TemplateSignHereCreateUpdateModel {
  tabName?: string | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  xCoord?: number;
  /** @format int32 */
  yCoord?: number;
  /** @format int32 */
  dateSignedXCoord?: number | null;
  /** @format int32 */
  dateSignedYCoord?: number | null;
  includeDateSigned?: boolean;
  /** @format int32 */
  templateId?: number;
  /** @format int32 */
  signerRoleId?: number;
}

export interface TemplateSignHereModel {
  tabName?: string | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  xCoord?: number;
  /** @format int32 */
  yCoord?: number;
  /** @format int32 */
  dateSignedXCoord?: number | null;
  /** @format int32 */
  dateSignedYCoord?: number | null;
  includeDateSigned?: boolean;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  templateId?: number;
  /** @format int32 */
  signerRoleId?: number;
  arenaSignSignerRole?: ArenaSignSignerRoleModel;
}

export interface TextInfo {
  /** @format int32 */
  ansiCodePage?: number;
  /** @format int32 */
  oemCodePage?: number;
  /** @format int32 */
  macCodePage?: number;
  /** @format int32 */
  ebcdicCodePage?: number;
  /** @format int32 */
  lcid?: number;
  cultureName?: string | null;
  isReadOnly?: boolean;
  listSeparator?: string | null;
  isRightToLeft?: boolean;
}

export interface ThumbnailViewModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  documentData?: string | null;
  /** @format int32 */
  page?: number;
}

export interface ToolsModel {
  canAccessHr?: boolean;
  canAccessDealCopyTool?: boolean;
  canAccessLeaversTool?: boolean;
  canAccessRemoveLocksTool?: boolean;
  canAccessSystemTool?: boolean;
  canAccessCacheSettings?: boolean;
  canAccessDocumentRetention?: boolean;
  canAccessExceptionalJobs?: boolean;
  canGenerateExceptionalJobs?: boolean;
  canAccessCustomTools?: Record<string, boolean>;
}

export interface TraceDataItem {
  key?: string | null;
  value?: string | null;
}

/**
* 

0 = Exception

1 = Information
* @format int32
*/
export enum TraceEventType {
  Exception = 0,
  Information = 1
}

/**
* 

1 = Error

2 = Verbose
* @format int32
*/
export enum TraceLevel {
  Error = 1,
  Verbose = 2
}

export interface TraceModel {
  /** @format int64 */
  id?: number;
  entity?: string | null;
  /** @format int32 */
  entityPk?: number;
  /**
   *
   * 0 = Exception
   * 1 = Information
   */
  eventType?: TraceEventType;
  message?: string | null;
  /**
   *
   * 1 = Error
   * 2 = Verbose
   */
  level?: TraceLevel;
  component?: string | null;
  data?: TraceDataItem[] | null;
  /** @format date-time */
  loggedDate?: string;
  host?: string | null;
}

export interface Type {
  name?: string | null;
  customAttributes?: CustomAttributeData[] | null;
  isCollectible?: boolean;
  /** @format int32 */
  metadataToken?: number;
  isInterface?: boolean;
  /**
   *
   * 1 = Constructor
   * 2 = Event
   * 4 = Field
   * 8 = Method
   * 16 = Property
   * 32 = TypeInfo
   * 64 = Custom
   * 128 = NestedType
   * 191 = All
   */
  memberType?: MemberTypes;
  namespace?: string | null;
  assemblyQualifiedName?: string | null;
  fullName?: string | null;
  assembly?: Assembly;
  module?: Module;
  isNested?: boolean;
  declaringType?: Type;
  declaringMethod?: MethodBase;
  reflectedType?: Type;
  underlyingSystemType?: Type;
  isTypeDefinition?: boolean;
  isArray?: boolean;
  isByRef?: boolean;
  isPointer?: boolean;
  isConstructedGenericType?: boolean;
  isGenericParameter?: boolean;
  isGenericTypeParameter?: boolean;
  isGenericMethodParameter?: boolean;
  isGenericType?: boolean;
  isGenericTypeDefinition?: boolean;
  isSZArray?: boolean;
  isVariableBoundArray?: boolean;
  isByRefLike?: boolean;
  isFunctionPointer?: boolean;
  isUnmanagedFunctionPointer?: boolean;
  hasElementType?: boolean;
  genericTypeArguments?: Type[] | null;
  /** @format int32 */
  genericParameterPosition?: number;
  /**
   *
   * 0 = None
   * 1 = Covariant
   * 2 = Contravariant
   * 3 = VarianceMask
   * 4 = ReferenceTypeConstraint
   * 8 = NotNullableValueTypeConstraint
   * 16 = DefaultConstructorConstraint
   * 28 = SpecialConstraintMask
   */
  genericParameterAttributes?: GenericParameterAttributes;
  /**
   *
   * 0 = Class
   * 1 = Public
   * 2 = NestedPublic
   * 3 = NestedPrivate
   * 4 = NestedFamily
   * 5 = NestedAssembly
   * 6 = NestedFamANDAssem
   * 7 = NestedFamORAssem
   * 8 = SequentialLayout
   * 16 = ExplicitLayout
   * 24 = LayoutMask
   * 32 = ClassSemanticsMask
   * 128 = Abstract
   * 256 = Sealed
   * 1024 = SpecialName
   * 2048 = RTSpecialName
   * 4096 = Import
   * 8192 = Serializable
   * 16384 = WindowsRuntime
   * 65536 = UnicodeClass
   * 131072 = AutoClass
   * 196608 = CustomFormatClass
   * 262144 = HasSecurity
   * 264192 = ReservedMask
   * 1048576 = BeforeFieldInit
   * 12582912 = CustomFormatMask
   */
  attributes?: TypeAttributes;
  isAbstract?: boolean;
  isImport?: boolean;
  isSealed?: boolean;
  isSpecialName?: boolean;
  isClass?: boolean;
  isNestedAssembly?: boolean;
  isNestedFamANDAssem?: boolean;
  isNestedFamily?: boolean;
  isNestedFamORAssem?: boolean;
  isNestedPrivate?: boolean;
  isNestedPublic?: boolean;
  isNotPublic?: boolean;
  isPublic?: boolean;
  isAutoLayout?: boolean;
  isExplicitLayout?: boolean;
  isLayoutSequential?: boolean;
  isAnsiClass?: boolean;
  isAutoClass?: boolean;
  isUnicodeClass?: boolean;
  isCOMObject?: boolean;
  isContextful?: boolean;
  isEnum?: boolean;
  isMarshalByRef?: boolean;
  isPrimitive?: boolean;
  isValueType?: boolean;
  isSignatureType?: boolean;
  isSecurityCritical?: boolean;
  isSecuritySafeCritical?: boolean;
  isSecurityTransparent?: boolean;
  structLayoutAttribute?: StructLayoutAttribute;
  typeInitializer?: ConstructorInfo;
  typeHandle?: RuntimeTypeHandle;
  /** @format uuid */
  guid?: string;
  baseType?: Type;
  /** @deprecated */
  isSerializable?: boolean;
  containsGenericParameters?: boolean;
  isVisible?: boolean;
}

/**
* 

0 = Class

1 = Public

2 = NestedPublic

3 = NestedPrivate

4 = NestedFamily

5 = NestedAssembly

6 = NestedFamANDAssem

7 = NestedFamORAssem

8 = SequentialLayout

16 = ExplicitLayout

24 = LayoutMask

32 = ClassSemanticsMask

128 = Abstract

256 = Sealed

1024 = SpecialName

2048 = RTSpecialName

4096 = Import

8192 = Serializable

16384 = WindowsRuntime

65536 = UnicodeClass

131072 = AutoClass

196608 = CustomFormatClass

262144 = HasSecurity

264192 = ReservedMask

1048576 = BeforeFieldInit

12582912 = CustomFormatMask
* @format int32
*/
export enum TypeAttributes {
  Class = 0,
  Public = 1,
  NestedPublic = 2,
  NestedPrivate = 3,
  NestedFamily = 4,
  NestedAssembly = 5,
  NestedFamANDAssem = 6,
  NestedFamORAssem = 7,
  SequentialLayout = 8,
  ExplicitLayout = 16,
  LayoutMask = 24,
  ClassSemanticsMask = 32,
  Abstract = 128,
  Sealed = 256,
  SpecialName = 1024,
  RTSpecialName = 2048,
  Import = 4096,
  Serializable = 8192,
  WindowsRuntime = 16384,
  UnicodeClass = 65536,
  AutoClass = 131072,
  CustomFormatClass = 196608,
  HasSecurity = 262144,
  ReservedMask = 264192,
  BeforeFieldInit = 1048576,
  CustomFormatMask = 12582912
}

export interface TypeInfo {
  name?: string | null;
  customAttributes?: CustomAttributeData[] | null;
  isCollectible?: boolean;
  /** @format int32 */
  metadataToken?: number;
  isInterface?: boolean;
  /**
   *
   * 1 = Constructor
   * 2 = Event
   * 4 = Field
   * 8 = Method
   * 16 = Property
   * 32 = TypeInfo
   * 64 = Custom
   * 128 = NestedType
   * 191 = All
   */
  memberType?: MemberTypes;
  namespace?: string | null;
  assemblyQualifiedName?: string | null;
  fullName?: string | null;
  assembly?: Assembly;
  module?: Module;
  isNested?: boolean;
  declaringType?: Type;
  declaringMethod?: MethodBase;
  reflectedType?: Type;
  underlyingSystemType?: Type;
  isTypeDefinition?: boolean;
  isArray?: boolean;
  isByRef?: boolean;
  isPointer?: boolean;
  isConstructedGenericType?: boolean;
  isGenericParameter?: boolean;
  isGenericTypeParameter?: boolean;
  isGenericMethodParameter?: boolean;
  isGenericType?: boolean;
  isGenericTypeDefinition?: boolean;
  isSZArray?: boolean;
  isVariableBoundArray?: boolean;
  isByRefLike?: boolean;
  isFunctionPointer?: boolean;
  isUnmanagedFunctionPointer?: boolean;
  hasElementType?: boolean;
  genericTypeArguments?: Type[] | null;
  /** @format int32 */
  genericParameterPosition?: number;
  /**
   *
   * 0 = None
   * 1 = Covariant
   * 2 = Contravariant
   * 3 = VarianceMask
   * 4 = ReferenceTypeConstraint
   * 8 = NotNullableValueTypeConstraint
   * 16 = DefaultConstructorConstraint
   * 28 = SpecialConstraintMask
   */
  genericParameterAttributes?: GenericParameterAttributes;
  /**
   *
   * 0 = Class
   * 1 = Public
   * 2 = NestedPublic
   * 3 = NestedPrivate
   * 4 = NestedFamily
   * 5 = NestedAssembly
   * 6 = NestedFamANDAssem
   * 7 = NestedFamORAssem
   * 8 = SequentialLayout
   * 16 = ExplicitLayout
   * 24 = LayoutMask
   * 32 = ClassSemanticsMask
   * 128 = Abstract
   * 256 = Sealed
   * 1024 = SpecialName
   * 2048 = RTSpecialName
   * 4096 = Import
   * 8192 = Serializable
   * 16384 = WindowsRuntime
   * 65536 = UnicodeClass
   * 131072 = AutoClass
   * 196608 = CustomFormatClass
   * 262144 = HasSecurity
   * 264192 = ReservedMask
   * 1048576 = BeforeFieldInit
   * 12582912 = CustomFormatMask
   */
  attributes?: TypeAttributes;
  isAbstract?: boolean;
  isImport?: boolean;
  isSealed?: boolean;
  isSpecialName?: boolean;
  isClass?: boolean;
  isNestedAssembly?: boolean;
  isNestedFamANDAssem?: boolean;
  isNestedFamily?: boolean;
  isNestedFamORAssem?: boolean;
  isNestedPrivate?: boolean;
  isNestedPublic?: boolean;
  isNotPublic?: boolean;
  isPublic?: boolean;
  isAutoLayout?: boolean;
  isExplicitLayout?: boolean;
  isLayoutSequential?: boolean;
  isAnsiClass?: boolean;
  isAutoClass?: boolean;
  isUnicodeClass?: boolean;
  isCOMObject?: boolean;
  isContextful?: boolean;
  isEnum?: boolean;
  isMarshalByRef?: boolean;
  isPrimitive?: boolean;
  isValueType?: boolean;
  isSignatureType?: boolean;
  isSecurityCritical?: boolean;
  isSecuritySafeCritical?: boolean;
  isSecurityTransparent?: boolean;
  structLayoutAttribute?: StructLayoutAttribute;
  typeInitializer?: ConstructorInfo;
  typeHandle?: RuntimeTypeHandle;
  /** @format uuid */
  guid?: string;
  baseType?: Type;
  /** @deprecated */
  isSerializable?: boolean;
  containsGenericParameters?: boolean;
  isVisible?: boolean;
  genericTypeParameters?: Type[] | null;
  declaredConstructors?: ConstructorInfo[] | null;
  declaredEvents?: EventInfo[] | null;
  declaredFields?: FieldInfo[] | null;
  declaredMembers?: MemberInfo[] | null;
  declaredMethods?: MethodInfo[] | null;
  declaredNestedTypes?: TypeInfo[] | null;
  declaredProperties?: PropertyInfo[] | null;
  implementedInterfaces?: Type[] | null;
}

export interface UpdateExceptionalJobConfigurationModel {
  /** @format int32 */
  id?: number;
  cabinetId?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  /**
   *
   * 1 = CreateNewVersion
   */
  versionType?: ExceptionalJobVersionType;
  enabled?: boolean;
}

export interface UpdateExceptionalJobsConfigurationModel {
  /** @format int32 */
  id?: number;
  cabinetId?: string | null;
  documentTypeIds?: number[] | null;
  /**
   *
   * 1 = CreateNewVersion
   */
  versionType?: ExceptionalJobVersionType;
  enabled?: boolean;
}

export interface UserCopyModel {
  username?: string | null;
  emailAddress?: string | null;
  name?: string | null;
  /** @format int32 */
  organisationId?: number;
  /** @format int32 */
  authClientId?: number | null;
  forceSingleSignOn?: boolean;
  /**
   *
   * 0 = Sha1
   * 1 = Sha1AndBCrypt
   * 2 = BCrypt
   */
  passwordHashType?: PasswordHashType;
  /** @format int32 */
  copyUserId?: number;
}

export interface UserCreateModel {
  username?: string | null;
  emailAddress?: string | null;
  name?: string | null;
  /** @format int32 */
  organisationId?: number;
  /** @format int32 */
  authClientId?: number | null;
  forceSingleSignOn?: boolean;
  /**
   *
   * 0 = Sha1
   * 1 = Sha1AndBCrypt
   * 2 = BCrypt
   */
  passwordHashType?: PasswordHashType;
}

export interface UserModel {
  /** @format int32 */
  id?: number;
  username?: string | null;
  emailAddress?: string | null;
  name?: string | null;
  domain?: string | null;
  windowsAuthentication?: boolean;
  passwordNeverExpires?: boolean;
  hasTemporaryPassword?: boolean;
  /**
   *
   * 0 = Sha1
   * 1 = Sha1AndBCrypt
   * 2 = BCrypt
   */
  passwordHashType?: PasswordHashType;
  isDeactivated?: boolean;
  canEdit?: boolean;
  /** @format int32 */
  defaultRoleId?: number;
  isLockedOut?: boolean;
  isInternalUser?: boolean;
  organisation?: OrganisationModel;
  roles?: RoleModel[] | null;
  /** @format int32 */
  authClientId?: number | null;
  authClient?: AuthClientModel;
  forceSingleSignOn?: boolean;
  externallyManaged?: boolean;
}

export interface UserNotificationModel {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  userId?: number;
  /** @format date-time */
  createdDate?: string;
  /**
   *
   * 0 = InProgress
   * 1 = Error
   * 2 = Warning
   * 3 = Success
   */
  status?: UserNotificationStatus;
  description?: string | null;
  isSeen?: boolean;
  isDeleted?: boolean;
  notificationMessage?: string | null;
  actionButtonLabel?: string | null;
  actionButtonLink?: string | null;
}

/**
* 

0 = InProgress

1 = Error

2 = Warning

3 = Success
* @format int32
*/
export enum UserNotificationStatus {
  InProgress = 0,
  Error = 1,
  Warning = 2,
  Success = 3
}

export interface UserRolesUpdateModel {
  user?: UserModel;
  roles?: RoleModel[] | null;
}

export interface UserUpdateModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  emailAddress?: string | null;
  username?: string | null;
  organisation?: OrganisationModel;
  domain?: string | null;
  windowsAuthentication?: boolean;
  passwordNeverExpires?: boolean;
  isDeactivated?: boolean;
  /** @format int32 */
  authClientId?: number | null;
  forceSingleSignOn?: boolean;
  externallyManaged?: boolean;
}

export interface UserWindowsAutoLogInModel {
  enabled?: boolean;
}

/**
* 

1 = AnyValue

2 = Numeric

3 = AlphaNumeric

4 = Date

5 = YesNo
* @format int32
*/
export enum ValidationType {
  AnyValue = 1,
  Numeric = 2,
  AlphaNumeric = 3,
  Date = 4,
  YesNo = 5
}

/**
* 

0 = AsNewVersionOfDocument

1 = AsAVersionOfDocument
* @format int32
*/
export enum VersionControlType {
  AsNewVersionOfDocument = 0,
  AsAVersionOfDocument = 1
}

/**
* 

0 = None

1 = ManualCheckedInOut

2 = ReIndexed

3 = HistoricVersion

4 = PagesChanged
* @format int32
*/
export enum VersionType {
  None = 0,
  ManualCheckedInOut = 1,
  ReIndexed = 2,
  HistoricVersion = 3,
  PagesChanged = 4
}

/**
* 

0 = None

1 = ViewRelatedDocument

2 = Tooltip

3 = CurrentDocument
* @format int32
*/
export enum WorkflowDataSourceFieldActionButtonType {
  None = 0,
  ViewRelatedDocument = 1,
  Tooltip = 2,
  CurrentDocument = 3
}

/**
* 

1 = String

2 = Integer

3 = Boolean

4 = DateTime

5 = Decimal

6 = Double

7 = Object

8 = Unknown
* @format int32
*/
export enum WorkflowDataSourceFieldDataType {
  String = 1,
  Integer = 2,
  Boolean = 3,
  DateTime = 4,
  Decimal = 5,
  Double = 6,
  Object = 7,
  Unknown = 8
}

export interface WorkflowDataSourceModel {
  key?: string | null;
  fields?: Record<string, any>;
}

export interface WorkflowFieldUpdateRuleModel {
  key?: string | null;
  description?: string | null;
  criteriaFields?: WorkflowRuleFieldModel[] | null;
  updateFields?: WorkflowRuleFieldModel[] | null;
}

export interface WorkflowJobAuditDataModel {
  auditData?: WorkflowJobAuditModel[] | null;
  auditColumns?: ColumnsModel[] | null;
}

export interface WorkflowJobAuditModel {
  /** @format date-time */
  date?: string;
  userFullName?: string | null;
  queueDescription?: string | null;
  fieldDescription?: string | null;
  oldValue?: any;
  newValue?: any;
}

export interface WorkflowJobButtonModel {
  id?: string | null;
  caption?: string | null;
  isConfigured?: boolean;
  isEnabled?: boolean;
  /**
   *
   * 0 = ProcessJob
   * 1 = ReturnJob
   * 2 = ExceptionJob
   * 3 = CancelJob
   * 4 = SaveJob
   */
  processingAction?: WorkflowStandardProcessingAction;
}

export interface WorkflowJobHistoryDataModel {
  historyData?: WorkflowJobHistoryModel[] | null;
  historyColumns?: ColumnsModel[] | null;
}

export interface WorkflowJobHistoryModel {
  /** @format date-time */
  eventDate?: string;
  userFullName?: string | null;
  historyType?: string | null;
  description?: string | null;
}

export interface WorkflowJobModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  /** @format int32 */
  jobId?: number;
  /** @format int32 */
  queueId?: number;
  documentSearchModel?: BaseDocumentSearchModel;
  jobComponentName?: string | null;
  queueComponentName?: string | null;
  workflowQueueConfiguration?: WorkflowQueueConfigurationModel;
  workflowDataSources?: WorkflowDataSourceModel[] | null;
  canProcess?: boolean;
  lockModel?: LockModel;
  errorModel?: ErrorModel;
  canGetNextJob?: boolean;
  documentDataSourceKey?: string | null;
}

export interface WorkflowJobPostProcessNavigationModel {
  /** @format int32 */
  queueId?: number;
  /** @format int32 */
  jobId?: number | null;
}

export interface WorkflowJobProcessModel {
  /**
   *
   * 0 = ProcessJob
   * 1 = ReturnJob
   * 2 = ExceptionJob
   * 3 = CancelJob
   * 4 = SaveJob
   */
  processingAction?: WorkflowStandardProcessingAction;
  workflowDataSources?: WorkflowDataSourceModel[] | null;
}

export interface WorkflowJobProcessResultModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  message?: string | null;
  success?: boolean;
  messageAcknowledgementRequired?: boolean;
  hasMessage?: boolean;
  postProcessNavigation?: WorkflowJobPostProcessNavigationModel;
}

export interface WorkflowJobSecondaryQueueModel {
  listQueueKey?: string | null;
  configurationQueueKey?: string | null;
}

export interface WorkflowJobTabFieldsModel {
  /** @format int32 */
  columnNumber?: number;
  dataSourceKey?: string | null;
  dataSourceFieldName?: string | null;
  isRequired?: boolean;
  isReadonly?: boolean;
  overwriteDataSourceActionButton?: boolean;
  /**
   *
   * 0 = None
   * 1 = ViewRelatedDocument
   * 2 = Tooltip
   * 3 = CurrentDocument
   */
  actionButtonType?: WorkflowDataSourceFieldActionButtonType;
  actionButtonTag?: string | null;
}

export interface WorkflowJobTabModel {
  /**
   *
   * 1 = Standard
   * 2 = Workflow
   * 3 = Custom
   */
  workflowJobTabType?: WorkflowJobTabType;
  /**
   *
   * 1 = Horizontal
   * 2 = Vertical
   */
  jobTabOrientation?: JobTabOrientation;
  componentName?: string | null;
  key?: string | null;
  description?: string | null;
  fields?: WorkflowJobTabFieldsModel[] | null;
  dynamicFormModel?: DynamicFormModel;
  preLoad?: boolean;
  hidden?: boolean;
}

/**
* 

1 = Standard

2 = Workflow

3 = Custom
* @format int32
*/
export enum WorkflowJobTabType {
  Standard = 1,
  Workflow = 2,
  Custom = 3
}

export interface WorkflowJobTabsToHideModel {
  saleType?: string | null;
  tabKeyToShow?: string | null;
  tabKeysToHide?: string[] | null;
}

export interface WorkflowJobTracingDataModel {
  traceData?: TraceModel[] | null;
  traceColumns?: ColumnsModel[] | null;
}

export interface WorkflowJobsEmailModel {
  jobIds?: number[] | null;
}

export interface WorkflowKanbanCardOrderResultModel {
  targetLane?: string | null;
  success?: boolean;
  message?: string | null;
}

export interface WorkflowKanbanCardOrderUpdateModel {
  sourceLane?: string | null;
  sourceLaneCardIds?: number[] | null;
  targetLane?: string | null;
  targetLaneCardIds?: number[] | null;
  /** @format int32 */
  sourceLaneCardIndex?: number | null;
  /** @format int32 */
  targetLaneCardIndex?: number | null;
  /** @format int32 */
  excludedCardIdFromTargetValidation?: number | null;
}

export interface WorkflowKanbanJobModel {
  optimisticLock?: OptimisticLockModel;
  mStoreDynamicForm?: MStoreDynamicFormModel;
}

export interface WorkflowKanbanJobMoveModel {
  /** @format date-time */
  readTime?: string;
}

export interface WorkflowKanbanJobProcessModel {
  /** @format date-time */
  readTime?: string;
  workflowDataSources?: WorkflowDataSourceModel[] | null;
}

export interface WorkflowKanbanJobProcessResultModel {
  workflowKanbanJob?: WorkflowKanbanJobModel;
  workflowJobProcessResult?: WorkflowJobProcessResultModel;
  /**
   *
   * 0 = UnableToAcquireLock
   * 1 = PopUpFieldsRequired
   * 2 = ProcessSuccessful
   * 3 = IllegalLaneMove
   */
  workflowKanbanJobProcessResultStatus?: WorkflowKanbanJobProcessResultStatus;
}

/**
* 

0 = UnableToAcquireLock

1 = PopUpFieldsRequired

2 = ProcessSuccessful

3 = IllegalLaneMove
* @format int32
*/
export enum WorkflowKanbanJobProcessResultStatus {
  UnableToAcquireLock = 0,
  PopUpFieldsRequired = 1,
  ProcessSuccessful = 2,
  IllegalLaneMove = 3
}

export interface WorkflowQueueConfigurationModel {
  standardJobTabs?: WorkflowJobTabModel[] | null;
  workflowJobTabs?: WorkflowJobTabModel[] | null;
  customJobTabs?: WorkflowJobTabModel[] | null;
  workflowJobButtons?: WorkflowJobButtonModel[] | null;
  workflowJobSecondaryQueues?: WorkflowJobSecondaryQueueModel[] | null;
  canOpenJobsInAnyQueue?: boolean;
  dataSourceKeys?: string[] | null;
  showCancelJobConfirmation?: boolean;
  cancelJobConfirmationMessage?: string | null;
  canGetNextJob?: boolean;
  allowWallboardMode?: boolean;
  /** @format int32 */
  wallboardRefreshIntervalInSeconds?: number;
  fieldUpdateRules?: WorkflowFieldUpdateRuleModel[] | null;
  useProcessFieldUpdateRules?: boolean;
  hideDocument?: boolean;
}

export interface WorkflowQueueDataModel {
  notification?: string | null;
  hasNotification?: boolean;
  showToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  errorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  presentationType?: NotificationPresentationType;
  /** @format int32 */
  queueId?: number;
  queueComponentName?: string | null;
  queueName?: string | null;
  /** @format int32 */
  queueDataCount?: number;
  queueDataTable?: DataTable;
  queueData?: Record<string, any>[] | null;
  queueColumns?: DataTableColumnsModel[] | null;
  canOpenJobs?: boolean;
  canOpenJobsInNewTab?: boolean;
  additionalConfigurations?: any;
  allowWallboardMode?: boolean;
  /** @format int32 */
  wallboardRefreshIntervalInSeconds?: number;
}

export interface WorkflowRuleFieldModel {
  dataSourceKey?: string | null;
  dataFieldName?: string | null;
  value?: string | null;
}

/**
* 

0 = ProcessJob

1 = ReturnJob

2 = ExceptionJob

3 = CancelJob

4 = SaveJob
* @format int32
*/
export enum WorkflowStandardProcessingAction {
  ProcessJob = 0,
  ReturnJob = 1,
  ExceptionJob = 2,
  CancelJob = 3,
  SaveJob = 4
}

export interface WorkflowTreeNodeDataModel {
  type?: string | null;
  /** @format int32 */
  id?: number;
  canAccess?: boolean;
}

export interface WorkflowTreeNodeModel {
  text?: string | null;
  state?: WorkflowTreeNodeStateModel;
  data?: WorkflowTreeNodeDataModel;
  children?: WorkflowTreeNodeModel[] | null;
  parentKey?: string | null;
  key?: string | null;
}

export interface WorkflowTreeNodeStateModel {
  selectable?: boolean;
}

export interface XPorterSchool {
  /** @format int32 */
  id?: number;
  schoolName?: string | null;
  secret?: string | null;
  students?: XPorterStudent[] | null;
}

export interface XPorterStudent {
  /** @format int32 */
  id?: number;
  upn?: string | null;
  surname?: string | null;
  forename?: string | null;
  /** @format date-time */
  dateOfBirth?: string;
  academicYear?: string | null;
  /** @format int32 */
  schoolId?: number;
  leaver?: boolean;
  school?: XPorterSchool;
}

export interface DocusignConfigurationSettingsListParams {
  /** @format int32 */
  DocumentTypeId?: number;
}

export interface DocusignConfigurationAdditionalDocumentFilesCreatePayload {
  /** @format binary */
  FileData?: File;
  Description?: string;
}

export interface DocusignConfigurationDocumentTypeListParams {
  /** @format int32 */
  DocumentTypeId?: number;
}

export interface DocusignConfigurationSignerRolesListParams {
  /** @format int32 */
  DocumentTypeId?: number;
}

export interface DocusignConfigurationSignerRoleDetailParams {
  /** @format int32 */
  DocumentTypeId?: number;
  /** @format int32 */
  SignerRoleId?: number;
  documentTypeId: string;
}

export interface DocusignConfigurationTemplatesConfigurationListParams {
  /** @format int32 */
  DocumentTypeId?: number;
}

export interface DocusignConfigurationTemplateConfigurationListParams {
  /** @format int32 */
  DocumentTypeId?: number;
  /** @format int32 */
  TemplateId?: number;
}

export interface DocusignConfigurationTemplateSignHereConfigurationListParams {
  /** @format int32 */
  DocumentTypeId?: number;
  /** @format int32 */
  TemplateSignHereId?: number;
}

export interface DocusignConfigurationTemplateAdditionalDocumentConfigurationListParams {
  /** @format int32 */
  DocumentTypeId?: number;
  /** @format int32 */
  TemplateId?: number;
  /** @format int32 */
  TemplateAdditionalDocumentId?: number;
}

export interface DocumentListParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  ViewConversionId?: number;
  DocumentPagePreferences?: DocumentPagePreferencesModel[];
  'AutoSaveConfiguration.Enabled'?: boolean;
  'AutoSaveConfiguration.Scope'?: string;
  CabinetId?: string;
  /** @format int32 */
  DocumentId?: number;
  /** @format int32 */
  DocumentTypeId?: number;
  HasDocumentTypeId?: boolean;
}

export interface DocumentPdfListParams {
  cabinetId?: string;
  /** @format int32 */
  documentId?: number;
}

export interface DocumentInformationListParams {
  CabinetId?: string;
  /** @format int32 */
  DocumentId?: number;
  /** @format int32 */
  DocumentTypeId?: number;
  HasDocumentTypeId?: boolean;
}

export interface DocumentRetentionInformationListParams {
  CabinetId?: string;
  /** @format int32 */
  DocumentId?: number;
  /** @format int32 */
  DocumentTypeId?: number;
  HasDocumentTypeId?: boolean;
}

export interface DocumentValidForRetentionUpdateParams {
  cabinetId?: string;
  /** @format int32 */
  documentId?: number;
}

export interface DocumentUpdateRetentionUpdateParams {
  /** @format int32 */
  DocumentId?: number;
  CabinetId?: string;
  /**
   *
   * 0 = None
   * 1 = AutomaticDeletion
   * 2 = ReviewForDeletion
   */
  RetentionType?: RetentionType;
  /** @format date-time */
  RetentionDate?: string;
  IsToReview?: boolean;
  Notification?: string;
  HasNotification?: boolean;
  ShowToast?: boolean;
  /**
   *
   * 0 = None
   * 1 = UnsupportedFileType
   * 2 = SqlTimeOutException
   * 3 = JobDoesNotExistInQueue
   * 4 = JobLockedByAnotherSession
   * 5 = InvalidConfiguration
   * 6 = DocumentPageShuffleSucceededReIndexFailed
   * 7 = EncryptionError
   */
  ErrorCode?: ErrorCode;
  /**
   *
   * 0 = Success
   * 1 = UserActionRequired
   * 2 = UnexpectedError
   */
  PresentationType?: NotificationPresentationType;
}

export interface DocumentActionsListParams {
  CabinetId?: string;
  /** @format int32 */
  DocumentId?: number;
  /** @format int32 */
  DocumentTypeId?: number;
  HasDocumentTypeId?: boolean;
}

export type DocumentUpdatePayload = string;

export interface DocumentThumbnailListParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  MaximumWidthInPixels?: number;
  /** @format int32 */
  MaximumHeightInPixels?: number;
  DocumentPagePreferences?: DocumentPagePreferencesModel[];
  CabinetId?: string;
  /** @format int32 */
  DocumentId?: number;
  /** @format int32 */
  DocumentTypeId?: number;
  HasDocumentTypeId?: boolean;
}

export type DocumentEmailValidateFileSizeLimitCreatePayload = DocumentBulkEmailDocumentModel[];

export interface DocumentsToStoreListParams {
  IncludeBatchNumber?: boolean;
}

export interface DocumentsToStoreMyDocumentsListParams {
  IncludeBatchNumber?: boolean;
}

export interface DocumentsToStoreEveryonesDocumentsListParams {
  IncludeBatchNumber?: boolean;
}

export interface DocumentsToStoreDocumentsDetailParams {
  IncludeBatchNumber?: boolean;
  /** @format int32 */
  documentTypeid: number;
}

export interface DocumentsToStoreDocumentCreatePayload {
  /** @format binary */
  FormFile?: File;
  IsDocumentToStoreDocument?: boolean;
  IsMyDocument?: boolean;
  /** @format int32 */
  DocumentTypeId?: number;
  /** @format int32 */
  BatchNumber?: number;
}

export interface DocumentToStoreListParams {
  SourceCabinetId?: string;
  /** @format int32 */
  SourceDocumentId?: number;
  /** @format int32 */
  TargetDocumentTypeId?: number;
}

export interface DocusignEnvelopePostSampleCreateParams {
  recipientEmail?: string;
}

export type DocusignEnvelopeUpdatePayload = string;

export interface DocusignEnvelopeUpdateParams {
  envelopeId?: string;
}

export type ExternalUsersRolesUpdatePayload = number[];

export interface ListWorkflowDataFieldListListParams {
  DataSourceKey?: string;
  DataFieldKey?: string;
  /** @format int32 */
  JobId?: number;
}

export interface ListCanAddItemToListAsyncListParams {
  /** @format int32 */
  listId?: number;
}

export type ListMaintenanceConfigurationListItemDeletePayload = number[];

export interface LockListParams {
  ApplicationType?: string;
  /** @format int32 */
  LockTypeId?: number;
  ShowPersistentLocks?: boolean;
}

export interface OrganisationsListParams {
  IsDeactivated?: boolean;
  /** @format int32 */
  OrganisationId?: number;
}

export interface ParameterListParams {
  /** @format int32 */
  entityTypeId?: number;
  entityPk?: string;
  group?: string;
  code?: string;
}

export type AutomotiveSalesPackTabPreviewPreSalesPackCreatePayload = number[];

export type AutomotiveSalesPackTabPreviewPostSalesPackCreatePayload = number[];

export type AutomotiveSalesPackTabSignPreSalesPackCreatePayload = number[];

export type AutomotiveSalesPackTabSignPostSalesPackCreatePayload = number[];

export interface ScriveConfigurationDocumentTypeConfigurationListParams {
  /** @format int32 */
  DocumentTypeId?: number;
}

export interface ScriveConfigurationSignerRolesListParams {
  /** @format int32 */
  DocumentTypeId?: number;
}

export interface ScriveConfigurationSignerRoleDetailParams {
  /** @format int32 */
  DocumentTypeId?: number;
  /** @format int32 */
  SignerRoleId?: number;
  documentTypeId: string;
}

export interface ScriveConfigurationTemplatesConfigurationListParams {
  /** @format int32 */
  DocumentTypeId?: number;
}

export interface ScriveConfigurationTemplateConfigurationListParams {
  /** @format int32 */
  DocumentTypeId?: number;
  /** @format int32 */
  TemplateId?: number;
}

export interface ScriveConfigurationSigningpartyConfigurationListParams {
  /** @format int32 */
  DocumentTypeId?: number;
  /** @format int32 */
  TemplateSigningPartyId?: number;
}

export interface ScriveConfigurationSigningpartyfieldConfigurationListParams {
  /** @format int32 */
  TemplateSigningPartyFieldId?: number;
}

export interface ScriveConfigurationSigningpartyfieldplacementConfigurationListParams {
  /** @format int32 */
  TemplateSigningPartyFieldPlacementId?: number;
}

export interface ScriveConfigurationSettingsListParams {
  /** @format int32 */
  documentTypeId?: number;
}

export interface ScriveSigningPostSampleCreateParams {
  recipientEmail?: string;
}

export interface SingleSignOnConfigurationSinglesignonenabledUpdateParams {
  enabled?: boolean;
}

export interface ToolsDocumentRetentionDetailParams {
  documentTypeIds?: number[];
  cabinetId: string;
}

export interface UsersListParams {
  /** @format int32 */
  OrganisationId?: number;
  IsDeactivated?: boolean;
}

export interface WorkflowJobDocumentDetailParams {
  /** @format int32 */
  JobId?: number;
  /** @format int32 */
  Page?: number;
  jobId: string;
}

export interface WorkflowQueueDetailParams {
  serializedFilters?: string;
  /** @format int32 */
  id: number;
}

import { AxiosInstance, AxiosRequestConfig } from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded'
}

export class HttpClient {
  public instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: Iterable<any> = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({ secure, path, type, query, body, ...params }: FullRequestParams): Promise<T> => {
    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    return this.instance
      .request({
        ...params,
        headers: {
          ...(params.headers || {}),
          ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {})
        },
        params: query,
        data: body,
        url: path
      })
      .then((response) => response.data);
  };
}

/**
 * @title mstoreV5
 * @version v1
 */
export class Api extends HttpClient {
  appSettings = {
    /**
     * No description
     *
     * @tags AppSettings
     * @name AppSettingsList
     * @request GET:/api/AppSettings
     * @secure
     */
    appSettingsList: (params: RequestParams = {}) =>
      this.request<AppSettingsModel, void>({
        path: `/api/AppSettings`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags AppSettings
     * @name AppSettingsGetappstartsettingsList
     * @request GET:/api/AppSettings/getappstartsettings
     * @secure
     */
    appSettingsGetappstartsettingsList: (params: RequestParams = {}) =>
      this.request<AppStartSettingsModel, void>({
        path: `/api/AppSettings/getappstartsettings`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  autoSaveConfiguration = {
    /**
     * No description
     *
     * @tags AutoSaveConfiguration
     * @name AutoSaveConfigurationList
     * @request GET:/api/AutoSaveConfiguration
     * @secure
     */
    autoSaveConfigurationList: (params: RequestParams = {}) =>
      this.request<AutoSaveConfigurationModel, void>({
        path: `/api/AutoSaveConfiguration`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags AutoSaveConfiguration
     * @name AutoSaveConfigurationUpdate
     * @request PUT:/api/AutoSaveConfiguration
     * @secure
     */
    autoSaveConfigurationUpdate: (data: AutoSaveConfigurationModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/AutoSaveConfiguration`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags AutoSaveConfiguration
     * @name AutoSaveConfigurationDefaultUpdate
     * @request PUT:/api/AutoSaveConfiguration/default
     * @secure
     */
    autoSaveConfigurationDefaultUpdate: (data: AutoSaveConfigurationModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/AutoSaveConfiguration/default`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  cabinetConfiguration = {
    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationAllcabinetreferencesList
     * @request GET:/api/CabinetConfiguration/allcabinetreferences
     * @secure
     */
    cabinetConfigurationAllcabinetreferencesList: (params: RequestParams = {}) =>
      this.request<CopyReferenceModel[], void>({
        path: `/api/CabinetConfiguration/allcabinetreferences`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationAllcabinetsList
     * @request GET:/api/CabinetConfiguration/allcabinets
     * @secure
     */
    cabinetConfigurationAllcabinetsList: (params: RequestParams = {}) =>
      this.request<CopyCabinetReferencesModel[], void>({
        path: `/api/CabinetConfiguration/allcabinets`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationAllcabinetsdataList
     * @request GET:/api/CabinetConfiguration/allcabinetsdata
     * @secure
     */
    cabinetConfigurationAllcabinetsdataList: (params: RequestParams = {}) =>
      this.request<CabinetModel[], void>({
        path: `/api/CabinetConfiguration/allcabinetsdata`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationAllcabinetnamesList
     * @request GET:/api/CabinetConfiguration/allcabinetnames
     * @secure
     */
    cabinetConfigurationAllcabinetnamesList: (params: RequestParams = {}) =>
      this.request<string[], void>({
        path: `/api/CabinetConfiguration/allcabinetnames`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationCabinetreferenceconfigurationDetail
     * @request GET:/api/CabinetConfiguration/cabinetreferenceconfiguration/{referenceId}
     * @secure
     */
    cabinetConfigurationCabinetreferenceconfigurationDetail: (referenceId: number, params: RequestParams = {}) =>
      this.request<CabinetConfigurationModel, void>({
        path: `/api/CabinetConfiguration/cabinetreferenceconfiguration/${referenceId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationChangeCreate
     * @request POST:/api/CabinetConfiguration/change
     * @secure
     */
    cabinetConfigurationChangeCreate: (data: ConfigurationChangeModel, params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/CabinetConfiguration/change`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationChangeList
     * @request GET:/api/CabinetConfiguration/change
     * @secure
     */
    cabinetConfigurationChangeList: (params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/CabinetConfiguration/change`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationChangeUpdate
     * @request PUT:/api/CabinetConfiguration/change/{id}
     * @secure
     */
    cabinetConfigurationChangeUpdate: (id: number, params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/CabinetConfiguration/change/${id}`,
        method: 'PUT',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationSettingsList
     * @request GET:/api/CabinetConfiguration/settings
     * @secure
     */
    cabinetConfigurationSettingsList: (params: RequestParams = {}) =>
      this.request<CabinetConfigurationSettingsModel, void>({
        path: `/api/CabinetConfiguration/settings`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationDetail
     * @request GET:/api/CabinetConfiguration/{cabinetId}
     * @secure
     */
    cabinetConfigurationDetail: (cabinetId: string, params: RequestParams = {}) =>
      this.request<CabinetConfigurationModel, void>({
        path: `/api/CabinetConfiguration/${cabinetId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationCreate
     * @request POST:/api/CabinetConfiguration
     * @secure
     */
    cabinetConfigurationCreate: (data: CabinetConfigurationModel, params: RequestParams = {}) =>
      this.request<CabinetConfigurationModel, void>({
        path: `/api/CabinetConfiguration`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationUpdate
     * @request PUT:/api/CabinetConfiguration
     * @secure
     */
    cabinetConfigurationUpdate: (data: CabinetConfigurationModel, params: RequestParams = {}) =>
      this.request<CabinetConfigurationModel, void>({
        path: `/api/CabinetConfiguration`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationDelete
     * @request DELETE:/api/CabinetConfiguration
     * @secure
     */
    cabinetConfigurationDelete: (data: DeleteConfigurationModel, params: RequestParams = {}) =>
      this.request<DeleteConfigurationResponseModel, void>({
        path: `/api/CabinetConfiguration`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationDocumenttypeDelete
     * @request DELETE:/api/CabinetConfiguration/documenttype
     * @secure
     */
    cabinetConfigurationDocumenttypeDelete: (data: DeleteConfigurationModel, params: RequestParams = {}) =>
      this.request<DeleteConfigurationResponseModel, void>({
        path: `/api/CabinetConfiguration/documenttype`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationDocumentTypeCreate
     * @request POST:/api/CabinetConfiguration/documentType
     * @secure
     */
    cabinetConfigurationDocumentTypeCreate: (data: CabinetConfigurationModel, params: RequestParams = {}) =>
      this.request<CabinetConfigurationModel, void>({
        path: `/api/CabinetConfiguration/documentType`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationDocumentTypeUpdate
     * @request PUT:/api/CabinetConfiguration/documentType
     * @secure
     */
    cabinetConfigurationDocumentTypeUpdate: (data: CabinetConfigurationModel, params: RequestParams = {}) =>
      this.request<CabinetConfigurationModel, void>({
        path: `/api/CabinetConfiguration/documentType`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationCheckAuthorizedList
     * @request GET:/api/CabinetConfiguration/checkAuthorized
     * @secure
     */
    cabinetConfigurationCheckAuthorizedList: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/CabinetConfiguration/checkAuthorized`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationDocumentLinkCreate
     * @request POST:/api/CabinetConfiguration/documentLink
     * @secure
     */
    cabinetConfigurationDocumentLinkCreate: (data: DocumentLinkConfigurationModel, params: RequestParams = {}) =>
      this.request<CabinetConfigurationModel, void>({
        path: `/api/CabinetConfiguration/documentLink`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationDocumentLinkUpdate
     * @request PUT:/api/CabinetConfiguration/documentLink
     * @secure
     */
    cabinetConfigurationDocumentLinkUpdate: (data: DocumentLinkConfigurationModel, params: RequestParams = {}) =>
      this.request<CabinetConfigurationModel, void>({
        path: `/api/CabinetConfiguration/documentLink`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationDocumentLinkDelete
     * @request DELETE:/api/CabinetConfiguration/documentLink
     * @secure
     */
    cabinetConfigurationDocumentLinkDelete: (data: DeleteConfigurationModel, params: RequestParams = {}) =>
      this.request<DeleteConfigurationResponseModel, void>({
        path: `/api/CabinetConfiguration/documentLink`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationDocumentLinkBidirectionalCreate
     * @request POST:/api/CabinetConfiguration/documentLinkBidirectional
     * @secure
     */
    cabinetConfigurationDocumentLinkBidirectionalCreate: (data: DocumentLinkConfigurationModel, params: RequestParams = {}) =>
      this.request<CabinetConfigurationModel, void>({
        path: `/api/CabinetConfiguration/documentLinkBidirectional`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CabinetConfiguration
     * @name CabinetConfigurationCheckExistingBidirectionalDocumentLinkCreate
     * @request POST:/api/CabinetConfiguration/checkExistingBidirectionalDocumentLink
     * @secure
     */
    cabinetConfigurationCheckExistingBidirectionalDocumentLinkCreate: (data: DocumentLinkConfigurationModel, params: RequestParams = {}) =>
      this.request<boolean, void>({
        path: `/api/CabinetConfiguration/checkExistingBidirectionalDocumentLink`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  componentVersion = {
    /**
     * No description
     *
     * @tags ComponentVersion
     * @name ComponentVersionList
     * @request GET:/api/ComponentVersion
     * @secure
     */
    componentVersionList: (params: RequestParams = {}) =>
      this.request<ComponentVersionModel[], void>({
        path: `/api/ComponentVersion`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  configuration = {
    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationSettingsList
     * @request GET:/api/docusign/Configuration/Settings
     * @secure
     */
    docusignConfigurationSettingsList: (query: DocusignConfigurationSettingsListParams, params: RequestParams = {}) =>
      this.request<SettingsConfigurationModel, void>({
        path: `/api/docusign/Configuration/Settings`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationSettingsCreate
     * @request POST:/api/docusign/Configuration/Settings/{documentTypeId}
     * @secure
     */
    docusignConfigurationSettingsCreate: (documentTypeId: number, data: SettingsModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/docusign/Configuration/Settings/${documentTypeId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationAdditionalDocumentFilesCreate
     * @request POST:/api/docusign/Configuration/additionalDocumentFiles
     * @secure
     */
    docusignConfigurationAdditionalDocumentFilesCreate: (data: DocusignConfigurationAdditionalDocumentFilesCreatePayload, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/additionalDocumentFiles`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationAdditionalDocumentFilesList
     * @request GET:/api/docusign/Configuration/additionalDocumentFiles
     * @secure
     */
    docusignConfigurationAdditionalDocumentFilesList: (params: RequestParams = {}) =>
      this.request<AdditionalDocumentFileConfigurationModel, void>({
        path: `/api/docusign/Configuration/additionalDocumentFiles`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationAdditionalDocumentFilesUpdate
     * @request PUT:/api/docusign/Configuration/additionalDocumentFiles
     * @secure
     */
    docusignConfigurationAdditionalDocumentFilesUpdate: (data: AdditionalDocumentFileUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/additionalDocumentFiles`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationAdditionalDocumentFilesDetail
     * @request GET:/api/docusign/Configuration/additionalDocumentFiles/{id}
     * @secure
     */
    docusignConfigurationAdditionalDocumentFilesDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdditionalDocumentFileModel, void>({
        path: `/api/docusign/Configuration/additionalDocumentFiles/${id}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationAdditionalDocumentFilesDelete
     * @request DELETE:/api/docusign/Configuration/additionalDocumentFiles/{id}
     * @secure
     */
    docusignConfigurationAdditionalDocumentFilesDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/docusign/Configuration/additionalDocumentFiles/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationAdditionalDocumentFilesSigntabsDetail
     * @request GET:/api/docusign/Configuration/additionalDocumentFiles/{id}/signtabs
     * @secure
     */
    docusignConfigurationAdditionalDocumentFilesSigntabsDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdditionalDocumentSignTabConfigurationModel, void>({
        path: `/api/docusign/Configuration/additionalDocumentFiles/${id}/signtabs`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationAdditionalDocumentFilesSigntabsCreate
     * @request POST:/api/docusign/Configuration/additionalDocumentFiles/{id}/signtabs
     * @secure
     */
    docusignConfigurationAdditionalDocumentFilesSigntabsCreate: (id: number, data: AdditionalDocumentSignTabCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/additionalDocumentFiles/${id}/signtabs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationAdditionalDocumentFilesSigntabsDetail2
     * @request GET:/api/docusign/Configuration/additionalDocumentFiles/{additionalDocumentFileId}/signtabs/{id}
     * @originalName docusignConfigurationAdditionalDocumentFilesSigntabsDetail
     * @duplicate
     * @secure
     */
    docusignConfigurationAdditionalDocumentFilesSigntabsDetail2: (additionalDocumentFileId: number, id: number, params: RequestParams = {}) =>
      this.request<AdditionalDocumentSignTabModel, void>({
        path: `/api/docusign/Configuration/additionalDocumentFiles/${additionalDocumentFileId}/signtabs/${id}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationAdditionalDocumentFilesSigntabsUpdate
     * @request PUT:/api/docusign/Configuration/additionalDocumentFiles/{additionalDocumentFileId}/signtabs/{id}
     * @secure
     */
    docusignConfigurationAdditionalDocumentFilesSigntabsUpdate: (additionalDocumentFileId: number, id: number, data: AdditionalDocumentSignTabCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/additionalDocumentFiles/${additionalDocumentFileId}/signtabs/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationAdditionalDocumentFilesSigntabsDelete
     * @request DELETE:/api/docusign/Configuration/additionalDocumentFiles/{additionalDocumentFileId}/signtabs/{id}
     * @secure
     */
    docusignConfigurationAdditionalDocumentFilesSigntabsDelete: (additionalDocumentFileId: number, id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/docusign/Configuration/additionalDocumentFiles/${additionalDocumentFileId}/signtabs/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationDocumentTypeList
     * @request GET:/api/docusign/Configuration/documentType
     * @secure
     */
    docusignConfigurationDocumentTypeList: (query: DocusignConfigurationDocumentTypeListParams, params: RequestParams = {}) =>
      this.request<ArenaSignDocumentTypeConfigurationModel, void>({
        path: `/api/docusign/Configuration/documentType`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationDocumentTypeUpdate
     * @request PUT:/api/docusign/Configuration/documentType/{documentTypeId}
     * @secure
     */
    docusignConfigurationDocumentTypeUpdate: (documentTypeId: number, data: DocumentTypeUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/documentType/${documentTypeId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationSignerRolesList
     * @request GET:/api/docusign/Configuration/signerRoles
     * @secure
     */
    docusignConfigurationSignerRolesList: (query: DocusignConfigurationSignerRolesListParams, params: RequestParams = {}) =>
      this.request<SignerRolesConfigurationModel, void>({
        path: `/api/docusign/Configuration/signerRoles`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationSignerRoleDetail
     * @request GET:/api/docusign/Configuration/{documentTypeId}/signerRole
     * @secure
     */
    docusignConfigurationSignerRoleDetail: ({ documentTypeId, ...query }: DocusignConfigurationSignerRoleDetailParams, params: RequestParams = {}) =>
      this.request<ArenaSignSignerRoleConfigurationModel, void>({
        path: `/api/docusign/Configuration/${documentTypeId}/signerRole`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationSignerRoleCreate
     * @request POST:/api/docusign/Configuration/{documentTypeId}/signerRole
     * @secure
     */
    docusignConfigurationSignerRoleCreate: (documentTypeId: number, data: SignerRoleCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/${documentTypeId}/signerRole`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationSignerRoleUpdate
     * @request PUT:/api/docusign/Configuration/{documentTypeId}/signerRole/{id}
     * @secure
     */
    docusignConfigurationSignerRoleUpdate: (documentTypeId: number, id: number, data: SignerRoleCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/${documentTypeId}/signerRole/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationSignerRoleDelete
     * @request DELETE:/api/docusign/Configuration/signerRole/{id}
     * @secure
     */
    docusignConfigurationSignerRoleDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/docusign/Configuration/signerRole/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationPrivateKeyUpdate
     * @request PUT:/api/docusign/Configuration/privateKey
     * @secure
     */
    docusignConfigurationPrivateKeyUpdate: (data: PrivateKeyUpdateModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/docusign/Configuration/privateKey`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationPrivateKeyList
     * @request GET:/api/docusign/Configuration/privateKey
     * @secure
     */
    docusignConfigurationPrivateKeyList: (params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/docusign/Configuration/privateKey`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTestDocuSignList
     * @request GET:/api/docusign/Configuration/testDocuSign
     * @secure
     */
    docusignConfigurationTestDocuSignList: (params: RequestParams = {}) =>
      this.request<DocuSignTestResponseModel, void>({
        path: `/api/docusign/Configuration/testDocuSign`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationArenaSignPrivateKeyList
     * @request GET:/api/docusign/Configuration/arenaSign/privateKey
     * @secure
     */
    docusignConfigurationArenaSignPrivateKeyList: (params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/docusign/Configuration/arenaSign/privateKey`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplatesConfigurationList
     * @request GET:/api/docusign/Configuration/templates/configuration
     * @secure
     */
    docusignConfigurationTemplatesConfigurationList: (query: DocusignConfigurationTemplatesConfigurationListParams, params: RequestParams = {}) =>
      this.request<DocuSignTemplatesConfigurationModel, void>({
        path: `/api/docusign/Configuration/templates/configuration`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateDelete
     * @request DELETE:/api/docusign/Configuration/template/{id}
     * @secure
     */
    docusignConfigurationTemplateDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/docusign/Configuration/template/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateUpdate
     * @request PUT:/api/docusign/Configuration/template/{id}
     * @secure
     */
    docusignConfigurationTemplateUpdate: (id: number, data: ArenaSignTemplateCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/template/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateConfigurationList
     * @request GET:/api/docusign/Configuration/template/configuration
     * @secure
     */
    docusignConfigurationTemplateConfigurationList: (query: DocusignConfigurationTemplateConfigurationListParams, params: RequestParams = {}) =>
      this.request<DocuSignTemplateConfigurationModel, void>({
        path: `/api/docusign/Configuration/template/configuration`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateCreate
     * @request POST:/api/docusign/Configuration/template
     * @secure
     */
    docusignConfigurationTemplateCreate: (data: ArenaSignTemplateCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateSignHereDelete
     * @request DELETE:/api/docusign/Configuration/templateSignHere/{id}
     * @secure
     */
    docusignConfigurationTemplateSignHereDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/docusign/Configuration/templateSignHere/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateSignHereUpdate
     * @request PUT:/api/docusign/Configuration/templateSignHere/{id}
     * @secure
     */
    docusignConfigurationTemplateSignHereUpdate: (id: number, data: TemplateSignHereCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/templateSignHere/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateSignHereConfigurationList
     * @request GET:/api/docusign/Configuration/templateSignHere/configuration
     * @secure
     */
    docusignConfigurationTemplateSignHereConfigurationList: (query: DocusignConfigurationTemplateSignHereConfigurationListParams, params: RequestParams = {}) =>
      this.request<TemplateSignHereConfigurationModel, void>({
        path: `/api/docusign/Configuration/templateSignHere/configuration`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateSignHereCreate
     * @request POST:/api/docusign/Configuration/templateSignHere
     * @secure
     */
    docusignConfigurationTemplateSignHereCreate: (data: TemplateSignHereCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/templateSignHere`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateAdditionalDocumentConfigurationList
     * @request GET:/api/docusign/Configuration/templateAdditionalDocument/configuration
     * @secure
     */
    docusignConfigurationTemplateAdditionalDocumentConfigurationList: (query: DocusignConfigurationTemplateAdditionalDocumentConfigurationListParams, params: RequestParams = {}) =>
      this.request<TemplateAdditionalDocumentConfigurationModel, void>({
        path: `/api/docusign/Configuration/templateAdditionalDocument/configuration`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateAdditionalDocumentUpdate
     * @request PUT:/api/docusign/Configuration/templateAdditionalDocument/{id}
     * @secure
     */
    docusignConfigurationTemplateAdditionalDocumentUpdate: (id: number, data: TemplateAdditionalDocumentCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/templateAdditionalDocument/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateAdditionalDocumentDelete
     * @request DELETE:/api/docusign/Configuration/templateAdditionalDocument/{id}
     * @secure
     */
    docusignConfigurationTemplateAdditionalDocumentDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/docusign/Configuration/templateAdditionalDocument/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateAdditionalDocumentCreate
     * @request POST:/api/docusign/Configuration/templateAdditionalDocument
     * @secure
     */
    docusignConfigurationTemplateAdditionalDocumentCreate: (data: TemplateAdditionalDocumentCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/templateAdditionalDocument`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationGetDocuSignFileTypeWhiteListList
     * @request GET:/api/docusign/Configuration/getDocuSignFileTypeWhiteList
     * @secure
     */
    docusignConfigurationGetDocuSignFileTypeWhiteListList: (params: RequestParams = {}) =>
      this.request<string[], void>({
        path: `/api/docusign/Configuration/getDocuSignFileTypeWhiteList`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateAfterSignSettingList
     * @request GET:/api/docusign/Configuration/templateAfterSignSetting
     * @secure
     */
    docusignConfigurationTemplateAfterSignSettingList: (params: RequestParams = {}) =>
      this.request<TemplateAfterSignSettingModel[], void>({
        path: `/api/docusign/Configuration/templateAfterSignSetting`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateAfterSignSettingUpdate
     * @request PUT:/api/docusign/Configuration/templateAfterSignSetting
     * @secure
     */
    docusignConfigurationTemplateAfterSignSettingUpdate: (data: TemplateAfterSignSettingConfigurationUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/docusign/Configuration/templateAfterSignSetting`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name DocusignConfigurationTemplateAfterSignSettingDetail
     * @request GET:/api/docusign/Configuration/templateAfterSignSetting/{templateAfterSignId}
     * @secure
     */
    docusignConfigurationTemplateAfterSignSettingDetail: (templateAfterSignId: number, params: RequestParams = {}) =>
      this.request<TemplateAfterSignSettingConfigurationModel, void>({
        path: `/api/docusign/Configuration/templateAfterSignSetting/${templateAfterSignId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationAuthorizationList
     * @request GET:/api/Configuration/authorization
     * @secure
     */
    configurationAuthorizationList: (params: RequestParams = {}) =>
      this.request<ConfigurationAuthorizationModel, void>({
        path: `/api/Configuration/authorization`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationTreeList
     * @request GET:/api/Configuration/tree
     * @secure
     */
    configurationTreeList: (params: RequestParams = {}) =>
      this.request<ConfigurationTreeNodeModel[], void>({
        path: `/api/Configuration/tree`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  dealDocument = {
    /**
     * No description
     *
     * @tags DealDocument
     * @name AutomotiveDealDocumentDealCopyRequestCreate
     * @request POST:/api/automotive/DealDocument/DealCopyRequest
     * @secure
     */
    automotiveDealDocumentDealCopyRequestCreate: (data: DealCopyRequestModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/automotive/DealDocument/DealCopyRequest`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DealDocument
     * @name AutomotiveDealDocumentDealCopyHistoryList
     * @request GET:/api/automotive/DealDocument/DealCopyHistory
     * @secure
     */
    automotiveDealDocumentDealCopyHistoryList: (params: RequestParams = {}) =>
      this.request<DealDocumentCopyHistoryModel[], void>({
        path: `/api/automotive/DealDocument/DealCopyHistory`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DealDocument
     * @name AutomotiveDealDocumentGetList
     * @request GET:/api/automotive/DealDocument/Get
     * @secure
     */
    automotiveDealDocumentGetList: (params: RequestParams = {}) =>
      this.request<DealDocumentCopyListConfigurationModel, void>({
        path: `/api/automotive/DealDocument/Get`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  document = {
    /**
     * No description
     *
     * @tags Document
     * @name DocumentList
     * @request GET:/api/Document
     * @secure
     */
    documentList: (query: DocumentListParams, params: RequestParams = {}) =>
      this.request<DocumentViewModel, void>({
        path: `/api/Document`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentCreate
     * @request POST:/api/Document
     * @secure
     */
    documentCreate: (data: IndexDocumentModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/Document`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentPdfList
     * @request GET:/api/Document/pdf
     * @secure
     */
    documentPdfList: (query: DocumentPdfListParams, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/Document/pdf`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentInformationList
     * @request GET:/api/Document/information
     * @secure
     */
    documentInformationList: (query: DocumentInformationListParams, params: RequestParams = {}) =>
      this.request<DocumentInformationModel, void>({
        path: `/api/Document/information`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentRetentionInformationList
     * @request GET:/api/Document/retentionInformation
     * @secure
     */
    documentRetentionInformationList: (query: DocumentRetentionInformationListParams, params: RequestParams = {}) =>
      this.request<DocumentRetentionModel, void>({
        path: `/api/Document/retentionInformation`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentValidForRetentionUpdate
     * @request PUT:/api/Document/validForRetention
     * @secure
     */
    documentValidForRetentionUpdate: (query: DocumentValidForRetentionUpdateParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Document/validForRetention`,
        method: 'PUT',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentUpdateRetentionUpdate
     * @request PUT:/api/Document/updateRetention
     * @secure
     */
    documentUpdateRetentionUpdate: (query: DocumentUpdateRetentionUpdateParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Document/updateRetention`,
        method: 'PUT',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentActionsList
     * @request GET:/api/Document/actions
     * @secure
     */
    documentActionsList: (query: DocumentActionsListParams, params: RequestParams = {}) =>
      this.request<DocumentActionModel, void>({
        path: `/api/Document/actions`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentUpdate
     * @request PUT:/api/Document/{cabinetId}/{documentId}
     * @secure
     */
    documentUpdate: (cabinetId: string, documentId: number, data: DocumentUpdatePayload, params: RequestParams = {}) =>
      this.request<DocumentExportModel, void>({
        path: `/api/Document/${cabinetId}/${documentId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentDelete
     * @request DELETE:/api/Document/{cabinetId}/{documentId}
     * @secure
     */
    documentDelete: (cabinetId: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Document/${cabinetId}/${documentId}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentDelete2
     * @request DELETE:/api/Document/{cabinetId}/{documentId}/{page}
     * @originalName documentDelete
     * @duplicate
     * @secure
     */
    documentDelete2: (cabinetId: string, documentId: number, page: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Document/${cabinetId}/${documentId}/${page}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentThumbnailList
     * @request GET:/api/Document/thumbnail
     * @secure
     */
    documentThumbnailList: (query: DocumentThumbnailListParams, params: RequestParams = {}) =>
      this.request<ThumbnailViewModel, void>({
        path: `/api/Document/thumbnail`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentPagePreferencesUpdate
     * @request PUT:/api/Document/PagePreferences/{documentId}
     * @secure
     */
    documentPagePreferencesUpdate: (documentId: number, data: DocumentPagePreferencesModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Document/PagePreferences/${documentId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentBackgrounddeleteCreate
     * @request POST:/api/Document/backgrounddelete
     * @secure
     */
    documentBackgrounddeleteCreate: (data: BackgroundDeleteRequestDataModel, params: RequestParams = {}) =>
      this.request<BackgroundDeleteResultModel, void>({
        path: `/api/Document/backgrounddelete`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentQueuebackgrounddeleteCreate
     * @request POST:/api/Document/queuebackgrounddelete
     * @secure
     */
    documentQueuebackgrounddeleteCreate: (data: BackgroundDeleteRequestDataModel, params: RequestParams = {}) =>
      this.request<QueueBackgroundTaskResultModel, void>({
        path: `/api/Document/queuebackgrounddelete`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentViewHistoryLogCreate
     * @request POST:/api/Document/viewHistoryLog/{documentId}
     * @secure
     */
    documentViewHistoryLogCreate: (documentId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Document/viewHistoryLog/${documentId}`,
        method: 'POST',
        secure: true,
        ...params
      })
  };
  documentEmail = {
    /**
     * No description
     *
     * @tags DocumentEmail
     * @name DocumentEmailCreate
     * @request POST:/api/DocumentEmail
     * @secure
     */
    documentEmailCreate: (data: DocumentEmailModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/DocumentEmail`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentEmail
     * @name DocumentEmailEmailToMeCreate
     * @request POST:/api/DocumentEmail/emailToMe
     * @secure
     */
    documentEmailEmailToMeCreate: (data: DocumentEmailToMeModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/DocumentEmail/emailToMe`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentEmail
     * @name DocumentEmailValidateFileSizeLimitCreate
     * @request POST:/api/DocumentEmail/validateFileSizeLimit
     * @secure
     */
    documentEmailValidateFileSizeLimitCreate: (data: DocumentEmailValidateFileSizeLimitCreatePayload, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/DocumentEmail/validateFileSizeLimit`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentEmail
     * @name DocumentEmailBulkCreate
     * @request POST:/api/DocumentEmail/bulk
     * @secure
     */
    documentEmailBulkCreate: (data: DocumentBulkEmailModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/DocumentEmail/bulk`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  documentEncryptionConfiguration = {
    /**
     * No description
     *
     * @tags DocumentEncryptionConfiguration
     * @name DocumentEncryptionConfigurationSettingsList
     * @request GET:/api/DocumentEncryptionConfiguration/settings
     * @secure
     */
    documentEncryptionConfigurationSettingsList: (params: RequestParams = {}) =>
      this.request<DocumentEncryptionConfigurationModel, void>({
        path: `/api/DocumentEncryptionConfiguration/settings`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentEncryptionConfiguration
     * @name DocumentEncryptionConfigurationSettingsUpdate
     * @request PUT:/api/DocumentEncryptionConfiguration/settings
     * @secure
     */
    documentEncryptionConfigurationSettingsUpdate: (data: DocumentEncryptionConfigurationModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/DocumentEncryptionConfiguration/settings`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentEncryptionConfiguration
     * @name DocumentEncryptionConfigurationStatusList
     * @request GET:/api/DocumentEncryptionConfiguration/status
     * @secure
     */
    documentEncryptionConfigurationStatusList: (params: RequestParams = {}) =>
      this.request<DocumentEncryptionStatusModel, void>({
        path: `/api/DocumentEncryptionConfiguration/status`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentEncryptionConfiguration
     * @name DocumentEncryptionConfigurationChangeCreate
     * @request POST:/api/DocumentEncryptionConfiguration/change
     * @secure
     */
    documentEncryptionConfigurationChangeCreate: (data: ConfigurationChangeModel, params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/DocumentEncryptionConfiguration/change`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentEncryptionConfiguration
     * @name DocumentEncryptionConfigurationChangeList
     * @request GET:/api/DocumentEncryptionConfiguration/change
     * @secure
     */
    documentEncryptionConfigurationChangeList: (params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/DocumentEncryptionConfiguration/change`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentEncryptionConfiguration
     * @name DocumentEncryptionConfigurationChangeUpdate
     * @request PUT:/api/DocumentEncryptionConfiguration/change/{id}
     * @secure
     */
    documentEncryptionConfigurationChangeUpdate: (id: number, params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/DocumentEncryptionConfiguration/change/${id}`,
        method: 'PUT',
        secure: true,
        ...params
      })
  };
  documentExport = {
    /**
     * No description
     *
     * @tags DocumentExport
     * @name DocumentExportUpdate
     * @request PUT:/api/DocumentExport/{cabinetId}/{documentId}
     * @secure
     */
    documentExportUpdate: (cabinetId: string, documentId: number, data: DocumentExportOptionsModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/DocumentExport/${cabinetId}/${documentId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentExport
     * @name DocumentExportExportMultipleDocumentsUpdate
     * @request PUT:/api/DocumentExport/exportMultipleDocuments/{cabinetId}/{documentId}/{zipFileName}
     * @secure
     */
    documentExportExportMultipleDocumentsUpdate: (cabinetId: string, documentId: number, zipFileName: string, data: DocumentExportOptionsModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/DocumentExport/exportMultipleDocuments/${cabinetId}/${documentId}/${zipFileName}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentExport
     * @name DocumentExportBackgroundexportCreate
     * @request POST:/api/DocumentExport/backgroundexport
     * @secure
     */
    documentExportBackgroundexportCreate: (data: BackgroundExportRequestDataModel, params: RequestParams = {}) =>
      this.request<BackgroundExportNotificationLinkModel, void>({
        path: `/api/DocumentExport/backgroundexport`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentExport
     * @name DocumentExportQueuebackgroundexportCreate
     * @request POST:/api/DocumentExport/queuebackgroundexport
     * @secure
     */
    documentExportQueuebackgroundexportCreate: (data: BackgroundExportRequestDataModel, params: RequestParams = {}) =>
      this.request<QueueBackgroundTaskResultModel, void>({
        path: `/api/DocumentExport/queuebackgroundexport`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentExport
     * @name DocumentExportBackgroundexportzipDetail
     * @request GET:/api/DocumentExport/backgroundexportzip/{backgroundTaskId}/{fileNumber}
     * @secure
     */
    documentExportBackgroundexportzipDetail: (backgroundTaskId: number, fileNumber: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/DocumentExport/backgroundexportzip/${backgroundTaskId}/${fileNumber}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentExport
     * @name DocumentExportBackgroundexportzipDelete
     * @request DELETE:/api/DocumentExport/backgroundexportzip/{backgroundTaskId}
     * @secure
     */
    documentExportBackgroundexportzipDelete: (backgroundTaskId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/DocumentExport/backgroundexportzip/${backgroundTaskId}`,
        method: 'DELETE',
        secure: true,
        ...params
      })
  };
  documentFullText = {
    /**
     * No description
     *
     * @tags DocumentFullText
     * @name DocumentFullTextDetail
     * @request GET:/api/DocumentFullText/{cabinetId}/{documentId}
     * @secure
     */
    documentFullTextDetail: (cabinetId: string, documentId: number, params: RequestParams = {}) =>
      this.request<DocumentFullTextDataModel, void>({
        path: `/api/DocumentFullText/${cabinetId}/${documentId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentFullText
     * @name DocumentFullTextCreate
     * @request POST:/api/DocumentFullText
     * @secure
     */
    documentFullTextCreate: (data: DocumentFullTextSearchModel, params: RequestParams = {}) =>
      this.request<DocumentFullTextDataModel, void>({
        path: `/api/DocumentFullText`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentFullText
     * @name DocumentFullTextDetail2
     * @request GET:/api/DocumentFullText/{cabinetId}/{documentId}/{uniqueId}
     * @originalName documentFullTextDetail
     * @duplicate
     * @secure
     */
    documentFullTextDetail2: (cabinetId: string, documentId: number, uniqueId: number, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/DocumentFullText/${cabinetId}/${documentId}/${uniqueId}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  documentPrint = {
    /**
     * No description
     *
     * @tags DocumentPrint
     * @name DocumentPrintPdfDetail
     * @request GET:/api/DocumentPrint/pdf/{cabinetId}/{documentId}
     * @secure
     */
    documentPrintPdfDetail: (cabinetId: string, documentId: number, params: RequestParams = {}) =>
      this.request<DocumentPrintResponseModel, void>({
        path: `/api/DocumentPrint/pdf/${cabinetId}/${documentId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentPrint
     * @name DocumentPrintBulkprintCreate
     * @request POST:/api/DocumentPrint/bulkprint
     * @secure
     */
    documentPrintBulkprintCreate: (data: BulkPrintRequestModel, params: RequestParams = {}) =>
      this.request<BulkPrintResultModel, void>({
        path: `/api/DocumentPrint/bulkprint`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentPrint
     * @name DocumentPrintBackgroundprintCreate
     * @request POST:/api/DocumentPrint/backgroundprint
     * @secure
     */
    documentPrintBackgroundprintCreate: (data: BackgroundPrintRequestDataModel, params: RequestParams = {}) =>
      this.request<QueueBackgroundTaskResultModel, void>({
        path: `/api/DocumentPrint/backgroundprint`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentPrint
     * @name DocumentPrintBackgroundprintDetail
     * @request GET:/api/DocumentPrint/backgroundprint/{backgroundTaskId}
     * @secure
     */
    documentPrintBackgroundprintDetail: (backgroundTaskId: number, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/DocumentPrint/backgroundprint/${backgroundTaskId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentPrint
     * @name DocumentPrintBackgroundprintDelete
     * @request DELETE:/api/DocumentPrint/backgroundprint/{backgroundTaskId}
     * @secure
     */
    documentPrintBackgroundprintDelete: (backgroundTaskId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/DocumentPrint/backgroundprint/${backgroundTaskId}`,
        method: 'DELETE',
        secure: true,
        ...params
      })
  };
  documentsToStore = {
    /**
     * No description
     *
     * @tags DocumentsToStore
     * @name DocumentsToStoreList
     * @request GET:/api/DocumentsToStore
     * @secure
     */
    documentsToStoreList: (query: DocumentsToStoreListParams, params: RequestParams = {}) =>
      this.request<DocumentsToStoreModel, void>({
        path: `/api/DocumentsToStore`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentsToStore
     * @name DocumentsToStoreMyDocumentsList
     * @request GET:/api/DocumentsToStore/myDocuments
     * @secure
     */
    documentsToStoreMyDocumentsList: (query: DocumentsToStoreMyDocumentsListParams, params: RequestParams = {}) =>
      this.request<DocumentTypeToStoreModel, void>({
        path: `/api/DocumentsToStore/myDocuments`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentsToStore
     * @name DocumentsToStoreMyDocumentsFirstList
     * @request GET:/api/DocumentsToStore/myDocuments/first
     * @secure
     */
    documentsToStoreMyDocumentsFirstList: (params: RequestParams = {}) =>
      this.request<DocumentViewModel, void>({
        path: `/api/DocumentsToStore/myDocuments/first`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentsToStore
     * @name DocumentsToStoreEveryonesDocumentsList
     * @request GET:/api/DocumentsToStore/everyonesDocuments
     * @secure
     */
    documentsToStoreEveryonesDocumentsList: (query: DocumentsToStoreEveryonesDocumentsListParams, params: RequestParams = {}) =>
      this.request<DocumentTypeToStoreModel, void>({
        path: `/api/DocumentsToStore/everyonesDocuments`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentsToStore
     * @name DocumentsToStoreDocumentsDetail
     * @request GET:/api/DocumentsToStore/documents/{documentTypeid}
     * @secure
     */
    documentsToStoreDocumentsDetail: ({ documentTypeid, ...query }: DocumentsToStoreDocumentsDetailParams, params: RequestParams = {}) =>
      this.request<DocumentTypeToStoreModel, void>({
        path: `/api/DocumentsToStore/documents/${documentTypeid}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentsToStore
     * @name DocumentsToStoreDocumentsDetail2
     * @request GET:/api/DocumentsToStore/documents/{documentTypeid}/{documentid}/{sortBy}/{sortDesc}
     * @originalName documentsToStoreDocumentsDetail
     * @duplicate
     * @secure
     */
    documentsToStoreDocumentsDetail2: (documentTypeid: number, documentId: number, sortBy: string, sortDesc: boolean, documentid: string, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/DocumentsToStore/documents/${documentTypeid}/${documentid}/${sortBy}/${sortDesc}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentsToStore
     * @name DocumentsToStoreDocumentCreate
     * @request POST:/api/DocumentsToStore/document
     * @secure
     */
    documentsToStoreDocumentCreate: (data: DocumentsToStoreDocumentCreatePayload, params: RequestParams = {}) =>
      this.request<DocumentCreationResultModel, void>({
        path: `/api/DocumentsToStore/document`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentsToStore
     * @name DocumentsToStoreAllowUploadDetail
     * @request GET:/api/DocumentsToStore/allowUpload/{documentTypeId}
     * @secure
     */
    documentsToStoreAllowUploadDetail: (documentTypeId: number, params: RequestParams = {}) =>
      this.request<boolean, void>({
        path: `/api/DocumentsToStore/allowUpload/${documentTypeId}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  documentTabs = {
    /**
     * No description
     *
     * @tags DocumentTabs
     * @name DocumentTabsTabsDetail
     * @request GET:/api/DocumentTabs/tabs/{documentId}/{cabinetId}
     * @secure
     */
    documentTabsTabsDetail: (documentId: number, cabinetId: string, params: RequestParams = {}) =>
      this.request<DocumentTabModel[], void>({
        path: `/api/DocumentTabs/tabs/${documentId}/${cabinetId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentTabs
     * @name DocumentTabsHistoryTabDetail
     * @request GET:/api/DocumentTabs/historyTab/{documentId}/{cabinetId}
     * @secure
     */
    documentTabsHistoryTabDetail: (documentId: number, cabinetId: string, params: RequestParams = {}) =>
      this.request<WorkflowJobHistoryDataModel, void>({
        path: `/api/DocumentTabs/historyTab/${documentId}/${cabinetId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentTabs
     * @name DocumentTabsWorkflowInformationTabDetail
     * @request GET:/api/DocumentTabs/workflowInformationTab/{documentId}/{cabinetId}
     * @secure
     */
    documentTabsWorkflowInformationTabDetail: (documentId: number, cabinetId: string, params: RequestParams = {}) =>
      this.request<DocumentWorkflowInformationTabModel, void>({
        path: `/api/DocumentTabs/workflowInformationTab/${documentId}/${cabinetId}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  documentToStore = {
    /**
     * No description
     *
     * @tags DocumentToStore
     * @name DocumentToStoreDetail
     * @request GET:/api/DocumentToStore/{sourceCabinetId}/{sourceDocumentId}
     * @secure
     */
    documentToStoreDetail: (sourceCabinetId: string, sourceDocumentId: number, params: RequestParams = {}) =>
      this.request<StoreDocumentModel, void>({
        path: `/api/DocumentToStore/${sourceCabinetId}/${sourceDocumentId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentToStore
     * @name DocumentToStoreUpdate
     * @request PUT:/api/DocumentToStore/{sourceCabinetId}/{sourceDocumentId}
     * @secure
     */
    documentToStoreUpdate: (sourceCabinetId: string, sourceDocumentId: number, data: DocumentToStoreUpdateModel, params: RequestParams = {}) =>
      this.request<BaseModel, void>({
        path: `/api/DocumentToStore/${sourceCabinetId}/${sourceDocumentId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentToStore
     * @name DocumentToStoreList
     * @request GET:/api/DocumentToStore
     * @secure
     */
    documentToStoreList: (query: DocumentToStoreListParams, params: RequestParams = {}) =>
      this.request<DocumentToStoreViewModel, void>({
        path: `/api/DocumentToStore`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentToStore
     * @name DocumentToStoreStatusUpdate
     * @request PUT:/api/DocumentToStore/status/{cabinetId}/{documentId}
     * @secure
     */
    documentToStoreStatusUpdate: (cabinetId: string, documentId: number, data: MStoreInputInlineUpdateModel, params: RequestParams = {}) =>
      this.request<BaseModel, void>({
        path: `/api/DocumentToStore/status/${cabinetId}/${documentId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentToStore
     * @name AutomotiveDocumentToStoreNextEntityIdCreate
     * @request POST:/api/automotive/DocumentToStore/nextEntityId/{automotiveEntityId}
     * @secure
     */
    automotiveDocumentToStoreNextEntityIdCreate: (automotiveEntityId: AutomotiveEntityId, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/automotive/DocumentToStore/nextEntityId/${automotiveEntityId}`,
        method: 'POST',
        secure: true,
        ...params
      })
  };
  documentType = {
    /**
     * No description
     *
     * @tags DocumentType
     * @name DocumentTypeDetail
     * @request GET:/api/DocumentType/{id}
     * @secure
     */
    documentTypeDetail: (id: number, params: RequestParams = {}) =>
      this.request<DocumentTypeModel, void>({
        path: `/api/DocumentType/${id}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  documentVersion = {
    /**
     * No description
     *
     * @tags DocumentVersion
     * @name DocumentVersionDetail
     * @request GET:/api/DocumentVersion/{cabinetId}/{documentId}
     * @secure
     */
    documentVersionDetail: (cabinetId: string, documentId: number, params: RequestParams = {}) =>
      this.request<DocumentVersionModel[], void>({
        path: `/api/DocumentVersion/${cabinetId}/${documentId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags DocumentVersion
     * @name DocumentVersionMakeCurrentVersionCreate
     * @request POST:/api/DocumentVersion/MakeCurrentVersion/{currentDocumentId}/{documentVersionId}
     * @secure
     */
    documentVersionMakeCurrentVersionCreate: (currentDocumentId: number, documentVersionId: number, params: RequestParams = {}) =>
      this.request<BaseDocumentSearchModel, void>({
        path: `/api/DocumentVersion/MakeCurrentVersion/${currentDocumentId}/${documentVersionId}`,
        method: 'POST',
        secure: true,
        ...params
      })
  };
  docuSignWorkflowJob = {
    /**
     * No description
     *
     * @tags DocuSignWorkflowJob
     * @name DocuSignWorkflowJobGroupActionCreate
     * @request POST:/api/DocuSignWorkflowJob/groupAction/{queueId}
     * @secure
     */
    docuSignWorkflowJobGroupActionCreate: (queueId: number, data: DocuSignGroupActionModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/DocuSignWorkflowJob/groupAction/${queueId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  editReferences = {
    /**
     * No description
     *
     * @tags EditReferences
     * @name EditReferencesDetail
     * @request GET:/api/EditReferences/{sourceCabinetId}/{sourceDocumentId}
     * @secure
     */
    editReferencesDetail: (sourceCabinetId: string, sourceDocumentId: number, params: RequestParams = {}) =>
      this.request<StoreDocumentModel, void>({
        path: `/api/EditReferences/${sourceCabinetId}/${sourceDocumentId}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  envelope = {
    /**
     * No description
     *
     * @tags Envelope
     * @name DocusignEnvelopePostSampleCreate
     * @request POST:/api/docusign/Envelope/PostSample
     * @secure
     */
    docusignEnvelopePostSampleCreate: (query: DocusignEnvelopePostSampleCreateParams, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/docusign/Envelope/PostSample`,
        method: 'POST',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Envelope
     * @name DocusignEnvelopeCreate
     * @request POST:/api/docusign/Envelope
     * @secure
     */
    docusignEnvelopeCreate: (data: DocuSignEnvelopeCreateModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/docusign/Envelope`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Envelope
     * @name DocusignEnvelopeUpdate
     * @request PUT:/api/docusign/Envelope
     * @secure
     */
    docusignEnvelopeUpdate: (query: DocusignEnvelopeUpdateParams, data: DocusignEnvelopeUpdatePayload, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/docusign/Envelope`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Envelope
     * @name DocusignEnvelopeListenerCreate
     * @request POST:/api/docusign/Envelope/Listener
     * @secure
     */
    docusignEnvelopeListenerCreate: (data: EnvelopeUpdateModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/docusign/Envelope/Listener`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  exampleErrors = {
    /**
     * No description
     *
     * @tags ExampleErrors
     * @name ExampleErrorsWithNotificationDetail
     * @request GET:/api/ExampleErrors/WithNotification/{errorType}
     * @secure
     */
    exampleErrorsWithNotificationDetail: (errorType: string, params: RequestParams = {}) =>
      this.request<ExampleErrorsModel, void>({
        path: `/api/ExampleErrors/WithNotification/${errorType}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExampleErrors
     * @name ExampleErrorsBadRequestCreate
     * @request POST:/api/ExampleErrors/BadRequest
     * @secure
     */
    exampleErrorsBadRequestCreate: (data: UserCreateModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ExampleErrors/BadRequest`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExampleErrors
     * @name ExampleErrorsWithoutNotificationDetail
     * @request GET:/api/ExampleErrors/WithoutNotification/{errorType}
     * @secure
     */
    exampleErrorsWithoutNotificationDetail: (errorType: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ExampleErrors/WithoutNotification/${errorType}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExampleErrors
     * @name ExampleErrorsWithErrorPageDetail
     * @request GET:/api/ExampleErrors/WithErrorPage/{errorType}
     * @secure
     */
    exampleErrorsWithErrorPageDetail: (errorType: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ExampleErrors/WithErrorPage/${errorType}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  exceptionalJobs = {
    /**
     * No description
     *
     * @tags ExceptionalJobs
     * @name ExceptionalJobsList
     * @request GET:/api/ExceptionalJobs
     * @secure
     */
    exceptionalJobsList: (params: RequestParams = {}) =>
      this.request<ExceptionalJobConfigurationCabinetModel, void>({
        path: `/api/ExceptionalJobs`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExceptionalJobs
     * @name ExceptionalJobsCreate
     * @request POST:/api/ExceptionalJobs
     * @secure
     */
    exceptionalJobsCreate: (data: CreateExceptionalJobConfigurationModel, params: RequestParams = {}) =>
      this.request<ExceptionalJobConfigurationModel[], void>({
        path: `/api/ExceptionalJobs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExceptionalJobs
     * @name ExceptionalJobsUpdate
     * @request PUT:/api/ExceptionalJobs
     * @secure
     */
    exceptionalJobsUpdate: (data: UpdateExceptionalJobsConfigurationModel, params: RequestParams = {}) =>
      this.request<ExceptionalJobConfigurationModel[], void>({
        path: `/api/ExceptionalJobs`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExceptionalJobs
     * @name ExceptionalJobsJobUpdate
     * @request PUT:/api/ExceptionalJobs/Job
     * @secure
     */
    exceptionalJobsJobUpdate: (data: UpdateExceptionalJobConfigurationModel, params: RequestParams = {}) =>
      this.request<ExceptionalJobConfigurationModel, void>({
        path: `/api/ExceptionalJobs/Job`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  externalUsers = {
    /**
     * No description
     *
     * @tags ExternalUsers
     * @name ExternalUsersDetail
     * @request GET:/api/ExternalUsers/{userId}
     * @secure
     */
    externalUsersDetail: (userId: number, params: RequestParams = {}) =>
      this.request<ExternalUserModel, void>({
        path: `/api/ExternalUsers/${userId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExternalUsers
     * @name ExternalUsersUpdate
     * @request PUT:/api/ExternalUsers/{userId}
     * @secure
     */
    externalUsersUpdate: (userId: number, data: ExternalUserUpdateModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ExternalUsers/${userId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExternalUsers
     * @name ExternalUsersDetail2
     * @request GET:/api/ExternalUsers/{username}
     * @originalName externalUsersDetail
     * @duplicate
     * @secure
     */
    externalUsersDetail2: (username: string, params: RequestParams = {}) =>
      this.request<ExternalUserModel, void>({
        path: `/api/ExternalUsers/${username}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExternalUsers
     * @name ExternalUsersCreate
     * @request POST:/api/ExternalUsers
     * @secure
     */
    externalUsersCreate: (data: ExternalUserCreateModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/ExternalUsers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExternalUsers
     * @name ExternalUsersDeactivateUpdate
     * @request PUT:/api/ExternalUsers/deactivate/{userId}
     * @secure
     */
    externalUsersDeactivateUpdate: (userId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ExternalUsers/deactivate/${userId}`,
        method: 'PUT',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExternalUsers
     * @name ExternalUsersReactivateUpdate
     * @request PUT:/api/ExternalUsers/reactivate/{userId}
     * @secure
     */
    externalUsersReactivateUpdate: (userId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ExternalUsers/reactivate/${userId}`,
        method: 'PUT',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExternalUsers
     * @name ExternalUsersRolesList
     * @request GET:/api/ExternalUsers/roles
     * @secure
     */
    externalUsersRolesList: (params: RequestParams = {}) =>
      this.request<ExternalRoleModel[], void>({
        path: `/api/ExternalUsers/roles`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExternalUsers
     * @name ExternalUsersRolesUpdate
     * @request PUT:/api/ExternalUsers/roles/{userId}
     * @secure
     */
    externalUsersRolesUpdate: (userId: number, data: ExternalUsersRolesUpdatePayload, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ExternalUsers/roles/${userId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExternalUsers
     * @name ExternalUsersUsersList
     * @request GET:/api/ExternalUsers/users
     * @secure
     */
    externalUsersUsersList: (params: RequestParams = {}) =>
      this.request<ExternalUserModel[], void>({
        path: `/api/ExternalUsers/users`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExternalUsers
     * @name ExternalUsersApiKeyCreate
     * @request POST:/api/ExternalUsers/api-key/{userId}
     * @secure
     */
    externalUsersApiKeyCreate: (userId: number, params: RequestParams = {}) =>
      this.request<ApiKeyResponseModel, void>({
        path: `/api/ExternalUsers/api-key/${userId}`,
        method: 'POST',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ExternalUsers
     * @name ExternalUsersApiKeyRevokeCreate
     * @request POST:/api/ExternalUsers/{userId}/api-key/revoke
     * @secure
     */
    externalUsersApiKeyRevokeCreate: (userId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ExternalUsers/${userId}/api-key/revoke`,
        method: 'POST',
        secure: true,
        ...params
      })
  };
  feedback = {
    /**
     * No description
     *
     * @tags Feedback
     * @name FeedbackGetFeedbackSubjectsList
     * @request GET:/api/Feedback/GetFeedbackSubjects
     * @secure
     */
    feedbackGetFeedbackSubjectsList: (params: RequestParams = {}) =>
      this.request<FeedbackSubjectsModel, void>({
        path: `/api/Feedback/GetFeedbackSubjects`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Feedback
     * @name FeedbackSendFeedbackEmailCreate
     * @request POST:/api/Feedback/SendFeedbackEmail
     * @secure
     */
    feedbackSendFeedbackEmailCreate: (data: FeedbackModel, params: RequestParams = {}) =>
      this.request<boolean, void>({
        path: `/api/Feedback/SendFeedbackEmail`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  leaver = {
    /**
     * No description
     *
     * @tags Leaver
     * @name LeaverList
     * @request GET:/api/Leaver
     * @secure
     */
    leaverList: (params: RequestParams = {}) =>
      this.request<LeaverModel[], void>({
        path: `/api/Leaver`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Leaver
     * @name LeaverCreate
     * @request POST:/api/Leaver
     * @secure
     */
    leaverCreate: (data: LeaverCreateModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/Leaver`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Leaver
     * @name LeaverDetail
     * @request GET:/api/Leaver/{leaverId}
     * @secure
     */
    leaverDetail: (leaverId: number, params: RequestParams = {}) =>
      this.request<LeaverModel, void>({
        path: `/api/Leaver/${leaverId}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  leaverRules = {
    /**
     * No description
     *
     * @tags LeaverRules
     * @name LeaverRulesDetail
     * @request GET:/api/LeaverRules/{ruleId}
     * @secure
     */
    leaverRulesDetail: (ruleId: number, params: RequestParams = {}) =>
      this.request<LeaverRuleModel, void>({
        path: `/api/LeaverRules/${ruleId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags LeaverRules
     * @name LeaverRulesDelete
     * @request DELETE:/api/LeaverRules/{ruleId}
     * @secure
     */
    leaverRulesDelete: (ruleId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/LeaverRules/${ruleId}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags LeaverRules
     * @name LeaverRulesCreate
     * @request POST:/api/LeaverRules/{configurationId}
     * @secure
     */
    leaverRulesCreate: (configurationId: number, data: LeaverRuleCreateUpdateModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/LeaverRules/${configurationId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags LeaverRules
     * @name LeaverRulesUpdate
     * @request PUT:/api/LeaverRules/{configurationId}/{ruleId}
     * @secure
     */
    leaverRulesUpdate: (configurationId: number, ruleId: number, data: LeaverRuleCreateUpdateModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/LeaverRules/${configurationId}/${ruleId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  leaversToolConfigurations = {
    /**
     * No description
     *
     * @tags LeaversToolConfigurations
     * @name LeaversToolConfigurationsList
     * @request GET:/api/LeaversToolConfigurations
     * @secure
     */
    leaversToolConfigurationsList: (params: RequestParams = {}) =>
      this.request<LeaversToolConfigurationsModel, void>({
        path: `/api/LeaversToolConfigurations`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags LeaversToolConfigurations
     * @name LeaversToolConfigurationsCreate
     * @request POST:/api/LeaversToolConfigurations
     * @secure
     */
    leaversToolConfigurationsCreate: (data: LeaversToolConfigurationCreateModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/LeaversToolConfigurations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags LeaversToolConfigurations
     * @name LeaversToolConfigurationsDetail
     * @request GET:/api/LeaversToolConfigurations/{configurationId}
     * @secure
     */
    leaversToolConfigurationsDetail: (configurationId: number, params: RequestParams = {}) =>
      this.request<LeaversToolConfigurationModel, void>({
        path: `/api/LeaversToolConfigurations/${configurationId}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  list = {
    /**
     * No description
     *
     * @tags List
     * @name ListCreate
     * @request POST:/api/List
     * @secure
     */
    listCreate: (data: ListSearchModel, params: RequestParams = {}) =>
      this.request<ListModel, void>({
        path: `/api/List`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags List
     * @name ListList
     * @request GET:/api/List
     * @secure
     */
    listList: (params: RequestParams = {}) =>
      this.request<ListConfigurationModel[], void>({
        path: `/api/List`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags List
     * @name ListListItemCreate
     * @request POST:/api/List/listItem
     * @secure
     */
    listListItemCreate: (data: ListItemsModel, params: RequestParams = {}) =>
      this.request<boolean, void>({
        path: `/api/List/listItem`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags List
     * @name ListListItemUpdate
     * @request PUT:/api/List/listItem
     * @secure
     */
    listListItemUpdate: (data: ListItemsModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/List/listItem`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags List
     * @name ListWorkflowDataFieldListList
     * @request GET:/api/List/workflowDataFieldList
     * @secure
     */
    listWorkflowDataFieldListList: (query: ListWorkflowDataFieldListListParams, params: RequestParams = {}) =>
      this.request<ListModel, void>({
        path: `/api/List/workflowDataFieldList`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags List
     * @name ListCanAddItemToListAsyncList
     * @request GET:/api/List/canAddItemToListAsync
     * @secure
     */
    listCanAddItemToListAsyncList: (query: ListCanAddItemToListAsyncListParams, params: RequestParams = {}) =>
      this.request<boolean, void>({
        path: `/api/List/canAddItemToListAsync`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      })
  };
  listMaintenanceConfiguration = {
    /**
     * No description
     *
     * @tags ListMaintenanceConfiguration
     * @name ListMaintenanceConfigurationBuiltinCreate
     * @request POST:/api/ListMaintenanceConfiguration/builtin
     * @secure
     */
    listMaintenanceConfigurationBuiltinCreate: (data: BuiltInListConfigurationModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/ListMaintenanceConfiguration/builtin`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ListMaintenanceConfiguration
     * @name ListMaintenanceConfigurationSqlCreate
     * @request POST:/api/ListMaintenanceConfiguration/sql
     * @secure
     */
    listMaintenanceConfigurationSqlCreate: (data: SqlListConfigurationModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/ListMaintenanceConfiguration/sql`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ListMaintenanceConfiguration
     * @name ListMaintenanceConfigurationListitemCreate
     * @request POST:/api/ListMaintenanceConfiguration/listitem
     * @secure
     */
    listMaintenanceConfigurationListitemCreate: (data: BuiltInListItemModel, params: RequestParams = {}) =>
      this.request<BuiltInListUpdateResultModel, void>({
        path: `/api/ListMaintenanceConfiguration/listitem`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ListMaintenanceConfiguration
     * @name ListMaintenanceConfigurationListitemUpdate
     * @request PUT:/api/ListMaintenanceConfiguration/listitem
     * @secure
     */
    listMaintenanceConfigurationListitemUpdate: (data: BuiltInListItemModel, params: RequestParams = {}) =>
      this.request<BuiltInListUpdateResultModel, void>({
        path: `/api/ListMaintenanceConfiguration/listitem`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ListMaintenanceConfiguration
     * @name ListMaintenanceConfigurationList
     * @request GET:/api/ListMaintenanceConfiguration
     * @secure
     */
    listMaintenanceConfigurationList: (params: RequestParams = {}) =>
      this.request<ListMaintenanceConfigurationModel, void>({
        path: `/api/ListMaintenanceConfiguration`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ListMaintenanceConfiguration
     * @name ListMaintenanceConfigurationBuiltinDetail
     * @request GET:/api/ListMaintenanceConfiguration/builtin/{id}
     * @secure
     */
    listMaintenanceConfigurationBuiltinDetail: (id: number, params: RequestParams = {}) =>
      this.request<BuiltInListConfigurationModel, void>({
        path: `/api/ListMaintenanceConfiguration/builtin/${id}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ListMaintenanceConfiguration
     * @name ListMaintenanceConfigurationLockDetail
     * @request GET:/api/ListMaintenanceConfiguration/lock/{listId}
     * @secure
     */
    listMaintenanceConfigurationLockDetail: (listId: number, params: RequestParams = {}) =>
      this.request<LockModel, void>({
        path: `/api/ListMaintenanceConfiguration/lock/${listId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ListMaintenanceConfiguration
     * @name ListMaintenanceConfigurationListItemDelete
     * @request DELETE:/api/ListMaintenanceConfiguration/listItem/{listId}
     * @secure
     */
    listMaintenanceConfigurationListItemDelete: (listId: number, data: ListMaintenanceConfigurationListItemDeletePayload, params: RequestParams = {}) =>
      this.request<BuiltInListItemModel[], void>({
        path: `/api/ListMaintenanceConfiguration/listItem/${listId}`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ListMaintenanceConfiguration
     * @name ListMaintenanceConfigurationChangeCreate
     * @request POST:/api/ListMaintenanceConfiguration/change
     * @secure
     */
    listMaintenanceConfigurationChangeCreate: (data: ConfigurationChangeModel, params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/ListMaintenanceConfiguration/change`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ListMaintenanceConfiguration
     * @name ListMaintenanceConfigurationChangeList
     * @request GET:/api/ListMaintenanceConfiguration/change
     * @secure
     */
    listMaintenanceConfigurationChangeList: (params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/ListMaintenanceConfiguration/change`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ListMaintenanceConfiguration
     * @name ListMaintenanceConfigurationChangeUpdate
     * @request PUT:/api/ListMaintenanceConfiguration/change/{id}
     * @secure
     */
    listMaintenanceConfigurationChangeUpdate: (id: number, params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/ListMaintenanceConfiguration/change/${id}`,
        method: 'PUT',
        secure: true,
        ...params
      })
  };
  lock = {
    /**
     * No description
     *
     * @tags Lock
     * @name LockUpdate
     * @request PUT:/api/Lock/{id}
     * @secure
     */
    lockUpdate: (id: number, params: RequestParams = {}) =>
      this.request<LockModel, void>({
        path: `/api/Lock/${id}`,
        method: 'PUT',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Lock
     * @name LockDelete
     * @request DELETE:/api/Lock/{id}
     * @secure
     */
    lockDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Lock/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Lock
     * @name LockAnyuserDelete
     * @request DELETE:/api/Lock/anyuser/{id}
     * @secure
     */
    lockAnyuserDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Lock/anyuser/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Lock
     * @name LockList
     * @request GET:/api/Lock
     * @secure
     */
    lockList: (query: LockListParams, params: RequestParams = {}) =>
      this.request<LockMaintenanceModel, void>({
        path: `/api/Lock`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      })
  };
  manufacturerTab = {
    /**
     * No description
     *
     * @tags ManufacturerTab
     * @name AutomotiveManufacturerTabDetail
     * @request GET:/api/automotive/ManufacturerTab/{queueId}/{jobId}/{saleType}/{manufacturer}
     * @secure
     */
    automotiveManufacturerTabDetail: (queueId: number, jobId: number, saleType: string, manufacturer: string, params: RequestParams = {}) =>
      this.request<ManufacturerTabModel, void>({
        path: `/api/automotive/ManufacturerTab/${queueId}/${jobId}/${saleType}/${manufacturer}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ManufacturerTab
     * @name AutomotiveManufacturerTabCreate
     * @request POST:/api/automotive/ManufacturerTab/{queueId}/{jobId}/{saleType}/{manufacturer}
     * @secure
     */
    automotiveManufacturerTabCreate: (queueId: number, jobId: number, saleType: string, manufacturer: string, data: WorkflowDataSourceModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/automotive/ManufacturerTab/${queueId}/${jobId}/${saleType}/${manufacturer}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  navBarAccess = {
    /**
     * No description
     *
     * @tags NavBarAccess
     * @name NavBarAccessList
     * @request GET:/api/NavBarAccess
     * @secure
     */
    navBarAccessList: (params: RequestParams = {}) =>
      this.request<NavBarAccessModel, void>({
        path: `/api/NavBarAccess`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  notes = {
    /**
     * No description
     *
     * @tags Notes
     * @name NotesDetail
     * @request GET:/api/Notes/{entityTypeId}/{entityPk}/{cabinetId}
     * @secure
     */
    notesDetail: (entityTypeId: number, entityPk: string, cabinetId: string, params: RequestParams = {}) =>
      this.request<NoteModel[], void>({
        path: `/api/Notes/${entityTypeId}/${entityPk}/${cabinetId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Notes
     * @name NotesCreate
     * @request POST:/api/Notes/{entityTypeId}/{entityPk}/{cabinetId}
     * @secure
     */
    notesCreate: (entityTypeId: number, entityPk: string, cabinetId: string, data: NoteCreateModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Notes/${entityTypeId}/${entityPk}/${cabinetId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Notes
     * @name NotesUpdate
     * @request PUT:/api/Notes/{entityTypeId}/{entityPk}/{cabinetId}
     * @secure
     */
    notesUpdate: (entityTypeId: number, entityPk: string, cabinetId: string, data: NoteModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Notes/${entityTypeId}/${entityPk}/${cabinetId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Notes
     * @name NotesDelete
     * @request DELETE:/api/Notes/{entityTypeId}/{entityPk}/{noteId}/{cabinetId}
     * @secure
     */
    notesDelete: (entityTypeId: number, entityPk: string, noteId: number, cabinetId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Notes/${entityTypeId}/${entityPk}/${noteId}/${cabinetId}`,
        method: 'DELETE',
        secure: true,
        ...params
      })
  };
  organisations = {
    /**
     * No description
     *
     * @tags Organisations
     * @name OrganisationsList
     * @request GET:/api/Organisations
     * @secure
     */
    organisationsList: (query: OrganisationsListParams, params: RequestParams = {}) =>
      this.request<OrganisationModel[], void>({
        path: `/api/Organisations`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name OrganisationsCreate
     * @request POST:/api/Organisations
     * @secure
     */
    organisationsCreate: (data: OrganisationCreateModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/Organisations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name OrganisationsDetail
     * @request GET:/api/Organisations/{id}
     * @secure
     */
    organisationsDetail: (id: number, params: RequestParams = {}) =>
      this.request<OrganisationModel, void>({
        path: `/api/Organisations/${id}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name OrganisationsUpdate
     * @request PUT:/api/Organisations/{id}
     * @secure
     */
    organisationsUpdate: (id: number, data: OrganisationUpdateModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Organisations/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name OrganisationsCheckMaintenancePermissionsList
     * @request GET:/api/Organisations/CheckMaintenancePermissions
     * @secure
     */
    organisationsCheckMaintenancePermissionsList: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Organisations/CheckMaintenancePermissions`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  parameter = {
    /**
     * No description
     *
     * @tags Parameter
     * @name ParameterList
     * @request GET:/api/Parameter
     * @secure
     */
    parameterList: (query: ParameterListParams, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/Parameter`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      })
  };
  referenceLookup = {
    /**
     * No description
     *
     * @tags ReferenceLookup
     * @name ReferenceLookupCreate
     * @request POST:/api/ReferenceLookup/{documentTypeId}
     * @secure
     */
    referenceLookupCreate: (documentTypeId: number, data: ReferenceLookupSearchModel, params: RequestParams = {}) =>
      this.request<ReferenceLookupResultModel, void>({
        path: `/api/ReferenceLookup/${documentTypeId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ReferenceLookup
     * @name ReferenceLookupDocumentsCreate
     * @request POST:/api/ReferenceLookup/{cabinetId}/{documentTypeId}/documents
     * @secure
     */
    referenceLookupDocumentsCreate: (cabinetId: string, documentTypeId: number, data: ReferenceLookupSearchModel, params: RequestParams = {}) =>
      this.request<DocumentReferencesResultModel, void>({
        path: `/api/ReferenceLookup/${cabinetId}/${documentTypeId}/documents`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  relatedDocuments = {
    /**
     * No description
     *
     * @tags RelatedDocuments
     * @name RelatedDocumentsDetail
     * @request GET:/api/RelatedDocuments/{cabinetId}/{documentId}
     * @secure
     */
    relatedDocumentsDetail: (cabinetId: string, documentId: number, params: RequestParams = {}) =>
      this.request<RelatedDocumentsModel, void>({
        path: `/api/RelatedDocuments/${cabinetId}/${documentId}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  roles = {
    /**
     * No description
     *
     * @tags Roles
     * @name RolesList
     * @request GET:/api/Roles
     * @secure
     */
    rolesList: (params: RequestParams = {}) =>
      this.request<RoleModel[], void>({
        path: `/api/Roles`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name RolesCreate
     * @request POST:/api/Roles
     * @secure
     */
    rolesCreate: (data: RoleCreateModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/Roles`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name RolesDetail
     * @request GET:/api/Roles/{id}
     * @secure
     */
    rolesDetail: (id: number, params: RequestParams = {}) =>
      this.request<RoleModel, void>({
        path: `/api/Roles/${id}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name RolesUpdate
     * @request PUT:/api/Roles/{id}
     * @secure
     */
    rolesUpdate: (id: number, data: RoleUpdateModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Roles/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name RolesDelete
     * @request DELETE:/api/Roles/{id}
     * @secure
     */
    rolesDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Roles/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name RolesUsersDetail
     * @request GET:/api/Roles/{id}/Users
     * @secure
     */
    rolesUsersDetail: (id: number, params: RequestParams = {}) =>
      this.request<UserModel[], void>({
        path: `/api/Roles/${id}/Users`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name RolesUsersUpdate
     * @request PUT:/api/Roles/{id}/Users
     * @secure
     */
    rolesUsersUpdate: (id: number, data: RoleUsersUpdateModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Roles/${id}/Users`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name RolesCopyRoleCreate
     * @request POST:/api/Roles/CopyRole
     * @secure
     */
    rolesCopyRoleCreate: (data: RoleCopyModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/Roles/CopyRole`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name RolesCheckMaintenancePermissionsList
     * @request GET:/api/Roles/CheckMaintenancePermissions
     * @secure
     */
    rolesCheckMaintenancePermissionsList: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Roles/CheckMaintenancePermissions`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  salesPackTab = {
    /**
     * No description
     *
     * @tags SalesPackTab
     * @name AutomotiveSalesPackTabPreSalesPackDetail
     * @request GET:/api/automotive/SalesPackTab/PreSalesPack/{workflowJobId}
     * @secure
     */
    automotiveSalesPackTabPreSalesPackDetail: (workflowJobId: number, params: RequestParams = {}) =>
      this.request<SalesPackTabModel[], void>({
        path: `/api/automotive/SalesPackTab/PreSalesPack/${workflowJobId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags SalesPackTab
     * @name AutomotiveSalesPackTabPostSalesPackDetail
     * @request GET:/api/automotive/SalesPackTab/PostSalesPack/{workflowJobId}
     * @secure
     */
    automotiveSalesPackTabPostSalesPackDetail: (workflowJobId: number, params: RequestParams = {}) =>
      this.request<SalesPackTabModel[], void>({
        path: `/api/automotive/SalesPackTab/PostSalesPack/${workflowJobId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags SalesPackTab
     * @name AutomotiveSalesPackTabPreviewPreSalesPackCreate
     * @request POST:/api/automotive/SalesPackTab/PreviewPreSalesPack/{workflowJobId}
     * @secure
     */
    automotiveSalesPackTabPreviewPreSalesPackCreate: (workflowJobId: number, data: AutomotiveSalesPackTabPreviewPreSalesPackCreatePayload, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/automotive/SalesPackTab/PreviewPreSalesPack/${workflowJobId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags SalesPackTab
     * @name AutomotiveSalesPackTabPreviewPostSalesPackCreate
     * @request POST:/api/automotive/SalesPackTab/PreviewPostSalesPack/{workflowJobId}
     * @secure
     */
    automotiveSalesPackTabPreviewPostSalesPackCreate: (workflowJobId: number, data: AutomotiveSalesPackTabPreviewPostSalesPackCreatePayload, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/automotive/SalesPackTab/PreviewPostSalesPack/${workflowJobId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags SalesPackTab
     * @name AutomotiveSalesPackTabSignPreSalesPackCreate
     * @request POST:/api/automotive/SalesPackTab/SignPreSalesPack/{workflowJobId}/{useOnFido}
     * @secure
     */
    automotiveSalesPackTabSignPreSalesPackCreate: (workflowJobId: number, useOnFido: boolean, data: AutomotiveSalesPackTabSignPreSalesPackCreatePayload, params: RequestParams = {}) =>
      this.request<WorkflowJobProcessResultModel, void>({
        path: `/api/automotive/SalesPackTab/SignPreSalesPack/${workflowJobId}/${useOnFido}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags SalesPackTab
     * @name AutomotiveSalesPackTabSignPostSalesPackCreate
     * @request POST:/api/automotive/SalesPackTab/SignPostSalesPack/{workflowJobId}/{useOnFido}
     * @secure
     */
    automotiveSalesPackTabSignPostSalesPackCreate: (workflowJobId: number, useOnFido: boolean, data: AutomotiveSalesPackTabSignPostSalesPackCreatePayload, params: RequestParams = {}) =>
      this.request<WorkflowJobProcessResultModel, void>({
        path: `/api/automotive/SalesPackTab/SignPostSalesPack/${workflowJobId}/${useOnFido}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  scriveCallback = {
    /**
     * No description
     *
     * @tags ScriveCallback
     * @name ScriveCallbackListenerCreate
     * @request POST:/api/ScriveCallback/Listener
     * @secure
     */
    scriveCallbackListenerCreate: (data: ScriveFlowApiCallbackResponseModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ScriveCallback/Listener`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  scriveConfiguration = {
    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationAuthenticationKeyUpdate
     * @request PUT:/api/ScriveConfiguration/AuthenticationKey
     * @secure
     */
    scriveConfigurationAuthenticationKeyUpdate: (data: ScriveAccessCredentialsModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ScriveConfiguration/AuthenticationKey`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationClearAuthenticationKeyUpdate
     * @request PUT:/api/ScriveConfiguration/ClearAuthenticationKey
     * @secure
     */
    scriveConfigurationClearAuthenticationKeyUpdate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ScriveConfiguration/ClearAuthenticationKey`,
        method: 'PUT',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationIsAuthenticationKeySetList
     * @request GET:/api/ScriveConfiguration/IsAuthenticationKeySet
     * @secure
     */
    scriveConfigurationIsAuthenticationKeySetList: (params: RequestParams = {}) =>
      this.request<boolean, void>({
        path: `/api/ScriveConfiguration/IsAuthenticationKeySet`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationDocumentTypeConfigurationList
     * @request GET:/api/ScriveConfiguration/documentType/configuration
     * @secure
     */
    scriveConfigurationDocumentTypeConfigurationList: (query: ScriveConfigurationDocumentTypeConfigurationListParams, params: RequestParams = {}) =>
      this.request<ArenaSignDocumentTypeConfigurationModel, void>({
        path: `/api/ScriveConfiguration/documentType/configuration`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationDocumentTypeUpdate
     * @request PUT:/api/ScriveConfiguration/documentType/{documentTypeId}
     * @secure
     */
    scriveConfigurationDocumentTypeUpdate: (documentTypeId: number, data: DocumentTypeUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/documentType/${documentTypeId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSignerRolesList
     * @request GET:/api/ScriveConfiguration/signerRoles
     * @secure
     */
    scriveConfigurationSignerRolesList: (query: ScriveConfigurationSignerRolesListParams, params: RequestParams = {}) =>
      this.request<SignerRolesConfigurationModel, void>({
        path: `/api/ScriveConfiguration/signerRoles`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSignerRoleDetail
     * @request GET:/api/ScriveConfiguration/{documentTypeId}/signerRole
     * @secure
     */
    scriveConfigurationSignerRoleDetail: ({ documentTypeId, ...query }: ScriveConfigurationSignerRoleDetailParams, params: RequestParams = {}) =>
      this.request<ArenaSignSignerRoleConfigurationModel, void>({
        path: `/api/ScriveConfiguration/${documentTypeId}/signerRole`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSignerRoleCreate
     * @request POST:/api/ScriveConfiguration/{documentTypeId}/signerRole
     * @secure
     */
    scriveConfigurationSignerRoleCreate: (documentTypeId: number, data: SignerRoleCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/${documentTypeId}/signerRole`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSignerRoleUpdate
     * @request PUT:/api/ScriveConfiguration/{documentTypeId}/signerRole/{id}
     * @secure
     */
    scriveConfigurationSignerRoleUpdate: (documentTypeId: number, id: number, data: SignerRoleCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/${documentTypeId}/signerRole/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSignerRoleDelete
     * @request DELETE:/api/ScriveConfiguration/signerRole/{id}
     * @secure
     */
    scriveConfigurationSignerRoleDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ScriveConfiguration/signerRole/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationTemplatesConfigurationList
     * @request GET:/api/ScriveConfiguration/templates/configuration
     * @secure
     */
    scriveConfigurationTemplatesConfigurationList: (query: ScriveConfigurationTemplatesConfigurationListParams, params: RequestParams = {}) =>
      this.request<ScriveTemplatesConfigurationModel, void>({
        path: `/api/ScriveConfiguration/templates/configuration`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationTemplateConfigurationList
     * @request GET:/api/ScriveConfiguration/template/configuration
     * @secure
     */
    scriveConfigurationTemplateConfigurationList: (query: ScriveConfigurationTemplateConfigurationListParams, params: RequestParams = {}) =>
      this.request<ScriveTemplateConfigurationModel, void>({
        path: `/api/ScriveConfiguration/template/configuration`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationTemplateUpdate
     * @request PUT:/api/ScriveConfiguration/template/{id}
     * @secure
     */
    scriveConfigurationTemplateUpdate: (id: number, data: ArenaSignTemplateCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/template/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationTemplateDelete
     * @request DELETE:/api/ScriveConfiguration/template/{id}
     * @secure
     */
    scriveConfigurationTemplateDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ScriveConfiguration/template/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationTemplateCreate
     * @request POST:/api/ScriveConfiguration/template
     * @secure
     */
    scriveConfigurationTemplateCreate: (data: ArenaSignTemplateCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyConfigurationList
     * @request GET:/api/ScriveConfiguration/signingparty/configuration
     * @secure
     */
    scriveConfigurationSigningpartyConfigurationList: (query: ScriveConfigurationSigningpartyConfigurationListParams, params: RequestParams = {}) =>
      this.request<ScriveTemplateSigningPartyConfigurationModel, void>({
        path: `/api/ScriveConfiguration/signingparty/configuration`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyCreate
     * @request POST:/api/ScriveConfiguration/signingparty
     * @secure
     */
    scriveConfigurationSigningpartyCreate: (data: ScriveTemplateSigningPartyCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/signingparty`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyUpdate
     * @request PUT:/api/ScriveConfiguration/signingparty/{id}
     * @secure
     */
    scriveConfigurationSigningpartyUpdate: (id: number, data: ScriveTemplateSigningPartyCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/signingparty/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyDelete
     * @request DELETE:/api/ScriveConfiguration/signingparty/{id}
     * @secure
     */
    scriveConfigurationSigningpartyDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ScriveConfiguration/signingparty/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyfieldConfigurationList
     * @request GET:/api/ScriveConfiguration/signingpartyfield/configuration
     * @secure
     */
    scriveConfigurationSigningpartyfieldConfigurationList: (query: ScriveConfigurationSigningpartyfieldConfigurationListParams, params: RequestParams = {}) =>
      this.request<ScriveTemplateSigningPartyFieldModel, void>({
        path: `/api/ScriveConfiguration/signingpartyfield/configuration`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyfieldCreate
     * @request POST:/api/ScriveConfiguration/signingpartyfield
     * @secure
     */
    scriveConfigurationSigningpartyfieldCreate: (data: ScriveTemplateSigningPartyFieldCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/signingpartyfield`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyfieldUpdate
     * @request PUT:/api/ScriveConfiguration/signingpartyfield/{id}
     * @secure
     */
    scriveConfigurationSigningpartyfieldUpdate: (id: number, data: ScriveTemplateSigningPartyFieldCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/signingpartyfield/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyfieldDelete
     * @request DELETE:/api/ScriveConfiguration/signingpartyfield/{id}
     * @secure
     */
    scriveConfigurationSigningpartyfieldDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ScriveConfiguration/signingpartyfield/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyfieldplacementConfigurationList
     * @request GET:/api/ScriveConfiguration/signingpartyfieldplacement/configuration
     * @secure
     */
    scriveConfigurationSigningpartyfieldplacementConfigurationList: (query: ScriveConfigurationSigningpartyfieldplacementConfigurationListParams, params: RequestParams = {}) =>
      this.request<ScriveTemplateSigningPartyFieldPlacementModel, void>({
        path: `/api/ScriveConfiguration/signingpartyfieldplacement/configuration`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyfieldplacementCreate
     * @request POST:/api/ScriveConfiguration/signingpartyfieldplacement
     * @secure
     */
    scriveConfigurationSigningpartyfieldplacementCreate: (data: ScriveTemplateSigningPartyFieldPlacementCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/signingpartyfieldplacement`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyfieldplacementUpdate
     * @request PUT:/api/ScriveConfiguration/signingpartyfieldplacement/{id}
     * @secure
     */
    scriveConfigurationSigningpartyfieldplacementUpdate: (id: number, data: ScriveTemplateSigningPartyFieldPlacementCreateUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/signingpartyfieldplacement/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSigningpartyfieldplacementDelete
     * @request DELETE:/api/ScriveConfiguration/signingpartyfieldplacement/{id}
     * @secure
     */
    scriveConfigurationSigningpartyfieldplacementDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ScriveConfiguration/signingpartyfieldplacement/${id}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSettingsList
     * @request GET:/api/ScriveConfiguration/Settings
     * @secure
     */
    scriveConfigurationSettingsList: (query: ScriveConfigurationSettingsListParams, params: RequestParams = {}) =>
      this.request<ScriveSettingsConfigurationModel, void>({
        path: `/api/ScriveConfiguration/Settings`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationSettingsCreate
     * @request POST:/api/ScriveConfiguration/Settings/{documentTypeId}
     * @secure
     */
    scriveConfigurationSettingsCreate: (documentTypeId: number, data: ScriveSettingsModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ScriveConfiguration/Settings/${documentTypeId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationTemplateAfterSignSettingList
     * @request GET:/api/ScriveConfiguration/templateAfterSignSetting
     * @secure
     */
    scriveConfigurationTemplateAfterSignSettingList: (params: RequestParams = {}) =>
      this.request<TemplateAfterSignSettingModel[], void>({
        path: `/api/ScriveConfiguration/templateAfterSignSetting`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationTemplateAfterSignSettingUpdate
     * @request PUT:/api/ScriveConfiguration/templateAfterSignSetting
     * @secure
     */
    scriveConfigurationTemplateAfterSignSettingUpdate: (data: TemplateAfterSignSettingConfigurationUpdateModel, params: RequestParams = {}) =>
      this.request<ArenaSignBaseResultModel, void>({
        path: `/api/ScriveConfiguration/templateAfterSignSetting`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveConfiguration
     * @name ScriveConfigurationTemplateAfterSignSettingDetail
     * @request GET:/api/ScriveConfiguration/templateAfterSignSetting/{templateAfterSignId}
     * @secure
     */
    scriveConfigurationTemplateAfterSignSettingDetail: (templateAfterSignId: number, params: RequestParams = {}) =>
      this.request<TemplateAfterSignSettingConfigurationModel, void>({
        path: `/api/ScriveConfiguration/templateAfterSignSetting/${templateAfterSignId}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  scriveSignersTab = {
    /**
     * No description
     *
     * @tags ScriveSignersTab
     * @name ScriveScriveSignersTabDetail
     * @request GET:/api/scrive/ScriveSignersTab/{jobId}
     * @secure
     */
    scriveScriveSignersTabDetail: (jobId: number, params: RequestParams = {}) =>
      this.request<ScriveSignersTabModel, void>({
        path: `/api/scrive/ScriveSignersTab/${jobId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveSignersTab
     * @name ScriveScriveSignersTabCreate
     * @request POST:/api/scrive/ScriveSignersTab/{jobId}
     * @secure
     */
    scriveScriveSignersTabCreate: (jobId: number, data: ScriveSignersDataSourceModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/scrive/ScriveSignersTab/${jobId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveSignersTab
     * @name ScriveScriveSignersTabSendforsigningCreate
     * @request POST:/api/scrive/ScriveSignersTab/sendforsigning/{jobId}
     * @secure
     */
    scriveScriveSignersTabSendforsigningCreate: (jobId: number, data: ScriveSignersDataSourceModel, params: RequestParams = {}) =>
      this.request<WorkflowJobProcessResultModel, void>({
        path: `/api/scrive/ScriveSignersTab/sendforsigning/${jobId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  scriveSigning = {
    /**
     * No description
     *
     * @tags ScriveSigning
     * @name ScriveSigningCreate
     * @request POST:/api/ScriveSigning
     * @secure
     */
    scriveSigningCreate: (data: ScriveSigningModel, params: RequestParams = {}) =>
      this.request<ScriveSubmitDocumentsForSigningResultModel, void>({
        path: `/api/ScriveSigning`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveSigning
     * @name ScriveSigningPostSampleCreate
     * @request POST:/api/ScriveSigning/PostSample
     * @secure
     */
    scriveSigningPostSampleCreate: (query: ScriveSigningPostSampleCreateParams, params: RequestParams = {}) =>
      this.request<ScriveSubmitDocumentsForSigningResultModel, void>({
        path: `/api/ScriveSigning/PostSample`,
        method: 'POST',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags ScriveSigning
     * @name ScriveSigningSignedDocumentDetail
     * @request GET:/api/ScriveSigning/SignedDocument/{scriveDocumentId}
     * @secure
     */
    scriveSigningSignedDocumentDetail: (scriveDocumentId: string, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/ScriveSigning/SignedDocument/${scriveDocumentId}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  scriveWorkflowJob = {
    /**
     * No description
     *
     * @tags ScriveWorkflowJob
     * @name ScriveWorkflowJobGroupActionCreate
     * @request POST:/api/ScriveWorkflowJob/groupAction/{queueId}
     * @secure
     */
    scriveWorkflowJobGroupActionCreate: (queueId: number, data: ScriveGroupActionModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ScriveWorkflowJob/groupAction/${queueId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  search = {
    /**
     * No description
     *
     * @tags Search
     * @name SearchPerformsearchCreate
     * @request POST:/api/Search/performsearch
     * @secure
     */
    searchPerformsearchCreate: (data: SearchRequestModel, params: RequestParams = {}) =>
      this.request<SearchResultsModel, void>({
        path: `/api/Search/performsearch`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchSearchBuilderList
     * @request GET:/api/Search/searchBuilder
     * @secure
     */
    searchSearchBuilderList: (params: RequestParams = {}) =>
      this.request<SearchBuilderModel, void>({
        path: `/api/Search/searchBuilder`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchCabinetReferencesDetail
     * @request GET:/api/Search/cabinetReferences/{cabinetId}
     * @secure
     */
    searchCabinetReferencesDetail: (cabinetId: string, params: RequestParams = {}) =>
      this.request<SearchReferenceModel[], void>({
        path: `/api/Search/cabinetReferences/${cabinetId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchDocumentReferencesDetail
     * @request GET:/api/Search/documentReferences/{cabinetId}/{documentTypeId}
     * @secure
     */
    searchDocumentReferencesDetail: (cabinetId: string, documentTypeId: number, params: RequestParams = {}) =>
      this.request<SearchReferenceModel[], void>({
        path: `/api/Search/documentReferences/${cabinetId}/${documentTypeId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchSavedSearchesList
     * @request GET:/api/Search/savedSearches
     * @secure
     */
    searchSavedSearchesList: (params: RequestParams = {}) =>
      this.request<SavedSearchModel[], void>({
        path: `/api/Search/savedSearches`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchSavedSearchesDetail
     * @request GET:/api/Search/savedSearches/{id}
     * @secure
     */
    searchSavedSearchesDetail: (id: number, params: RequestParams = {}) =>
      this.request<SavedSearchModel, void>({
        path: `/api/Search/savedSearches/${id}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchSavedSearchCreate
     * @request POST:/api/Search/savedSearch
     * @secure
     */
    searchSavedSearchCreate: (data: CreateSavedSearchModel, params: RequestParams = {}) =>
      this.request<SavedSearchModel, void>({
        path: `/api/Search/savedSearch`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchSavedSearchUpdate
     * @request PUT:/api/Search/savedSearch
     * @secure
     */
    searchSavedSearchUpdate: (data: SavedSearchModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Search/savedSearch`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchSavedSearchesDelete
     * @request DELETE:/api/Search/savedSearches/{savedSearchId}
     * @secure
     */
    searchSavedSearchesDelete: (savedSearchId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Search/savedSearches/${savedSearchId}`,
        method: 'DELETE',
        secure: true,
        ...params
      })
  };
  securityConfiguration = {
    /**
     * No description
     *
     * @tags SecurityConfiguration
     * @name SecurityConfigurationDetail
     * @request GET:/api/SecurityConfiguration/{entityTypeId}/{entityPk}
     * @secure
     */
    securityConfigurationDetail: (entityTypeId: MStoreEntityId, entityPk: string, params: RequestParams = {}) =>
      this.request<SecurityConfigurationModel, void>({
        path: `/api/SecurityConfiguration/${entityTypeId}/${entityPk}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags SecurityConfiguration
     * @name SecurityConfigurationUpdate
     * @request PUT:/api/SecurityConfiguration/{entityTypeId}/{entityPk}
     * @secure
     */
    securityConfigurationUpdate: (entityTypeId: MStoreEntityId, entityPk: string, data: SecurityEntityModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/SecurityConfiguration/${entityTypeId}/${entityPk}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  signature = {
    /**
     * No description
     *
     * @tags Signature
     * @name SignatureDetail
     * @request GET:/api/Signature/{cabinetId}/{documentId}
     * @secure
     */
    signatureDetail: (cabinetId: string, documentId: number, params: RequestParams = {}) =>
      this.request<SignatureTemplateModel, void>({
        path: `/api/Signature/${cabinetId}/${documentId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Signature
     * @name SignatureCreate
     * @request POST:/api/Signature/{cabinetId}/{documentId}
     * @secure
     */
    signatureCreate: (cabinetId: string, documentId: number, data: SignatureCreateModel, params: RequestParams = {}) =>
      this.request<DocumentSearchModel, void>({
        path: `/api/Signature/${cabinetId}/${documentId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  signersTab = {
    /**
     * No description
     *
     * @tags SignersTab
     * @name DocusignSignersTabDetail
     * @request GET:/api/docusign/SignersTab/{jobId}
     * @secure
     */
    docusignSignersTabDetail: (jobId: number, params: RequestParams = {}) =>
      this.request<SignersTabModel, void>({
        path: `/api/docusign/SignersTab/${jobId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags SignersTab
     * @name DocusignSignersTabCreate
     * @request POST:/api/docusign/SignersTab/{jobId}
     * @secure
     */
    docusignSignersTabCreate: (jobId: number, data: SignersDataSourceModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/docusign/SignersTab/${jobId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  singleSignOnConfiguration = {
    /**
     * No description
     *
     * @tags SingleSignOnConfiguration
     * @name SingleSignOnConfigurationList
     * @request GET:/api/SingleSignOnConfiguration
     * @secure
     */
    singleSignOnConfigurationList: (params: RequestParams = {}) =>
      this.request<SingleSignOnConfigurationModel, void>({
        path: `/api/SingleSignOnConfiguration`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags SingleSignOnConfiguration
     * @name SingleSignOnConfigurationUpdate
     * @request PUT:/api/SingleSignOnConfiguration
     * @secure
     */
    singleSignOnConfigurationUpdate: (data: AuthClientConfigurationModel, params: RequestParams = {}) =>
      this.request<AuthClientConfigurationModel, void>({
        path: `/api/SingleSignOnConfiguration`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags SingleSignOnConfiguration
     * @name SingleSignOnConfigurationEnabledUpdate
     * @request PUT:/api/SingleSignOnConfiguration/enabled
     * @secure
     */
    singleSignOnConfigurationEnabledUpdate: (data: AuthClientConfigurationModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/SingleSignOnConfiguration/enabled`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags SingleSignOnConfiguration
     * @name SingleSignOnConfigurationSinglesignonenabledUpdate
     * @request PUT:/api/SingleSignOnConfiguration/singlesignonenabled
     * @secure
     */
    singleSignOnConfigurationSinglesignonenabledUpdate: (query: SingleSignOnConfigurationSinglesignonenabledUpdateParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/SingleSignOnConfiguration/singlesignonenabled`,
        method: 'PUT',
        query: query,
        secure: true,
        ...params
      })
  };
  taskServicesConfiguration = {
    /**
     * No description
     *
     * @tags TaskServicesConfiguration
     * @name TaskServicesConfigurationUpdate
     * @request PUT:/api/TaskServicesConfiguration/{serviceName}
     * @secure
     */
    taskServicesConfigurationUpdate: (serviceName: string, data: TaskServiceSettingsConfigurationModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/TaskServicesConfiguration/${serviceName}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags TaskServicesConfiguration
     * @name TaskServicesConfigurationDetail
     * @request GET:/api/TaskServicesConfiguration/{serviceName}
     * @secure
     */
    taskServicesConfigurationDetail: (serviceName: string, params: RequestParams = {}) =>
      this.request<TaskServiceSettingsConfigurationModel, void>({
        path: `/api/TaskServicesConfiguration/${serviceName}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags TaskServicesConfiguration
     * @name TaskServicesConfigurationList
     * @request GET:/api/TaskServicesConfiguration
     * @secure
     */
    taskServicesConfigurationList: (params: RequestParams = {}) =>
      this.request<TaskService[], void>({
        path: `/api/TaskServicesConfiguration`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags TaskServicesConfiguration
     * @name TaskServicesConfigurationGlobalConfigurationList
     * @request GET:/api/TaskServicesConfiguration/globalConfiguration
     * @secure
     */
    taskServicesConfigurationGlobalConfigurationList: (params: RequestParams = {}) =>
      this.request<TaskServicesGlobalConfigurationModel, void>({
        path: `/api/TaskServicesConfiguration/globalConfiguration`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags TaskServicesConfiguration
     * @name TaskServicesConfigurationGlobalConfigurationUpdate
     * @request PUT:/api/TaskServicesConfiguration/globalConfiguration
     * @secure
     */
    taskServicesConfigurationGlobalConfigurationUpdate: (data: TaskServicesGlobalConfigurationModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/TaskServicesConfiguration/globalConfiguration`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags TaskServicesConfiguration
     * @name TaskServicesConfigurationHostsList
     * @request GET:/api/TaskServicesConfiguration/hosts
     * @secure
     */
    taskServicesConfigurationHostsList: (params: RequestParams = {}) =>
      this.request<TaskServiceHost[], void>({
        path: `/api/TaskServicesConfiguration/hosts`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags TaskServicesConfiguration
     * @name TaskServicesConfigurationChangeCreate
     * @request POST:/api/TaskServicesConfiguration/change
     * @secure
     */
    taskServicesConfigurationChangeCreate: (data: ConfigurationChangeModel, params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/TaskServicesConfiguration/change`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags TaskServicesConfiguration
     * @name TaskServicesConfigurationChangeList
     * @request GET:/api/TaskServicesConfiguration/change
     * @secure
     */
    taskServicesConfigurationChangeList: (params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/TaskServicesConfiguration/change`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags TaskServicesConfiguration
     * @name TaskServicesConfigurationChangeUpdate
     * @request PUT:/api/TaskServicesConfiguration/change/{id}
     * @secure
     */
    taskServicesConfigurationChangeUpdate: (id: number, params: RequestParams = {}) =>
      this.request<ConfigurationChangeModel, void>({
        path: `/api/TaskServicesConfiguration/change/${id}`,
        method: 'PUT',
        secure: true,
        ...params
      })
  };
  tools = {
    /**
     * No description
     *
     * @tags Tools
     * @name ToolsList
     * @request GET:/api/Tools
     * @secure
     */
    toolsList: (params: RequestParams = {}) =>
      this.request<ToolsModel, void>({
        path: `/api/Tools`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Tools
     * @name ToolsDeleteV3ConnectorCacheSettingsDelete
     * @request DELETE:/api/Tools/deleteV3ConnectorCacheSettings
     * @secure
     */
    toolsDeleteV3ConnectorCacheSettingsDelete: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Tools/deleteV3ConnectorCacheSettings`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Tools
     * @name ToolsDocumentRetentionList
     * @request GET:/api/Tools/documentRetention
     * @secure
     */
    toolsDocumentRetentionList: (params: RequestParams = {}) =>
      this.request<DocumentsToReviewCountModel, void>({
        path: `/api/Tools/documentRetention`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Tools
     * @name ToolsDocumentRetentionDetail
     * @request GET:/api/Tools/documentRetention/{cabinetId}
     * @secure
     */
    toolsDocumentRetentionDetail: ({ cabinetId, ...query }: ToolsDocumentRetentionDetailParams, params: RequestParams = {}) =>
      this.request<DocumentsToReviewModel, void>({
        path: `/api/Tools/documentRetention/${cabinetId}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Tools
     * @name ToolsCreateExceptionalJobCreate
     * @request POST:/api/Tools/createExceptionalJob
     * @secure
     */
    toolsCreateExceptionalJobCreate: (data: ExceptionalJobCreateModel, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/Tools/createExceptionalJob`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Tools
     * @name ToolsExceptionalJobsList
     * @request GET:/api/Tools/exceptionalJobs
     * @secure
     */
    toolsExceptionalJobsList: (params: RequestParams = {}) =>
      this.request<ExceptionalJobModel[], void>({
        path: `/api/Tools/exceptionalJobs`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Tools
     * @name ToolsExceptionaljobuniqueidList
     * @request GET:/api/Tools/exceptionaljobuniqueid
     * @secure
     */
    toolsExceptionaljobuniqueidList: (params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/Tools/exceptionaljobuniqueid`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  userNotification = {
    /**
     * No description
     *
     * @tags UserNotification
     * @name UserNotificationSendCreate
     * @request POST:/api/UserNotification/send/{userId}
     * @secure
     */
    userNotificationSendCreate: (userId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/UserNotification/send/${userId}`,
        method: 'POST',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags UserNotification
     * @name UserNotificationList
     * @request GET:/api/UserNotification
     * @secure
     */
    userNotificationList: (params: RequestParams = {}) =>
      this.request<UserNotificationModel[], void>({
        path: `/api/UserNotification`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags UserNotification
     * @name UserNotificationSeenCreate
     * @request POST:/api/UserNotification/seen
     * @secure
     */
    userNotificationSeenCreate: (params: RequestParams = {}) =>
      this.request<UserNotificationModel[], void>({
        path: `/api/UserNotification/seen`,
        method: 'POST',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags UserNotification
     * @name UserNotificationDeleteUpdate
     * @request PUT:/api/UserNotification/delete/{id}
     * @secure
     */
    userNotificationDeleteUpdate: (id: number, params: RequestParams = {}) =>
      this.request<UserNotificationModel[], void>({
        path: `/api/UserNotification/delete/${id}`,
        method: 'PUT',
        secure: true,
        ...params
      })
  };
  users = {
    /**
     * No description
     *
     * @tags Users
     * @name UsersCurrentUserList
     * @request GET:/api/Users/CurrentUser
     * @secure
     */
    usersCurrentUserList: (params: RequestParams = {}) =>
      this.request<UserModel, void>({
        path: `/api/Users/CurrentUser`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersList
     * @request GET:/api/Users
     * @secure
     */
    usersList: (query: UsersListParams, params: RequestParams = {}) =>
      this.request<UserModel[], void>({
        path: `/api/Users`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersCreate
     * @request POST:/api/Users
     * @secure
     */
    usersCreate: (data: UserCreateModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/Users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersDetail
     * @request GET:/api/Users/{id}
     * @secure
     */
    usersDetail: (id: number, params: RequestParams = {}) =>
      this.request<UserModel, void>({
        path: `/api/Users/${id}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersUpdate
     * @request PUT:/api/Users/{id}
     * @secure
     */
    usersUpdate: (id: number, data: UserUpdateModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Users/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersCopyUserCreate
     * @request POST:/api/Users/CopyUser
     * @secure
     */
    usersCopyUserCreate: (data: UserCopyModel, params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/Users/CopyUser`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersRolesUpdate
     * @request PUT:/api/Users/{id}/Roles
     * @secure
     */
    usersRolesUpdate: (id: number, data: UserRolesUpdateModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Users/${id}/Roles`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersRolesDetail
     * @request GET:/api/Users/{id}/Roles
     * @secure
     */
    usersRolesDetail: (id: number, params: RequestParams = {}) =>
      this.request<RoleModel[], void>({
        path: `/api/Users/${id}/Roles`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersSendWelcomeEmailCreate
     * @request POST:/api/Users/SendWelcomeEmail/{id}
     * @secure
     */
    usersSendWelcomeEmailCreate: (id: number, params: RequestParams = {}) =>
      this.request<boolean, void>({
        path: `/api/Users/SendWelcomeEmail/${id}`,
        method: 'POST',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersSendPasswordResetEmailCreate
     * @request POST:/api/Users/SendPasswordResetEmail/{id}
     * @secure
     */
    usersSendPasswordResetEmailCreate: (id: number, params: RequestParams = {}) =>
      this.request<boolean, void>({
        path: `/api/Users/SendPasswordResetEmail/${id}`,
        method: 'POST',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersCurrentUserRolesList
     * @request GET:/api/Users/CurrentUser/Roles
     * @secure
     */
    usersCurrentUserRolesList: (params: RequestParams = {}) =>
      this.request<RoleModel[], void>({
        path: `/api/Users/CurrentUser/Roles`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersRemoveAccessLockCreate
     * @request POST:/api/Users/RemoveAccessLock/{id}
     * @secure
     */
    usersRemoveAccessLockCreate: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Users/RemoveAccessLock/${id}`,
        method: 'POST',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersCheckMaintenancePermissionsList
     * @request GET:/api/Users/CheckMaintenancePermissions
     * @secure
     */
    usersCheckMaintenancePermissionsList: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Users/CheckMaintenancePermissions`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersCurrentUserWindowsAutoLogInUpdate
     * @request PUT:/api/Users/CurrentUser/WindowsAutoLogIn
     * @secure
     */
    usersCurrentUserWindowsAutoLogInUpdate: (data: UserWindowsAutoLogInModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Users/CurrentUser/WindowsAutoLogIn`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersAuthclientsList
     * @request GET:/api/Users/authclients
     * @secure
     */
    usersAuthclientsList: (params: RequestParams = {}) =>
      this.request<SingleSignOnUserConfigurationModel, void>({
        path: `/api/Users/authclients`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersCountUsersWithLegacyPasswordHashesList
     * @request GET:/api/Users/count-users-with-legacy-password-hashes
     * @secure
     */
    usersCountUsersWithLegacyPasswordHashesList: (params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/Users/count-users-with-legacy-password-hashes`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersUpdateLegacyPasswordHashesCreate
     * @request POST:/api/Users/update-legacy-password-hashes
     * @secure
     */
    usersUpdateLegacyPasswordHashesCreate: (params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/Users/update-legacy-password-hashes`,
        method: 'POST',
        secure: true,
        ...params
      })
  };
  workflowJob = {
    /**
     * No description
     *
     * @tags WorkflowJob
     * @name WorkflowJobWorkflowJobHasLockDetail
     * @request GET:/api/WorkflowJob/{queueId}/{jobId}/workflowJobHasLock
     * @secure
     */
    workflowJobWorkflowJobHasLockDetail: (queueId: number, jobId: number, params: RequestParams = {}) =>
      this.request<LockModel, void>({
        path: `/api/WorkflowJob/${queueId}/${jobId}/workflowJobHasLock`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowJob
     * @name WorkflowJobDetail
     * @request GET:/api/WorkflowJob/{queueId}/{jobId}/{isReadonly}
     * @secure
     */
    workflowJobDetail: (queueId: number, jobId: number, isReadonly: boolean, params: RequestParams = {}) =>
      this.request<WorkflowJobModel, void>({
        path: `/api/WorkflowJob/${queueId}/${jobId}/${isReadonly}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowJob
     * @name WorkflowJobDocumentDetail
     * @request GET:/api/WorkflowJob/document/{jobId}
     * @secure
     */
    workflowJobDocumentDetail: ({ jobId, ...query }: WorkflowJobDocumentDetailParams, params: RequestParams = {}) =>
      this.request<DocumentViewModel, void>({
        path: `/api/WorkflowJob/document/${jobId}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowJob
     * @name WorkflowJobHistoryDetail
     * @request GET:/api/WorkflowJob/history/{jobId}
     * @secure
     */
    workflowJobHistoryDetail: (jobId: number, params: RequestParams = {}) =>
      this.request<WorkflowJobHistoryDataModel, void>({
        path: `/api/WorkflowJob/history/${jobId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowJob
     * @name WorkflowJobAuditDetail
     * @request GET:/api/WorkflowJob/audit/{jobId}
     * @secure
     */
    workflowJobAuditDetail: (jobId: number, params: RequestParams = {}) =>
      this.request<WorkflowJobAuditDataModel, void>({
        path: `/api/WorkflowJob/audit/${jobId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowJob
     * @name WorkflowJobCreate
     * @request POST:/api/WorkflowJob/{queueId}/{jobId}
     * @secure
     */
    workflowJobCreate: (queueId: number, jobId: number, data: WorkflowJobProcessModel, params: RequestParams = {}) =>
      this.request<WorkflowJobProcessResultModel, void>({
        path: `/api/WorkflowJob/${queueId}/${jobId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowJob
     * @name WorkflowJobEmailJobsCreate
     * @request POST:/api/WorkflowJob/emailJobs/{queueId}
     * @secure
     */
    workflowJobEmailJobsCreate: (queueId: number, data: WorkflowJobsEmailModel, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/WorkflowJob/emailJobs/${queueId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowJob
     * @name WorkflowJobTracingDetail
     * @request GET:/api/WorkflowJob/tracing/{jobId}
     * @secure
     */
    workflowJobTracingDetail: (jobId: number, params: RequestParams = {}) =>
      this.request<WorkflowJobTracingDataModel, void>({
        path: `/api/WorkflowJob/tracing/${jobId}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowJob
     * @name AutomotiveWorkflowJobDetail
     * @request GET:/api/automotive/WorkflowJob/{queueId}/{jobId}/{manufacturer}
     * @secure
     */
    automotiveWorkflowJobDetail: (queueId: number, jobId: number, manufacturer: string, params: RequestParams = {}) =>
      this.request<AutomotiveWorkflowJobModel, void>({
        path: `/api/automotive/WorkflowJob/${queueId}/${jobId}/${manufacturer}`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowJob
     * @name AutomotiveWorkflowJobCancelledDealCreate
     * @request POST:/api/automotive/WorkflowJob/{queueId}/{jobId}/cancelledDeal
     * @secure
     */
    automotiveWorkflowJobCancelledDealCreate: (queueId: number, jobId: number, data: CancelDealModel, params: RequestParams = {}) =>
      this.request<WorkflowJobProcessResultModel, void>({
        path: `/api/automotive/WorkflowJob/${queueId}/${jobId}/cancelledDeal`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowJob
     * @name AutomotiveWorkflowJobStockNumberDetail
     * @request GET:/api/automotive/WorkflowJob/{queueId}/{jobId}/stockNumber/{stockNumber}
     * @secure
     */
    automotiveWorkflowJobStockNumberDetail: (queueId: number, jobId: number, stockNumber: string, params: RequestParams = {}) =>
      this.request<StockNumberModel, void>({
        path: `/api/automotive/WorkflowJob/${queueId}/${jobId}/stockNumber/${stockNumber}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  workflowKanbanJob = {
    /**
     * No description
     *
     * @tags WorkflowKanbanJob
     * @name WorkflowKanbanJobUpdate
     * @request PUT:/api/WorkflowKanbanJob/{queueId}/{jobId}/{sourceLane}/{targetLane}
     * @secure
     */
    workflowKanbanJobUpdate: (queueId: number, jobId: number, sourceLane: string, targetLane: string, data: WorkflowKanbanJobMoveModel, params: RequestParams = {}) =>
      this.request<WorkflowKanbanJobProcessResultModel, void>({
        path: `/api/WorkflowKanbanJob/${queueId}/${jobId}/${sourceLane}/${targetLane}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowKanbanJob
     * @name WorkflowKanbanJobUpdate2
     * @request PUT:/api/WorkflowKanbanJob/{queueId}/{jobId}/{targetLane}
     * @originalName workflowKanbanJobUpdate
     * @duplicate
     * @secure
     */
    workflowKanbanJobUpdate2: (queueId: number, jobId: number, targetLane: string, data: WorkflowKanbanJobProcessModel, params: RequestParams = {}) =>
      this.request<WorkflowKanbanJobProcessResultModel, void>({
        path: `/api/WorkflowKanbanJob/${queueId}/${jobId}/${targetLane}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags WorkflowKanbanJob
     * @name WorkflowKanbanJobCardOrderUpdate
     * @request PUT:/api/WorkflowKanbanJob/{queueId}/{jobId}/cardOrder
     * @secure
     */
    workflowKanbanJobCardOrderUpdate: (queueId: number, jobId: number, data: WorkflowKanbanCardOrderUpdateModel, params: RequestParams = {}) =>
      this.request<WorkflowKanbanCardOrderResultModel, void>({
        path: `/api/WorkflowKanbanJob/${queueId}/${jobId}/cardOrder`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      })
  };
  workflowQueue = {
    /**
     * No description
     *
     * @tags WorkflowQueue
     * @name WorkflowQueueDetail
     * @request GET:/api/WorkflowQueue/{id}
     * @secure
     */
    workflowQueueDetail: ({ id, ...query }: WorkflowQueueDetailParams, params: RequestParams = {}) =>
      this.request<WorkflowQueueDataModel, void>({
        path: `/api/WorkflowQueue/${id}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      })
  };
  workflowTree = {
    /**
     * No description
     *
     * @tags WorkflowTree
     * @name WorkflowTreeList
     * @request GET:/api/WorkflowTree
     * @secure
     */
    workflowTreeList: (params: RequestParams = {}) =>
      this.request<WorkflowTreeNodeModel[], void>({
        path: `/api/WorkflowTree`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
  xPorterConfiguration = {
    /**
     * No description
     *
     * @tags XPorterConfiguration
     * @name XPorterConfigurationList
     * @request GET:/api/XPorterConfiguration
     * @secure
     */
    xPorterConfigurationList: (params: RequestParams = {}) =>
      this.request<XPorterSchool[], void>({
        path: `/api/XPorterConfiguration`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags XPorterConfiguration
     * @name XPorterConfigurationUpdate
     * @request PUT:/api/XPorterConfiguration
     * @secure
     */
    xPorterConfigurationUpdate: (data: XPorterSchool, params: RequestParams = {}) =>
      this.request<XPorterSchool[], void>({
        path: `/api/XPorterConfiguration`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags XPorterConfiguration
     * @name XPorterConfigurationCreate
     * @request POST:/api/XPorterConfiguration
     * @secure
     */
    xPorterConfigurationCreate: (data: XPorterSchool, params: RequestParams = {}) =>
      this.request<XPorterSchool[], void>({
        path: `/api/XPorterConfiguration`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags XPorterConfiguration
     * @name XPorterConfigurationDelete
     * @request DELETE:/api/XPorterConfiguration/{schoolId}
     * @secure
     */
    xPorterConfigurationDelete: (schoolId: number, params: RequestParams = {}) =>
      this.request<XPorterSchool[], void>({
        path: `/api/XPorterConfiguration/${schoolId}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags XPorterConfiguration
     * @name XPorterConfigurationTestDetail
     * @request GET:/api/XPorterConfiguration/test/{schoolId}
     * @secure
     */
    xPorterConfigurationTestDetail: (schoolId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/XPorterConfiguration/test/${schoolId}`,
        method: 'GET',
        secure: true,
        ...params
      })
  };
}
